import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AccountDoesNotMatchError = ErrorInterface & {
  __typename?: 'AccountDoesNotMatchError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type AccountPerformance = {
  __typename?: 'AccountPerformance';
  /** Calculated total portfolio Rate of Return, including rewards (scale 0-100) */
  moneyWeightedRor: Scalars['Float']['output'];
  performance: Array<Performance>;
};

export type AccountTask = {
  __typename?: 'AccountTask';
  currentCompletions: Scalars['Int']['output'];
  deepLink: Scalars['String']['output'];
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  instruction?: Maybe<Scalars['String']['output']>;
  targetCompletions: Scalars['Int']['output'];
};

export type AccountTaskList = {
  __typename?: 'AccountTaskList';
  accountTaskList: Scalars['String']['output'];
  accountTasks?: Maybe<Array<AccountTask>>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for AccountTaskList. */
export type AccountTaskListConnection = {
  __typename?: 'AccountTaskListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountTaskListEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AccountTaskList>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AccountTaskListEdge = {
  __typename?: 'AccountTaskListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AccountTaskList>;
};

export type AccountTypeError = ErrorInterface & {
  __typename?: 'AccountTypeError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export enum ActionChoiceEnum {
  /** Later */
  Later = 'LATER',
  /** No */
  No = 'NO',
  /** Yes */
  Yes = 'YES'
}

/** Active A/B test experiments for a user. */
export type ActiveExperiment = {
  __typename?: 'ActiveExperiment';
  /** Additional details about the variant */
  details?: Maybe<Scalars['JSON']['output']>;
  /** The name of the A/B test */
  testName: Scalars['String']['output'];
  /** The variant a user belongs to */
  variant?: Maybe<Scalars['String']['output']>;
};

export type AdAttributesInput = {
  htmlAd?: InputMaybe<HtmlAdInput>;
};

export enum AdMraidVersionEnum {
  /** mraid 2.0 */
  Mraid2 = 'MRAID2',
  /** mraid 3.0 */
  Mraid3 = 'MRAID3'
}

export enum AdSupportedSizeEnum {
  /** 3:4 */
  LandscapeInterstitial = 'LANDSCAPE_INTERSTITIAL',
  /** 4:3 */
  PortraitInterstitial = 'PORTRAIT_INTERSTITIAL'
}

export enum AdTypeEnum {
  HtmlAd = 'HTML_AD',
  NativeAd = 'NATIVE_AD',
  VastAd = 'VAST_AD'
}

export type AdUnion = HtmlAd | NativeAd;

/** The connection type for AdUnion. */
export type AdUnionConnection = {
  __typename?: 'AdUnionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AdUnionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AdUnion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AdUnionEdge = {
  __typename?: 'AdUnionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AdUnion>;
};

export type AddonInstrument = {
  __typename?: 'AddonInstrument';
  fundamentals: InstrumentFundamentals;
  inactive: Scalars['Boolean']['output'];
  labels: Array<InstrumentLabel>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  administrativeArea?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of Address */
export type AddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userAddress: UserAddress;
};

/** Autogenerated return type of Address */
export type AddressPayload = {
  __typename?: 'AddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type AddressVerificationError = ErrorInterface & {
  __typename?: 'AddressVerificationError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type AggregatedAddonInstrument = {
  __typename?: 'AggregatedAddonInstrument';
  addonInstrument: AddonInstrument;
  equityPosition?: Maybe<EquityPosition>;
  marketValue?: Maybe<Scalars['Float']['output']>;
  status: AggregatedAddonInstrumentStatusEnum;
  unrealizedDayPL?: Maybe<Scalars['Float']['output']>;
  unrealizedDayPLPercent?: Maybe<Scalars['Float']['output']>;
  unrealizedPL?: Maybe<Scalars['Float']['output']>;
  unrealizedPLPercent?: Maybe<Scalars['Float']['output']>;
};

export enum AggregatedAddonInstrumentStatusEnum {
  /** Owned */
  Owned = 'OWNED',
  /** Pending Buy */
  PendingBuy = 'PENDING_BUY',
  /** Pending Sell */
  PendingSell = 'PENDING_SELL'
}

export type AggregatedCorePortfolio = {
  __typename?: 'AggregatedCorePortfolio';
  equityPositions: Array<EquityPosition>;
  marketValue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  status: AggregatedCorePortfolioStatusEnum;
  unrealizedDayPL: Scalars['Float']['output'];
  unrealizedDayPLPercent: Scalars['Float']['output'];
  unrealizedPL: Scalars['Float']['output'];
  unrealizedPLPercent: Scalars['Float']['output'];
};

export enum AggregatedCorePortfolioStatusEnum {
  /** Owned */
  Owned = 'OWNED',
  /** Partial Owned */
  PartialOwned = 'PARTIAL_OWNED',
  /** Pending Buy */
  PendingBuy = 'PENDING_BUY'
}

/** Autogenerated input type of AnswerQuestion */
export type AnswerQuestionInput = {
  answers?: InputMaybe<Array<QuestionResponse>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  placementName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AnswerQuestion */
export type AnswerQuestionPayload = {
  __typename?: 'AnswerQuestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  nextAvailableDataContainer?: Maybe<QuestionContainer>;
  partnerBid?: Maybe<PartnerBid>;
};

export type AppSettings = {
  __typename?: 'AppSettings';
  accountStrengthCardHeaderCopy: Scalars['String']['output'];
  accountStrengthIncentiveCopy: Scalars['String']['output'];
  accountStrengthIncentiveRewardAmount: Scalars['Float']['output'];
  availableBalanceInfoCopy: Scalars['String']['output'];
  cashAdvanceAchTransferCopy: Scalars['String']['output'];
  cashAdvanceFirstMonthFee: Scalars['Float']['output'];
  cashAdvanceMaximumAmount: Scalars['Float']['output'];
  cashAdvanceMinimumAmount: Scalars['Float']['output'];
  cashAdvanceMinimumMonthlyIncome: Scalars['Int']['output'];
  cashAdvanceMonthlyFee: Scalars['Float']['output'];
  dataQuestionZeroStateCategoryId: Scalars['String']['output'];
  depositMaxLimit: Scalars['Int']['output'];
  depositMinLimit: Scalars['Int']['output'];
  identityVerificationLink?: Maybe<Scalars['String']['output']>;
  lifetimeEarningsInfoCopy: Scalars['String']['output'];
  locationCardHeaderSubtitle: Scalars['String']['output'];
  locationCardHeaderTitle: Scalars['String']['output'];
  locationPayoutAmount: Scalars['Float']['output'];
  pendingBalanceInfoCopy: Scalars['String']['output'];
  premiumSubscriptionPrice: Scalars['Float']['output'];
  rpCategoryPaginationAmount: Scalars['Int']['output'];
  rpHomeTagCopy: Scalars['String']['output'];
  rpSearchPlaceholderCopy: Scalars['String']['output'];
  searchZeroStateCategoryId: Scalars['String']['output'];
  sessionInactivityPeriod: Scalars['Int']['output'];
  tabapayRsaKey: Scalars['String']['output'];
  tabapayRsaKeyId: Scalars['String']['output'];
  tutorialHighlightedRpCategoryId: Scalars['String']['output'];
  tutorialHighlightedRpTagId: Scalars['String']['output'];
  unifiedLogin: Scalars['Boolean']['output'];
  unifiedLoginAndroid: Scalars['Boolean']['output'];
  withdrawalIncrement: Scalars['Float']['output'];
  withdrawalMaxLimit: Scalars['Int']['output'];
  withdrawalMinBalanceCopy: Scalars['String']['output'];
  withdrawalMinLimit: Scalars['Int']['output'];
};

/** Autogenerated input type of AssignAddon */
export type AssignAddonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  investmentAccountId: Scalars['ID']['input'];
  symbol: Scalars['String']['input'];
};

/** Autogenerated return type of AssignAddon */
export type AssignAddonPayload = {
  __typename?: 'AssignAddonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investmentAccount?: Maybe<InvestmentAccount>;
};

/** Autogenerated input type of AssignBankAccountToCashAdvanceApplication */
export type AssignBankAccountToCashAdvanceApplicationInput = {
  bankAccountId: Scalars['ID']['input'];
  cashAdvanceApplicationId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AssignBankAccountToCashAdvanceApplication */
export type AssignBankAccountToCashAdvanceApplicationPayload = {
  __typename?: 'AssignBankAccountToCashAdvanceApplicationPayload';
  cashAdvanceApplication?: Maybe<CashAdvanceApplication>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type AtmSubscriptionFee = Transaction & {
  __typename?: 'AtmSubscriptionFee';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type AtmSubscriptionFeePayment = Transaction & {
  __typename?: 'AtmSubscriptionFeePayment';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type AvailableFeatures = {
  __typename?: 'AvailableFeatures';
  cashAdvanceRequest: Scalars['Boolean']['output'];
  pfmAdditionalAccounts: Scalars['Boolean']['output'];
  pfmBase: Scalars['Boolean']['output'];
  pfmCustomCategories: Scalars['Boolean']['output'];
  pfmExports: Scalars['Boolean']['output'];
  pfmRefreshTransactions: Scalars['Boolean']['output'];
};

export type BadRequest = ErrorInterface & {
  __typename?: 'BadRequest';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type Balance = {
  __typename?: 'Balance';
  available?: Maybe<Scalars['String']['output']>;
  availableToWithdraw?: Maybe<Scalars['String']['output']>;
  cashTotal?: Maybe<Scalars['String']['output']>;
  cumulativeEarned?: Maybe<Scalars['String']['output']>;
  cumulativeEarnedPast30Days?: Maybe<Scalars['String']['output']>;
  pending?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['String']['output']>;
};

export type BankAccount = {
  __typename?: 'BankAccount';
  allowDeposit?: Maybe<Scalars['Boolean']['output']>;
  allowWithdrawal?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  displayAccountNumber?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  gatewayWithdrawalFee?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requireReauth?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<BankAccountStatusEnum>;
  transferMethod?: Maybe<Scalars['String']['output']>;
};

export enum BankAccountStatusEnum {
  /** Linked */
  Linked = 'LINKED',
  /** Pending Verification */
  PendingVerification = 'PENDING_VERIFICATION',
  /** Unlinked */
  Unlinked = 'UNLINKED',
  /** Unlinking */
  Unlinking = 'UNLINKING'
}

export type BankAccountTransaction = {
  __typename?: 'BankAccountTransaction';
  amount: Scalars['Float']['output'];
  bankAccountId: Scalars['ID']['output'];
  date: Scalars['ISO8601Date']['output'];
  deleted: Scalars['Boolean']['output'];
  detailedCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originalDescription?: Maybe<Scalars['String']['output']>;
  pending: Scalars['Boolean']['output'];
  primaryCategory?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export enum BankAccountTransactionSort {
  /** Amount Ascending */
  AmountAsc = 'AMOUNT_ASC',
  /** Amount Descending */
  AmountDesc = 'AMOUNT_DESC',
  /** Date Ascending */
  DateAsc = 'DATE_ASC',
  /** Date Descending */
  DateDesc = 'DATE_DESC'
}

export type BarData = {
  __typename?: 'BarData';
  close: Scalars['String']['output'];
  high: Scalars['String']['output'];
  low: Scalars['String']['output'];
  open: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  volume: Scalars['String']['output'];
};

export type BaseAd = {
  /** The specific type of ad. */
  adType: AdTypeEnum;
  id: Scalars['ID']['output'];
  /** The Served Impression ID that was served to the user. */
  servedImpressionId: Scalars['ID']['output'];
};

export type BasePartnerOffer = {
  /** The card description for an offer */
  cardDescription?: Maybe<Scalars['String']['output']>;
  /** The card headline for an offer */
  cardHeadline?: Maybe<Scalars['String']['output']>;
  /** The call to action of an offer */
  cta?: Maybe<Scalars['String']['output']>;
  /** The click url for a user offer */
  ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum;
  /** The click url for a user offer */
  ctaUrl?: Maybe<Scalars['String']['output']>;
  /** Details about an offer */
  description?: Maybe<Scalars['String']['output']>;
  /** Legal notice related an offer in Markdown syntax. Normally includes Terms and Conditions */
  disclosure?: Maybe<Scalars['String']['output']>;
  /**
   * The click url for a user offer
   * @deprecated Prefer cta_click_behavior instead
   */
  externalCtaUrl: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The response the user made for this offer */
  myResponse?: Maybe<UserPartnerBidResponse>;
  /** The type of offer */
  offerType: PartnerOfferTypeEnum;
  /** The partner for an offer */
  partner: Partner;
  /** The potential reward for this offer that can be earned. */
  potentialRewardTotal?: Maybe<PartnerOfferPotentialRewardTotal>;
  /** The savings amount for this offer */
  savingsAmount?: Maybe<Scalars['String']['output']>;
  /** The Served Impression ID that was served to the user. */
  servedImpressionId: Scalars['ID']['output'];
  /** Whether or not to skip the offer details page */
  skipOfferDetails: Scalars['Boolean']['output'];
  /** The url linking to the terms and conditions for an offer */
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BatchPublishClientEvents */
export type BatchPublishClientEventsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  events: Array<ClientEventInput>;
};

/** Autogenerated return type of BatchPublishClientEvents */
export type BatchPublishClientEventsPayload = {
  __typename?: 'BatchPublishClientEventsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ClientEventUnionErrors>>;
  /** The Request IDS that were successfully published */
  eventIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type Budget = {
  __typename?: 'Budget';
  amount: Scalars['Float']['output'];
  category: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  inactiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  month: Scalars['ISO8601Date']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type BudgetNotFoundError = ErrorInterface & {
  __typename?: 'BudgetNotFoundError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type Button = {
  __typename?: 'Button';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CvvVerificationError = ErrorInterface & {
  __typename?: 'CVVVerificationError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type CalibrateBudgetsErrors = Error | GenericCalibrationError;

/** Autogenerated input type of CalibrateBudgets */
export type CalibrateBudgetsInput = {
  clearCurrentMonth?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CalibrateBudgets */
export type CalibrateBudgetsPayload = {
  __typename?: 'CalibrateBudgetsPayload';
  budgets?: Maybe<Array<Budget>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CalibrateBudgetsErrors>>;
};

export type CardDeclinedError = ErrorInterface & {
  __typename?: 'CardDeclinedError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type CardHolderNameVerificationError = ErrorInterface & {
  __typename?: 'CardHolderNameVerificationError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type CashAdvance = Transaction & {
  __typename?: 'CashAdvance';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CashAdvanceApplication = {
  __typename?: 'CashAdvanceApplication';
  bankAccount?: Maybe<BankAccount>;
  id: Scalars['ID']['output'];
  rejectionDetails?: Maybe<Array<Scalars['String']['output']>>;
  status: CashAdvanceApplicationStatus;
};

export enum CashAdvanceApplicationStatus {
  /** The user has been approved for a cash advance, and a subscription has been created */
  Approved = 'APPROVED',
  /** The cash advance application has been cancelled. The user can re-apply */
  Cancelled = 'CANCELLED',
  /** The cash advance application has been cancelled, and the user is not allowed to reapply */
  CancelledNoReapply = 'CANCELLED_NO_REAPPLY',
  /** The cash advance application is in progress */
  InProgress = 'IN_PROGRESS',
  /** The user has been rejected for a cash advance. Details are available in the rejectionDetails field */
  Rejected = 'REJECTED',
  /** The user must repay an existing cash advance before applying for a new one */
  RepayOnly = 'REPAY_ONLY',
  /** The cash advance application has been submitted and is pending evaluation */
  Submitted = 'SUBMITTED'
}

export type CashAdvanceApprovedAmount = {
  __typename?: 'CashAdvanceApprovedAmount';
  amount?: Maybe<Scalars['String']['output']>;
  approvedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type CashAdvanceEvaluation = {
  __typename?: 'CashAdvanceEvaluation';
  allowedAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
};

export type CashAdvanceFee = {
  __typename?: 'CashAdvanceFee';
  amount: Scalars['String']['output'];
  feeType: CashAdvanceFeeType;
  id: Scalars['ID']['output'];
};

export type CashAdvanceFeeSchedule = {
  __typename?: 'CashAdvanceFeeSchedule';
  amount: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export enum CashAdvanceFeeType {
  /** Tip */
  Tip = 'TIP',
  /** Transfer fee */
  TransferFee = 'TRANSFER_FEE'
}

export type CashAdvanceRepayment = Transaction & {
  __typename?: 'CashAdvanceRepayment';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CashAdvanceRequest = {
  __typename?: 'CashAdvanceRequest';
  amount: Scalars['String']['output'];
  amountNeededToRepay?: Maybe<Scalars['String']['output']>;
  /** The date the cash advance is expected to be repaid. Only nullable for quotes */
  expectedRepaymentDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fees: Array<CashAdvanceFee>;
  id: Scalars['ID']['output'];
  repaymentAmount: Scalars['String']['output'];
  status: CashAdvanceRequestStatus;
  transferType: CashAdvanceRequestTransferType;
};

export enum CashAdvanceRequestStatus {
  /** Approved */
  Approved = 'APPROVED',
  /** Charge Back */
  ChargeBack = 'CHARGE_BACK',
  /** Failed */
  Failed = 'FAILED',
  /** Pending */
  Pending = 'PENDING',
  /** Quote */
  Quote = 'QUOTE',
  /** Completed */
  Rejected = 'REJECTED',
  /** Repaid */
  Repaid = 'REPAID',
  /** Repayment Submitted */
  RepaymentSubmittedToFinsys = 'REPAYMENT_SUBMITTED_TO_FINSYS',
  /** Settled */
  Settled = 'SETTLED',
  /** Submitted */
  SubmittedToFinsys = 'SUBMITTED_TO_FINSYS'
}

export enum CashAdvanceRequestTransferType {
  /** ACH transfer. 3-5 Business days */
  Ach = 'ACH',
  /** Instant transfer. Within minutes */
  Asap = 'ASAP'
}

export type CashAdvanceSubscription = {
  __typename?: 'CashAdvanceSubscription';
  activeAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  initialFeeChargedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nextFeeChargedAt: Scalars['ISO8601DateTime']['output'];
  status: CashAdvanceSubscriptionStatus;
};

export enum CashAdvanceSubscriptionStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Inactive */
  Inactive = 'INACTIVE',
  /** Past Due */
  PastDue = 'PAST_DUE',
  /** Trial */
  Trial = 'TRIAL'
}

export type CashAdvanceTip = Transaction & {
  __typename?: 'CashAdvanceTip';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CashAdvanceTransferFee = Transaction & {
  __typename?: 'CashAdvanceTransferFee';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Category = {
  __typename?: 'Category';
  name: Scalars['String']['output'];
};

export enum CategoryDetailDisplayStyleEnum {
  /** This is the featured style */
  Banner = 'BANNER',
  /** Card with gradient background overlay */
  BannerCardGradient = 'BANNER_CARD_GRADIENT',
  /** Card with gradient background overlay oriented vertically */
  BannerCardGradientVertical = 'BANNER_CARD_GRADIENT_VERTICAL',
  /** Card with split background */
  BannerCardSplit = 'BANNER_CARD_SPLIT',
  /** Card with split background oriented vertically */
  BannerCardSplitVertical = 'BANNER_CARD_SPLIT_VERTICAL',
  /** This is the larger featured style */
  BannerLarge = 'BANNER_LARGE',
  /** This is the larger featured style oriented vertically */
  BannerLargeVertical = 'BANNER_LARGE_VERTICAL',
  /** The basic tile style with a clear background */
  BasicClear = 'BASIC_CLEAR',
  /** The wide basic tile style with a clear background */
  BasicClearLarge = 'BASIC_CLEAR_LARGE',
  /** The wide basic tile style with a clear background oriented vertically */
  BasicClearLargeVertical = 'BASIC_CLEAR_LARGE_VERTICAL',
  /** The semi-wide basic tile style with a clear background double stacked */
  BasicClearMediumDouble = 'BASIC_CLEAR_MEDIUM_DOUBLE',
  /** The semi-wide basic tile style with a clear background triple stacked */
  BasicClearMediumTriple = 'BASIC_CLEAR_MEDIUM_TRIPLE',
  /** The semi-wide basic tile style with a clear background */
  BasicClearMeium = 'BASIC_CLEAR_MEIUM',
  /** The basic tile style with a white background */
  BasicWhite = 'BASIC_WHITE',
  /** Grid style which is the existing way to dispaly Your Offers */
  Grid = 'GRID'
}

export enum CategoryFeaturedDisplayStyleEnum {
  /** This is the featured style */
  Banner = 'BANNER',
  /** Card with gradient background overlay */
  BannerCardGradient = 'BANNER_CARD_GRADIENT',
  /** Card with gradient background overlay oriented vertically */
  BannerCardGradientVertical = 'BANNER_CARD_GRADIENT_VERTICAL',
  /** Card with split background */
  BannerCardSplit = 'BANNER_CARD_SPLIT',
  /** Card with split background oriented vertically */
  BannerCardSplitVertical = 'BANNER_CARD_SPLIT_VERTICAL',
  /** This is the larger featured style */
  BannerLarge = 'BANNER_LARGE',
  /** This is the larger featured style oriented vertically */
  BannerLargeVertical = 'BANNER_LARGE_VERTICAL',
  /** The basic tile style with a clear background */
  BasicClear = 'BASIC_CLEAR',
  /** The wide basic tile style with a clear background */
  BasicClearLarge = 'BASIC_CLEAR_LARGE',
  /** The wide basic tile style with a clear background oriented vertically */
  BasicClearLargeVertical = 'BASIC_CLEAR_LARGE_VERTICAL',
  /** The semi-wide basic tile style with a clear background double stacked */
  BasicClearMediumDouble = 'BASIC_CLEAR_MEDIUM_DOUBLE',
  /** The semi-wide basic tile style with a clear background triple stacked */
  BasicClearMediumTriple = 'BASIC_CLEAR_MEDIUM_TRIPLE',
  /** The semi-wide basic tile style with a clear background */
  BasicClearMeium = 'BASIC_CLEAR_MEIUM',
  /** The basic tile style with a white background */
  BasicWhite = 'BASIC_WHITE',
  /** Grid style which is the existing way to dispaly Your Offers */
  Grid = 'GRID'
}

export enum CategoryMainDisplayStyleEnum {
  /** This is the featured style */
  Banner = 'BANNER',
  /** Card with gradient background overlay */
  BannerCardGradient = 'BANNER_CARD_GRADIENT',
  /** Card with gradient background overlay oriented vertically */
  BannerCardGradientVertical = 'BANNER_CARD_GRADIENT_VERTICAL',
  /** Card with split background */
  BannerCardSplit = 'BANNER_CARD_SPLIT',
  /** Card with split background oriented vertically */
  BannerCardSplitVertical = 'BANNER_CARD_SPLIT_VERTICAL',
  /** This is the larger featured style */
  BannerLarge = 'BANNER_LARGE',
  /** This is the larger featured style oriented vertically */
  BannerLargeVertical = 'BANNER_LARGE_VERTICAL',
  /** The basic tile style with a clear background */
  BasicClear = 'BASIC_CLEAR',
  /** The wide basic tile style with a clear background */
  BasicClearLarge = 'BASIC_CLEAR_LARGE',
  /** The wide basic tile style with a clear background oriented vertically */
  BasicClearLargeVertical = 'BASIC_CLEAR_LARGE_VERTICAL',
  /** The semi-wide basic tile style with a clear background double stacked */
  BasicClearMediumDouble = 'BASIC_CLEAR_MEDIUM_DOUBLE',
  /** The semi-wide basic tile style with a clear background triple stacked */
  BasicClearMediumTriple = 'BASIC_CLEAR_MEDIUM_TRIPLE',
  /** The semi-wide basic tile style with a clear background */
  BasicClearMeium = 'BASIC_CLEAR_MEIUM',
  /** The basic tile style with a white background */
  BasicWhite = 'BASIC_WHITE',
  /** Grid style which is the existing way to dispaly Your Offers */
  Grid = 'GRID'
}

export type ChatUser = {
  __typename?: 'ChatUser';
  identity?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type ClientEvent = {
  __typename?: 'ClientEvent';
  data?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  partnerId?: Maybe<Scalars['ID']['output']>;
  partnerOfferId?: Maybe<Scalars['ID']['output']>;
  requestId: Scalars['ID']['output'];
  servedImpressionId?: Maybe<Scalars['ID']['output']>;
};

export type ClientEventError = {
  __typename?: 'ClientEventError';
  errors?: Maybe<Array<Error>>;
  event: ClientEvent;
};

export type ClientEventInput = {
  adId?: InputMaybe<Scalars['ID']['input']>;
  adType?: InputMaybe<AdTypeEnum>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  partnerOfferId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the request */
  requestId: Scalars['ID']['input'];
  servedImpressionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ClientEventUnionErrors = ClientEventError | Error;

export enum ClientPlatformEnum {
  /** android */
  Android = 'ANDROID',
  /** iOS */
  Ios = 'IOS'
}

export type CommonError = ErrorInterface & {
  __typename?: 'CommonError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export enum CompressionEnum {
  /** Daily */
  Daily = 'daily',
  /** 5 minutes */
  FiveMinutes = 'five_minutes',
  /** 1 hour */
  OneHour = 'one_hour',
  /** 1 minute */
  OneMinute = 'one_minute',
  /** 30 minutes */
  ThirtyMinutes = 'thirty_minutes',
  /** Weekly */
  Weekly = 'weekly'
}

/** Autogenerated input type of ConfirmEmail */
export type ConfirmEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confirmationToken: Scalars['String']['input'];
};

/** Autogenerated return type of ConfirmEmail */
export type ConfirmEmailPayload = {
  __typename?: 'ConfirmEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ConfirmPhone */
export type ConfirmPhoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confirmationToken: Scalars['String']['input'];
};

/** Autogenerated return type of ConfirmPhone */
export type ConfirmPhonePayload = {
  __typename?: 'ConfirmPhonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type Conflict = ErrorInterface & {
  __typename?: 'Conflict';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCashAdvanceApplication */
export type CreateCashAdvanceApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCashAdvanceApplication */
export type CreateCashAdvanceApplicationPayload = {
  __typename?: 'CreateCashAdvanceApplicationPayload';
  cashAdvanceApplication?: Maybe<CashAdvanceApplication>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CreateCashAdvanceRequest */
export type CreateCashAdvanceRequestInput = {
  amount: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tipAmount?: InputMaybe<Scalars['String']['input']>;
  transferType: CashAdvanceRequestTransferType;
};

/** Autogenerated return type of CreateCashAdvanceRequest */
export type CreateCashAdvanceRequestPayload = {
  __typename?: 'CreateCashAdvanceRequestPayload';
  cashAdvanceRequest?: Maybe<CashAdvanceRequest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CreateChatToken */
export type CreateChatTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateChatToken */
export type CreateChatTokenPayload = {
  __typename?: 'CreateChatTokenPayload';
  chatUser?: Maybe<ChatUser>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type CreateClosureRequestAlreadyClosingError = ErrorInterface & {
  __typename?: 'CreateClosureRequestAlreadyClosingError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type CreateClosureRequestCashAdvanceRequestNotRepaidError = ErrorInterface & {
  __typename?: 'CreateClosureRequestCashAdvanceRequestNotRepaidError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type CreateClosureRequestError = CreateClosureRequestAlreadyClosingError | CreateClosureRequestCashAdvanceRequestNotRepaidError | CreateClosureRequestUnableToRetrieveAchAccountNumberError | Error;

/** Autogenerated input type of CreateClosureRequest */
export type CreateClosureRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateClosureRequest */
export type CreateClosureRequestPayload = {
  __typename?: 'CreateClosureRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateClosureRequestError>>;
  success: Scalars['Boolean']['output'];
};

export type CreateClosureRequestUnableToRetrieveAchAccountNumberError = ErrorInterface & {
  __typename?: 'CreateClosureRequestUnableToRetrieveACHAccountNumberError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCtaClickUrl */
export type CreateCtaClickUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partnerOfferId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCtaClickUrl */
export type CreateCtaClickUrlPayload = {
  __typename?: 'CreateCtaClickUrlPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateLinkToken */
export type CreateLinkTokenPayload = {
  __typename?: 'CreateLinkTokenPayload';
  errors?: Maybe<Array<Error>>;
  linkToken?: Maybe<PlaidLinkToken>;
};

/** Autogenerated input type of CreateOnetimeDeposit */
export type CreateOnetimeDepositInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  request: OnetimeDeposit;
};

/** Autogenerated return type of CreateOnetimeDeposit */
export type CreateOnetimeDepositPayload = {
  __typename?: 'CreateOnetimeDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  transaction?: Maybe<UserOnetimeDeposit>;
};

export type CreatePaymentAccountError = AccountTypeError | AddressVerificationError | BadRequest | CvvVerificationError | CardDeclinedError | CardHolderNameVerificationError | CommonError | Conflict | Error | InvalidAddressError | InvalidCardNumberError | InvalidExpirationDateError | PaymentAccountLinkedOverLimitError | RateLimitExceeded;

/** Autogenerated input type of CreatePaymentAccount */
export type CreatePaymentAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tabaPayCard: TabaPayCard;
};

/** Autogenerated return type of CreatePaymentAccount */
export type CreatePaymentAccountPayload = {
  __typename?: 'CreatePaymentAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreatePaymentAccountError>>;
  paymentAccount?: Maybe<BankAccount>;
};

export type CreateSubscriptionError = Error | ExistingSubscriptionError | NoLinkedCardError | NotSupportedSubscriptionProductError;

/** Autogenerated input type of CreateSubscription */
export type CreateSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  productKey: SubscriptionProductEnum;
};

/** Autogenerated return type of CreateSubscription */
export type CreateSubscriptionPayload = {
  __typename?: 'CreateSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateSubscriptionError>>;
  subscription?: Maybe<Subscription>;
};

/** Autogenerated input type of CreateUpdateLinkToken */
export type CreateUpdateLinkTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateUpdateLinkToken */
export type CreateUpdateLinkTokenPayload = {
  __typename?: 'CreateUpdateLinkTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  linkToken?: Maybe<PlaidLinkToken>;
};

/** Autogenerated input type of CreateUserFeatureOptIn */
export type CreateUserFeatureOptInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feature: Scalars['String']['input'];
  optedIn?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateUserFeatureOptIn */
export type CreateUserFeatureOptInPayload = {
  __typename?: 'CreateUserFeatureOptInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  userFeatureOptIn?: Maybe<UserFeatureOptIn>;
};

/** Autogenerated input type of CreateUser */
export type CreateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Phone;
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateUser */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ErrorInterface>>;
  user: User;
};

/** Input Type for creating a recurring deposit */
export type CreateUserRecurringDeposit = {
  amount: Scalars['String']['input'];
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  depositInterval: DepositIntervalEnum;
};

/** Autogenerated input type of CreateUserRecurringDeposit */
export type CreateUserRecurringDepositInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  recurringDeposit: CreateUserRecurringDeposit;
};

/** Autogenerated return type of CreateUserRecurringDeposit */
export type CreateUserRecurringDepositPayload = {
  __typename?: 'CreateUserRecurringDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userRecurringDeposit?: Maybe<UserRecurringDepositConfiguration>;
};

/** Autogenerated input type of CreateWithdrawal */
export type CreateWithdrawalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  request: WithdrawalRequest;
};

/** Autogenerated return type of CreateWithdrawal */
export type CreateWithdrawalPayload = {
  __typename?: 'CreateWithdrawalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  transaction?: Maybe<Withdrawal>;
};

export type DataDividend = Transaction & {
  __typename?: 'DataDividend';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Deal = BasePartnerOffer & WithTimestamps & {
  __typename?: 'Deal';
  /** The card description for an offer */
  cardDescription?: Maybe<Scalars['String']['output']>;
  /** The card headline for an offer */
  cardHeadline?: Maybe<Scalars['String']['output']>;
  /** When the offer was completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The call to action of an offer */
  cta?: Maybe<Scalars['String']['output']>;
  /** The click url for a user offer */
  ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum;
  /** The click url for a user offer */
  ctaUrl?: Maybe<Scalars['String']['output']>;
  /** Details about an offer */
  description?: Maybe<Scalars['String']['output']>;
  /** Legal notice related an offer in Markdown syntax. Normally includes Terms and Conditions */
  disclosure?: Maybe<Scalars['String']['output']>;
  expectedRewardTimeline?: Maybe<Scalars['String']['output']>;
  /**
   * The click url for a user offer
   * @deprecated Prefer cta_click_behavior instead
   */
  externalCtaUrl: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  myMonetizedProgress?: Maybe<MonetizedProgressConnection>;
  myProgress: PartnerOfferProgressConnection;
  /** The response the user made for this offer */
  myResponse?: Maybe<UserPartnerBidResponse>;
  /** Transactions for the current user related to this offer */
  myTransactions?: Maybe<TransactionConnection>;
  /** The type of offer */
  offerType: PartnerOfferTypeEnum;
  /** The partner for an offer */
  partner: Partner;
  /** The potential reward for this offer that can be earned. */
  potentialRewardTotal?: Maybe<PartnerOfferPotentialRewardTotal>;
  /** The savings amount for this offer */
  savingsAmount?: Maybe<Scalars['String']['output']>;
  /** The Served Impression ID that was served to the user. */
  servedImpressionId: Scalars['ID']['output'];
  /** Whether or not to skip the offer details page */
  skipOfferDetails: Scalars['Boolean']['output'];
  /** The url linking to the terms and conditions for an offer */
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type DealMyMonetizedProgressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DealMyProgressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DealMyTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of DeleteUserRecurringDeposit */
export type DeleteUserRecurringDepositInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteUserRecurringDeposit */
export type DeleteUserRecurringDepositPayload = {
  __typename?: 'DeleteUserRecurringDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userRecurringDeposit?: Maybe<UserRecurringDepositConfiguration>;
};

export enum DepositIntervalEnum {
  /** A monthly deposit interval */
  Monthly = 'MONTHLY',
  /** A weekly deposit interval */
  Weekly = 'WEEKLY'
}

export type DeviceIntegrity = {
  __typename?: 'DeviceIntegrity';
  challengeNonce: Scalars['String']['output'];
  verifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum EmploymentStatusEnum {
  /** Employed */
  Employed = 'EMPLOYED',
  /** Retired */
  Retired = 'RETIRED',
  /** Self Employed / Business Owner */
  SelfEmployed = 'SELF_EMPLOYED',
  /** Student */
  Student = 'STUDENT',
  /** Not Employed */
  Unemployed = 'UNEMPLOYED'
}

export type EquityPosition = {
  __typename?: 'EquityPosition';
  availableForTradingQty: Scalars['Float']['output'];
  avgPrice: Scalars['Float']['output'];
  marketValue: Scalars['Float']['output'];
  mktPrice: Scalars['Float']['output'];
  openQty: Scalars['Float']['output'];
  priorClose: Scalars['Float']['output'];
  side: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  unrealizedDayPL: Scalars['Float']['output'];
  unrealizedDayPLPercent: Scalars['Float']['output'];
  unrealizedPL: Scalars['Float']['output'];
};

export type Error = ErrorInterface & {
  __typename?: 'Error';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type ErrorInterface = {
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type EvaluationAlreadyRunError = ErrorInterface & {
  __typename?: 'EvaluationAlreadyRunError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type ExistingSubscriptionError = ErrorInterface & {
  __typename?: 'ExistingSubscriptionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of FavoritePartner */
export type FavoritePartnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['ID']['input'];
};

/** Autogenerated return type of FavoritePartner */
export type FavoritePartnerPayload = {
  __typename?: 'FavoritePartnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** Indicates if the partner was successfully favorited. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of ForgotPassword */
export type ForgotPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Phone>;
};

export type GenericBudgetError = ErrorInterface & {
  __typename?: 'GenericBudgetError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type GenericCalibrationError = ErrorInterface & {
  __typename?: 'GenericCalibrationError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type GenericError = ErrorInterface & {
  __typename?: 'GenericError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type HtmlAd = BaseAd & WithTimestamps & {
  __typename?: 'HtmlAd';
  /** The specific type of ad. */
  adType: AdTypeEnum;
  /** The HTML content or an error response. */
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The Served Impression ID that was served to the user. */
  servedImpressionId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type HtmlAdInput = {
  /** Which versions of mraid the ad supports */
  supportedMraidVersions?: InputMaybe<Array<AdMraidVersionEnum>>;
  /** The supported sizes for the ad */
  supportedSizes: Array<AdSupportedSizeEnum>;
};

export type InactivityFeeDisplay = Transaction & {
  __typename?: 'InactivityFeeDisplay';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** ISO 3166-2 formatted administrative area (division such as state or provence) */
export type InputAdministrativeArea = Question & {
  __typename?: 'InputAdministrativeArea';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputBoolean = Question & {
  __typename?: 'InputBoolean';
  createdAt: Scalars['String']['output'];
  falseOptionLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  trueOptionLabel?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputButtonSelection = Question & {
  __typename?: 'InputButtonSelection';
  buttons: Array<Button>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  multiple: Scalars['Boolean']['output'];
  rank: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputCurrency = Question & {
  __typename?: 'InputCurrency';
  createdAt: Scalars['String']['output'];
  /** @deprecated no longer supported */
  currencyCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputDate = Question & {
  __typename?: 'InputDate';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputGroup = Question & {
  __typename?: 'InputGroup';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  questions?: Maybe<Array<Question>>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputListSelection = Question & {
  __typename?: 'InputListSelection';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  options: Array<Option>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputNumber = Question & {
  __typename?: 'InputNumber';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

/** postal code input type */
export type InputPostalCode = Question & {
  __typename?: 'InputPostalCode';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputStyledButtonSelection = Question & {
  __typename?: 'InputStyledButtonSelection';
  buttons: Array<StyledButton>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  multiple: Scalars['Boolean']['output'];
  rank: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InputText = Question & {
  __typename?: 'InputText';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type InstrumentFundamentals = {
  __typename?: 'InstrumentFundamentals';
  askPrice: Scalars['Float']['output'];
  bidPrice: Scalars['Float']['output'];
  bookValuePerShare?: Maybe<Scalars['Float']['output']>;
  cashFlowPerShare?: Maybe<Scalars['Float']['output']>;
  close?: Maybe<Scalars['Float']['output']>;
  closePrior?: Maybe<Scalars['Float']['output']>;
  cumulativeVolume?: Maybe<Scalars['Float']['output']>;
  description: Scalars['String']['output'];
  dividend?: Maybe<Scalars['Float']['output']>;
  dividendYield?: Maybe<Scalars['Float']['output']>;
  earningsPerShare?: Maybe<Scalars['Float']['output']>;
  fiftyTwoWeekHighPrice?: Maybe<Scalars['Float']['output']>;
  fiftyTwoWeekLowPrice?: Maybe<Scalars['Float']['output']>;
  highPrice: Scalars['Float']['output'];
  lowPrice: Scalars['Float']['output'];
  marketCap?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  openPrice: Scalars['Float']['output'];
  operatingIncome?: Maybe<Scalars['Float']['output']>;
  pbRatio?: Maybe<Scalars['Float']['output']>;
  peRatio?: Maybe<Scalars['Float']['output']>;
  priceMovingAverage50Day?: Maybe<Scalars['Float']['output']>;
  priceMovingAverage150Day?: Maybe<Scalars['Float']['output']>;
  priceMovingAverage200Day?: Maybe<Scalars['Float']['output']>;
  roe?: Maybe<Scalars['Float']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  sharesOutstanding?: Maybe<Scalars['Float']['output']>;
  symbol: Scalars['String']['output'];
  volumeMovingAverage10Day?: Maybe<Scalars['Float']['output']>;
  volumeMovingAverage25Day?: Maybe<Scalars['Float']['output']>;
  volumeMovingAverage50Day?: Maybe<Scalars['Float']['output']>;
};

export type InstrumentLabel = {
  __typename?: 'InstrumentLabel';
  emoji: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type InternalNativeCreativeLayout = {
  __typename?: 'InternalNativeCreativeLayout';
  height?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type InvalidAddressError = ErrorInterface & {
  __typename?: 'InvalidAddressError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type InvalidCardNumberError = ErrorInterface & {
  __typename?: 'InvalidCardNumberError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type InvalidExpirationDateError = ErrorInterface & {
  __typename?: 'InvalidExpirationDateError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type InvalidSubscriptionTransitionError = ErrorInterface & {
  __typename?: 'InvalidSubscriptionTransitionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type InvalidUserAttributionError = ErrorInterface & {
  __typename?: 'InvalidUserAttributionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type InvestmentAccount = {
  __typename?: 'InvestmentAccount';
  aggregated?: Maybe<InvestmentAccountAggregated>;
  id: Scalars['ID']['output'];
  portfolio: Portfolio;
  provisioningCompletedAt?: Maybe<Scalars['String']['output']>;
  provisioningInitiatedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<InvestmentAccountStatusEnum>;
};

export type InvestmentAccountAggregated = {
  __typename?: 'InvestmentAccountAggregated';
  aggregatedAddonInstruments: Array<AggregatedAddonInstrument>;
  aggregatedCorePortfolio: AggregatedCorePortfolio;
};

export enum InvestmentAccountStatusEnum {
  /** Closed */
  Closed = 'closed',
  /** Failed KYC */
  FailedKyc = 'failed_kyc',
  /** Failed Provisioning */
  FailedProvisioning = 'failed_provisioning',
  /** Open */
  Open = 'open',
  /** Open, No Trades */
  OpenNoTrades = 'open_no_trades',
  /** Pending Close */
  PendingClose = 'pending_close',
  /** Provisioning */
  Provisioning = 'provisioning'
}

export type InvestmentApplicationInput = {
  broker?: InputMaybe<Scalars['Boolean']['input']>;
  citizenshipCountry?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  directorOf?: InputMaybe<Scalars['String']['input']>;
  employmentStatus: EmploymentStatusEnum;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  politicallyExposedNames?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentDeposit = Transaction & {
  __typename?: 'InvestmentDeposit';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type InvestmentWithdrawal = Transaction & {
  __typename?: 'InvestmentWithdrawal';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  entries: Array<LeaderboardEntry>;
  period: LeaderboardPeriodEnum;
  /** Total number of users in the leaderboard */
  totalUsers: Scalars['Int']['output'];
  type: LeaderboardTypeEnum;
  /** Current user's reward amount in the leaderboard */
  userAmount?: Maybe<Scalars['Float']['output']>;
  /** Current user's rank in the leaderboard */
  userRank?: Maybe<Scalars['Int']['output']>;
};

export type LeaderboardEntry = {
  __typename?: 'LeaderboardEntry';
  /** The reward amount earned by the user */
  amount: Scalars['Float']['output'];
  rank: Scalars['Int']['output'];
  user: LeaderboardUserUnion;
};

/** Time periods for reward leaderboards */
export enum LeaderboardPeriodEnum {
  /** Daily leaderboard */
  Daily = 'DAILY',
  /** Monthly leaderboard */
  Monthly = 'MONTHLY',
  /** Weekly leaderboard */
  Weekly = 'WEEKLY'
}

/** Types of reward leaderboards */
export enum LeaderboardTypeEnum {
  /** Data rewards leaderboard */
  DataReward = 'DATA_REWARD',
  /** Gaming rewards leaderboard */
  Gaming = 'GAMING',
  /** Overall rewards leaderboard */
  Overall = 'OVERALL',
  /** Partner rewards leaderboard */
  PartnerReward = 'PARTNER_REWARD',
  /** Referral rewards leaderboard */
  ReferralReward = 'REFERRAL_REWARD',
  /** Survey rewards leaderboard */
  Survey = 'SURVEY'
}

export type LeaderboardUserUnion = OtherUser | User;

/** Autogenerated input type of LinkAccount */
export type LinkAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  provider: Provider;
};

/** Autogenerated return type of LinkAccount */
export type LinkAccountPayload = {
  __typename?: 'LinkAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  monitoredBankAccounts?: Maybe<Array<MonitoredBankAccount>>;
};

export enum LinkAccountTypeEnum {
  /** Monitored account */
  Monitored = 'monitored',
  /** Payment account */
  Payment = 'payment'
}

/** Autogenerated input type of LinkBankAccount */
export type LinkBankAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  provider: Provider;
};

/** Autogenerated return type of LinkBankAccount */
export type LinkBankAccountPayload = {
  __typename?: 'LinkBankAccountPayload';
  bankAccount?: Maybe<BankAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  storeNumber?: Maybe<Scalars['String']['output']>;
};

export type MarketStatus = {
  __typename?: 'MarketStatus';
  isOpen: Scalars['Boolean']['output'];
};

export type MonetizedProgress = {
  __typename?: 'MonetizedProgress';
  /** The time the event was completed at */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The max amount of times this event can be completed */
  maxCompletionTimes: Scalars['Int']['output'];
  /** The amount that can be earned for this event */
  rewardAmount: Scalars['String']['output'];
  /** The description to be used for displaying purposes */
  rewardCriteriaDescription: Scalars['String']['output'];
  /** The type of reward that can be earned for this event */
  rewardType: PartnerRewardTypeEnum;
  /** The status of the progress the current node is in. */
  status: MonetizedProgressStatusEnum;
  /** The amount of times this event has been completed */
  timesCompleted: Scalars['Int']['output'];
};

/** The connection type for MonetizedProgress. */
export type MonetizedProgressConnection = {
  __typename?: 'MonetizedProgressConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MonetizedProgressEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MonetizedProgress>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MonetizedProgressEdge = {
  __typename?: 'MonetizedProgressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MonetizedProgress>;
};

export enum MonetizedProgressStatusEnum {
  Completed = 'COMPLETED',
  Incomplete = 'INCOMPLETE',
  InProgress = 'IN_PROGRESS'
}

export type MonitoredBankAccount = {
  __typename?: 'MonitoredBankAccount';
  balance?: Maybe<Scalars['Float']['output']>;
  balanceLastUpdatedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  createdAt: Scalars['ISO8601Date']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  displayAccountNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requireReauth?: Maybe<Scalars['Boolean']['output']>;
  subtype?: Maybe<MonitoredBankAccountSubtypeEnum>;
  type?: Maybe<MonitoredBankAccountTypeEnum>;
};

export enum MonitoredBankAccountSubtypeEnum {
  /** Auto loan */
  Auto = 'AUTO',
  /** Standard brokerage account */
  Brokerage = 'BROKERAGE',
  /** Business loan */
  Business = 'BUSINESS',
  /** Individual Savings Account (ISA) that pays interest tax-free (UK) */
  CashIsa = 'CASH_ISA',
  /** A cash management account, typically a cash account at a brokerage */
  CashManagement = 'CASH_MANAGEMENT',
  /** Certificate of deposit account */
  Cd = 'CD',
  /** Checking account */
  Checking = 'CHECKING',
  /** Commercial loan */
  Commercial = 'COMMERCIAL',
  /** Construction loan */
  Construction = 'CONSTRUCTION',
  /** Consumer loan */
  Consumer = 'CONSUMER',
  /** Bank-issued credit card */
  CreditCard = 'CREDIT_CARD',
  /** Standard cryptocurrency exchange account */
  CryptoExchange = 'CRYPTO_EXCHANGE',
  /** An Electronic Benefit Transfer (EBT) account, used by certain public assistance programs to distribute funds (US only) */
  Ebt = 'EBT',
  /** Tax-advantaged Coverdell Education Savings Account (ESA) (US) */
  EducationSavingsAccount = 'EDUCATION_SAVINGS_ACCOUNT',
  /** Fixed annuity */
  FixedAnnuity = 'FIXED_ANNUITY',
  /** Guaranteed Investment Certificate (Canada) */
  Gic = 'GIC',
  /** Tax-advantaged Health Reimbursement Arrangement (HRA) benefit plan (US) */
  HealthReimbursementArrangement = 'HEALTH_REIMBURSEMENT_ARRANGEMENT',
  /** Home Equity Line of Credit (HELOC) */
  HomeEquity = 'HOME_EQUITY',
  /** Health Savings Account */
  Hsa = 'HSA',
  /** Traditional Individual Retirement Account (IRA) (US) */
  Ira = 'IRA',
  /** Non-cash Individual Savings Account (ISA) (UK) */
  Isa = 'ISA',
  /** Employer-sponsored money-purchase 401(a) retirement plan (US) */
  I_401A = 'I_401A',
  /** Standard 401(k) retirement account (US) */
  I_401K = 'I_401K',
  /** 403(b) retirement savings account for non-profits and schools (US) */
  I_403B = 'I_403B',
  /** Tax-advantaged deferred-compensation 457(b) retirement plan for governments and non-profits (US) */
  I_457B = 'I_457B',
  /** Tax-advantaged college savings and prepaid tuition 529 plans (US) */
  I_529 = 'I_529',
  /** Keogh self-employed retirement plan (US) */
  Keogh = 'KEOGH',
  /** Life Income Fund (LIF) retirement account (Canada) */
  Lif = 'LIF',
  /** Life insurance account */
  LifeInsurance = 'LIFE_INSURANCE',
  /** Pre-approved line of credit */
  LineOfCredit = 'LINE_OF_CREDIT',
  /** Locked-in Retirement Account (LIRA) (Canada) */
  Lira = 'LIRA',
  /** General loan */
  Loan = 'LOAN',
  /** Locked-in Retirement Income Fund (LRIF) (Canada) */
  Lrif = 'LRIF',
  /** Locked-in Retirement Savings Plan (Canada) */
  Lrsp = 'LRSP',
  /** Money market account */
  MoneyMarket = 'MONEY_MARKET',
  /** Mortgage loan */
  Mortgage = 'MORTGAGE',
  /** Mutual fund account */
  MutualFund = 'MUTUAL_FUND',
  /** A cryptocurrency wallet where the user controls the private key */
  NonCustodialWallet = 'NON_CUSTODIAL_WALLET',
  /** A non-taxable brokerage account that is not covered by a more specific subtype */
  NonTaxableBrokerageAccount = 'NON_TAXABLE_BROKERAGE_ACCOUNT',
  /** Other or unknown account type */
  Other = 'OTHER',
  /** An annuity account not covered by other subtypes */
  OtherAnnuity = 'OTHER_ANNUITY',
  /** An insurance account not covered by other subtypes */
  OtherInsurance = 'OTHER_INSURANCE',
  /** Pre-approved overdraft account, usually tied to a checking account */
  Overdraft = 'OVERDRAFT',
  /** PayPal depository account */
  Paypal = 'PAYPAL',
  /** PayPal-issued credit card */
  PaypalCredit = 'PAYPAL_CREDIT',
  /** Standard pension account */
  Pension = 'PENSION',
  /** Prepaid debit card */
  Prepaid = 'PREPAID',
  /** Prescribed Registered Retirement Income Fund (Canada) */
  Prif = 'PRIF',
  /** Plan that gives employees share of company profits */
  ProfitSharingPlan = 'PROFIT_SHARING_PLAN',
  /** Qualifying share account */
  Qshr = 'QSHR',
  /** Registered Disability Savings Plan (RSDP) (Canada) */
  Rdsp = 'RDSP',
  /** Registered Education Savings Plan (Canada) */
  Resp = 'RESP',
  /** Retirement account not covered by other subtypes */
  Retirement = 'RETIREMENT',
  /** Restricted Life Income Fund (RLIF) (Canada) */
  Rlif = 'RLIF',
  /** Roth IRA (US) */
  Roth = 'ROTH',
  /** Employer-sponsored Roth 401(k) plan (US) */
  Roth_401K = 'ROTH_401K',
  /** Registered Retirement Income Fund (RRIF) (Canada) */
  Rrif = 'RRIF',
  /** Registered Retirement Savings Plan (Canadian, similar to US 401(k)) */
  Rrsp = 'RRSP',
  /** Salary Reduction Simplified Employee Pension Plan (SARSEP), discontinued retirement plan (US) */
  Sarsep = 'SARSEP',
  /** Savings account */
  Savings = 'SAVINGS',
  /** Simplified Employee Pension IRA (SEP IRA), retirement plan for small businesses and self-employed (US) */
  SepIra = 'SEP_IRA',
  /** Savings Incentive Match Plan for Employees IRA, retirement plan for small businesses (US) */
  SimpleIra = 'SIMPLE_IRA',
  /** Self-Invested Personal Pension (SIPP) (UK) */
  Sipp = 'SIPP',
  /** Standard stock plan account */
  StockPlan = 'STOCK_PLAN',
  /** Student loan */
  Student = 'STUDENT',
  /** Tax-Free Savings Account (TFSA), a retirement plan similar to a Roth IRA (Canada) */
  Tfsa = 'TFSA',
  /** Account representing funds or assets held by a trustee for the benefit of a beneficiary. Includes both revocable and irrevocable trusts. */
  Trust = 'TRUST',
  /** 'Uniform Gift to Minors Act' (brokerage account for minors, US) */
  Ugma = 'UGMA',
  /** 'Uniform Transfers to Minors Act' (brokerage account for minors, US) */
  Utma = 'UTMA',
  /** Tax-deferred capital accumulation annuity contract */
  VariableAnnuity = 'VARIABLE_ANNUITY'
}

export type MonitoredBankAccountTransaction = {
  __typename?: 'MonitoredBankAccountTransaction';
  amount: Scalars['Float']['output'];
  date: Scalars['ISO8601Date']['output'];
  deleted: Scalars['Boolean']['output'];
  detailedCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ignored: Scalars['Boolean']['output'];
  location?: Maybe<Location>;
  merchantLogoUrl?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  monitoredBankAccountId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nameOverride?: Maybe<Scalars['String']['output']>;
  needsCategorization: Scalars['Boolean']['output'];
  paymentChannel?: Maybe<PaymentChannelEnum>;
  pending: Scalars['Boolean']['output'];
  primaryCategory?: Maybe<Scalars['String']['output']>;
  primaryCategoryOverride?: Maybe<Scalars['String']['output']>;
  recurringTransactionId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export enum MonitoredBankAccountTypeEnum {
  /** A credit card type account. */
  Credit = 'CREDIT',
  /** An account type holding cash, in which funds are deposited. */
  Depository = 'DEPOSITORY',
  /** An investment type account. */
  Investment = 'INVESTMENT',
  /** A loan type account. */
  Loan = 'LOAN',
  /** An account type not covered by other types */
  Other = 'OTHER'
}

export type Mutation = {
  __typename?: 'Mutation';
  address?: Maybe<AddressPayload>;
  answerQuestion?: Maybe<AnswerQuestionPayload>;
  assignAddon?: Maybe<AssignAddonPayload>;
  assignBankAccountToCashAdvanceApplication?: Maybe<AssignBankAccountToCashAdvanceApplicationPayload>;
  batchPublishClientEvents?: Maybe<BatchPublishClientEventsPayload>;
  bidResponse?: Maybe<PartnerBidResponsePayload>;
  calibrateBudgets: CalibrateBudgetsPayload;
  confirmEmail: ConfirmEmailPayload;
  confirmPhone: ConfirmPhonePayload;
  createCashAdvanceApplication?: Maybe<CreateCashAdvanceApplicationPayload>;
  createCashAdvanceRequest?: Maybe<CreateCashAdvanceRequestPayload>;
  createChatToken: CreateChatTokenPayload;
  createClosureRequest: CreateClosureRequestPayload;
  createCtaClickUrl: CreateCtaClickUrlPayload;
  createLinkToken?: Maybe<CreateLinkTokenPayload>;
  createOnetimeDeposit?: Maybe<CreateOnetimeDepositPayload>;
  createPaymentAccount: CreatePaymentAccountPayload;
  createSubscription: CreateSubscriptionPayload;
  createUpdateLinkToken: CreateUpdateLinkTokenPayload;
  createUser: CreateUserPayload;
  /** @deprecated Use upsertUserFeatureOptIn instead */
  createUserFeatureOptIn: CreateUserFeatureOptInPayload;
  createUserRecurringDeposit?: Maybe<CreateUserRecurringDepositPayload>;
  createWithdrawal?: Maybe<CreateWithdrawalPayload>;
  deleteUserRecurringDeposit?: Maybe<DeleteUserRecurringDepositPayload>;
  favoritePartner?: Maybe<FavoritePartnerPayload>;
  forgotPassword: Scalars['Boolean']['output'];
  linkBankAccount: LinkBankAccountPayload;
  linkMonitoredAccount: LinkAccountPayload;
  mutePartner?: Maybe<MutePartnerPayload>;
  notifyReferredUser?: Maybe<NotifyReferredUserPayload>;
  oAuthCreateUser: OAuthCreateUserPayload;
  oAuthSignInUser: OAuthSignInUserPayload;
  pauseCashAdvanceSubscription?: Maybe<PauseCashAdvanceSubscriptionPayload>;
  pauseSubscription?: Maybe<PauseSubscriptionPayload>;
  payOutstandingFee?: Maybe<PayOutstandingFeePayload>;
  publishBackgroundEvent?: Maybe<PublishBackgroundEventPayload>;
  publishClientEvent?: Maybe<PublishClientEventPayload>;
  publishEvent?: Maybe<PublishEventPayload>;
  publishWebEvent?: Maybe<PublishWebEventPayload>;
  refreshTransactions?: Maybe<RefreshTransactionsPayload>;
  registrationComplete: RegistrationCompletePayload;
  removeAddon?: Maybe<RemoveAddonPayload>;
  repayCashAdvanceRequest?: Maybe<RepayCashAdvanceRequestPayload>;
  resendEmailVerification?: Maybe<ResendEmailVerificationPayload>;
  resendPhoneVerification?: Maybe<ResendPhoneVerificationPayload>;
  resetPassword: ResetPasswordPayload;
  resubmitInvestmentApplication?: Maybe<ResubmitInvestmentApplicationPayload>;
  resumeCashAdvanceSubscription?: Maybe<ResumeCashAdvanceSubscriptionPayload>;
  resumeSubscription?: Maybe<ResumeSubscriptionPayload>;
  runCashAdvanceEvaluation?: Maybe<RunCashAdvanceEvaluationPayload>;
  sendSignInSms?: Maybe<SendSignInSmsPayload>;
  setMonitoredTransactionOverrides: SetOverridesPayload;
  setUserAttribution: SetUserAttributionPayload;
  signInUser?: Maybe<SignInUserPayload>;
  signOutUser?: Maybe<Scalars['Boolean']['output']>;
  skipContainer?: Maybe<SkipContainerPayload>;
  submitCashAdvanceApplication?: Maybe<SubmitCashAdvanceApplicationPayload>;
  submitIntegrityResponse?: Maybe<SubmitIntegrityResponsePayload>;
  submitInvestmentApplication?: Maybe<SubmitInvestmentApplicationPayload>;
  switchSubscription: SwitchSubscriptionPayload;
  unlinkBankAccount: UnlinkBankAccountPayload;
  updatePaymentAccount: UpdatePaymentAccountPayload;
  updatePaymentAccountExpiration: UpdatePaymentAccountExpirationPayload;
  updatePhone: UpdatePhonePayload;
  updateUser: UpdateUserPayload;
  updateUserRecurringDeposit?: Maybe<UpdateUserRecurringDepositPayload>;
  upsertBudget: UpsertBudgetPayload;
  upsertUserFeatureOptIn: UpsertUserFeatureOptInPayload;
};


export type MutationAddressArgs = {
  input: AddressInput;
};


export type MutationAnswerQuestionArgs = {
  input: AnswerQuestionInput;
};


export type MutationAssignAddonArgs = {
  input: AssignAddonInput;
};


export type MutationAssignBankAccountToCashAdvanceApplicationArgs = {
  input: AssignBankAccountToCashAdvanceApplicationInput;
};


export type MutationBatchPublishClientEventsArgs = {
  input: BatchPublishClientEventsInput;
};


export type MutationBidResponseArgs = {
  input: PartnerBidResponseInput;
};


export type MutationCalibrateBudgetsArgs = {
  input: CalibrateBudgetsInput;
};


export type MutationConfirmEmailArgs = {
  input: ConfirmEmailInput;
};


export type MutationConfirmPhoneArgs = {
  input: ConfirmPhoneInput;
};


export type MutationCreateCashAdvanceApplicationArgs = {
  input: CreateCashAdvanceApplicationInput;
};


export type MutationCreateCashAdvanceRequestArgs = {
  input: CreateCashAdvanceRequestInput;
};


export type MutationCreateChatTokenArgs = {
  input: CreateChatTokenInput;
};


export type MutationCreateClosureRequestArgs = {
  input: CreateClosureRequestInput;
};


export type MutationCreateCtaClickUrlArgs = {
  input: CreateCtaClickUrlInput;
};


export type MutationCreateLinkTokenArgs = {
  linkAccountType?: InputMaybe<LinkAccountTypeEnum>;
};


export type MutationCreateOnetimeDepositArgs = {
  input: CreateOnetimeDepositInput;
};


export type MutationCreatePaymentAccountArgs = {
  input: CreatePaymentAccountInput;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateUpdateLinkTokenArgs = {
  input: CreateUpdateLinkTokenInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserFeatureOptInArgs = {
  input: CreateUserFeatureOptInInput;
};


export type MutationCreateUserRecurringDepositArgs = {
  input: CreateUserRecurringDepositInput;
};


export type MutationCreateWithdrawalArgs = {
  input: CreateWithdrawalInput;
};


export type MutationDeleteUserRecurringDepositArgs = {
  input: DeleteUserRecurringDepositInput;
};


export type MutationFavoritePartnerArgs = {
  input: FavoritePartnerInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationLinkBankAccountArgs = {
  input: LinkBankAccountInput;
};


export type MutationLinkMonitoredAccountArgs = {
  input: LinkAccountInput;
};


export type MutationMutePartnerArgs = {
  input: MutePartnerInput;
};


export type MutationNotifyReferredUserArgs = {
  input: NotifyReferredUserInput;
};


export type MutationOAuthCreateUserArgs = {
  input: OAuthCreateUserInput;
};


export type MutationOAuthSignInUserArgs = {
  input: OAuthSignInUserInput;
};


export type MutationPauseCashAdvanceSubscriptionArgs = {
  input: PauseCashAdvanceSubscriptionInput;
};


export type MutationPauseSubscriptionArgs = {
  input: PauseSubscriptionInput;
};


export type MutationPayOutstandingFeeArgs = {
  input: PayOutstandingFeeInput;
};


export type MutationPublishBackgroundEventArgs = {
  input: PublishBackgroundEventInput;
};


export type MutationPublishClientEventArgs = {
  input: PublishClientEventInput;
};


export type MutationPublishEventArgs = {
  input: PublishEventInput;
};


export type MutationPublishWebEventArgs = {
  input: PublishWebEventInput;
};


export type MutationRefreshTransactionsArgs = {
  input: RefreshTransactionsInput;
};


export type MutationRegistrationCompleteArgs = {
  input: RegistrationCompleteInput;
};


export type MutationRemoveAddonArgs = {
  input: RemoveAddonInput;
};


export type MutationRepayCashAdvanceRequestArgs = {
  input: RepayCashAdvanceRequestInput;
};


export type MutationResendEmailVerificationArgs = {
  input: ResendEmailVerificationInput;
};


export type MutationResendPhoneVerificationArgs = {
  input: ResendPhoneVerificationInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResubmitInvestmentApplicationArgs = {
  input: ResubmitInvestmentApplicationInput;
};


export type MutationResumeCashAdvanceSubscriptionArgs = {
  input: ResumeCashAdvanceSubscriptionInput;
};


export type MutationResumeSubscriptionArgs = {
  input: ResumeSubscriptionInput;
};


export type MutationRunCashAdvanceEvaluationArgs = {
  input: RunCashAdvanceEvaluationInput;
};


export type MutationSendSignInSmsArgs = {
  input: SendSignInSmsInput;
};


export type MutationSetMonitoredTransactionOverridesArgs = {
  input: SetOverridesInput;
};


export type MutationSetUserAttributionArgs = {
  input: SetUserAttributionInput;
};


export type MutationSignInUserArgs = {
  input: SignInUserInput;
};


export type MutationSignOutUserArgs = {
  input: SignOutUserInput;
};


export type MutationSkipContainerArgs = {
  input: SkipContainerInput;
};


export type MutationSubmitCashAdvanceApplicationArgs = {
  input: SubmitCashAdvanceApplicationInput;
};


export type MutationSubmitIntegrityResponseArgs = {
  input: SubmitIntegrityResponseInput;
};


export type MutationSubmitInvestmentApplicationArgs = {
  input: SubmitInvestmentApplicationInput;
};


export type MutationSwitchSubscriptionArgs = {
  input: SwitchSubscriptionInput;
};


export type MutationUnlinkBankAccountArgs = {
  input: UnlinkBankAccountInput;
};


export type MutationUpdatePaymentAccountArgs = {
  input: UpdatePaymentAccountInput;
};


export type MutationUpdatePaymentAccountExpirationArgs = {
  input: UpdatePaymentAccountExpirationInput;
};


export type MutationUpdatePhoneArgs = {
  input: UpdatePhoneInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserRecurringDepositArgs = {
  input: UpdateUserRecurringDepositInput;
};


export type MutationUpsertBudgetArgs = {
  input: UpsertBudgetInput;
};


export type MutationUpsertUserFeatureOptInArgs = {
  input: UpsertUserFeatureOptInInput;
};

/** Autogenerated input type of MutePartner */
export type MutePartnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['ID']['input'];
};

/** Autogenerated return type of MutePartner */
export type MutePartnerPayload = {
  __typename?: 'MutePartnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type NativeAd = BaseAd & WithTimestamps & {
  __typename?: 'NativeAd';
  /** The specific type of ad. */
  adType: AdTypeEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The title of a creative */
  cta: Scalars['String']['output'];
  /** The call to action url for a creative */
  ctaUri: Scalars['String']['output'];
  /** The deeplink url for a creative */
  deeplinkUri?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Legal notice related an offer in Markdown syntax. Normally includes Terms and Conditions */
  disclosure?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The internal (atm) layout for a creative */
  internalLayout?: Maybe<InternalNativeCreativeLayout>;
  /** The creative that is linked to this creative */
  linkedAd?: Maybe<AdUnion>;
  /** The main image url for a creative */
  mainImageUrl?: Maybe<Scalars['String']['output']>;
  /** The Served Impression ID that was served to the user. */
  servedImpressionId: Scalars['ID']['output'];
  /** The url linking to the terms and conditions for a creative or offer */
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  /** The title shown at the top of a Braze interstitial or a headline without emojis */
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type NoLinkedCardError = ErrorInterface & {
  __typename?: 'NoLinkedCardError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type NoOutStandingFeeError = ErrorInterface & {
  __typename?: 'NoOutStandingFeeError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type NoPaymentAccountError = ErrorInterface & {
  __typename?: 'NoPaymentAccountError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type NotSupportedSubscriptionProductError = ErrorInterface & {
  __typename?: 'NotSupportedSubscriptionProductError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type NotifyReferredUserError = Error | ReferralNotFoundError;

/** Autogenerated input type of NotifyReferredUser */
export type NotifyReferredUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referralId: Scalars['ID']['input'];
};

/** Autogenerated return type of NotifyReferredUser */
export type NotifyReferredUserPayload = {
  __typename?: 'NotifyReferredUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<NotifyReferredUserError>>;
};

export type OAuthCreateUserError = Error | OAuthCreateUserExistingOAuthError | OAuthCreateUserExistingUserError | OAuthCreateUserInvalidTokenError | OAuthCreateUserTokenExpiredError;

export type OAuthCreateUserExistingOAuthError = ErrorInterface & {
  __typename?: 'OAuthCreateUserExistingOAuthError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type OAuthCreateUserExistingUserError = ErrorInterface & {
  __typename?: 'OAuthCreateUserExistingUserError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of OAuthCreateUser */
export type OAuthCreateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  provider: OAuthProviderEnum;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type OAuthCreateUserInvalidTokenError = ErrorInterface & {
  __typename?: 'OAuthCreateUserInvalidTokenError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of OAuthCreateUser */
export type OAuthCreateUserPayload = {
  __typename?: 'OAuthCreateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<OAuthCreateUserError>>;
  user?: Maybe<User>;
};

export type OAuthCreateUserTokenExpiredError = ErrorInterface & {
  __typename?: 'OAuthCreateUserTokenExpiredError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export enum OAuthProviderEnum {
  /** Sign In with Apple */
  AppleSignIn = 'APPLE_SIGN_IN',
  /** Google OAuth 2 */
  GoogleOauth2 = 'GOOGLE_OAUTH2'
}

export type OAuthSignInNotRegisteredError = ErrorInterface & {
  __typename?: 'OAuthSignInNotRegisteredError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type OAuthSignInUserError = Error | OAuthSignInNotRegisteredError | OAuthSignInUserInvalidTokenError | OAuthSignInUserTokenExpiredError;

/** Autogenerated input type of OAuthSignInUser */
export type OAuthSignInUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  provider: OAuthProviderEnum;
  token: Scalars['String']['input'];
};

export type OAuthSignInUserInvalidTokenError = ErrorInterface & {
  __typename?: 'OAuthSignInUserInvalidTokenError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of OAuthSignInUser */
export type OAuthSignInUserPayload = {
  __typename?: 'OAuthSignInUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<OAuthSignInUserError>>;
  user?: Maybe<User>;
};

export type OAuthSignInUserTokenExpiredError = ErrorInterface & {
  __typename?: 'OAuthSignInUserTokenExpiredError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** One-time deposit request input type */
export type OnetimeDeposit = {
  amount: Scalars['String']['input'];
};

export type Option = {
  __typename?: 'Option';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OtherUser = {
  __typename?: 'OtherUser';
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastInitial?: Maybe<Scalars['String']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Partner = {
  __typename?: 'Partner';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  dataUsageDescription?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  favorite: Scalars['Boolean']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use iconUrl only */
  logoUrl?: Maybe<Scalars['String']['output']>;
  minimalOfferDetailOverride: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
};

export type PartnerBid = {
  __typename?: 'PartnerBid';
  activeFrom?: Maybe<Scalars['ISO8601DateTime']['output']>;
  activeTo?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dataVaultContainers?: Maybe<Array<QuestionContainer>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  partner: Partner;
  partnerOffer?: Maybe<PartnerOfferUnion>;
  reward?: Maybe<PartnerBidReward>;
};

export enum PartnerBidActionChoiceEnum {
  /** Later */
  Later = 'LATER',
  /** No */
  No = 'NO',
  /** Yes */
  Yes = 'YES'
}

/** The connection type for PartnerBid. */
export type PartnerBidConnection = {
  __typename?: 'PartnerBidConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerBidEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PartnerBid>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PartnerBidEdge = {
  __typename?: 'PartnerBidEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PartnerBid>;
};

/** Autogenerated input type of PartnerBidResponse */
export type PartnerBidResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  response: PartnerBidResponseInput1;
};

/** Partner Bid Response Input Object */
export type PartnerBidResponseInput1 = {
  actionChoice: PartnerBidActionChoiceEnum;
  bidId: Scalars['ID']['input'];
};

/** Autogenerated return type of PartnerBidResponse */
export type PartnerBidResponsePayload = {
  __typename?: 'PartnerBidResponsePayload';
  bidResponseId?: Maybe<Scalars['ID']['output']>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  offerId?: Maybe<Scalars['ID']['output']>;
  partnerBid?: Maybe<PartnerBid>;
};

export type PartnerBidReward = {
  __typename?: 'PartnerBidReward';
  amount?: Maybe<Scalars['String']['output']>;
  type: PartnerBidRewardEnum;
};

export enum PartnerBidRewardEnum {
  /** United States Dollar */
  Usd = 'USD'
}

export type PartnerOfferCategory = {
  __typename?: 'PartnerOfferCategory';
  /** The url for the banner image */
  bannerUrl?: Maybe<Scalars['String']['output']>;
  /** Customized data for a category */
  displayMetadata: PartnerOfferCategoryDisplayMetadata;
  id: Scalars['ID']['output'];
  /** Featured offers inside of a category */
  myFeaturedPartnerOffers1: PartnerOfferUnionConnection;
  /** All offers related to a specific category for a user */
  myFullPartnerOffers1: PartnerOfferUnionConnection;
  /** Offers related to a specific category, with a limit defined */
  myPartnerOffers1: PartnerOfferUnionConnection;
  /** The category name */
  name: Scalars['String']['output'];
  /** The position of the category to be displayed at. */
  priorityOrder?: Maybe<Scalars['Int']['output']>;
};


export type PartnerOfferCategoryMyFeaturedPartnerOffers1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PartnerOfferCategoryMyFullPartnerOffers1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PartnerOfferCategoryMyPartnerOffers1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for PartnerOfferCategory. */
export type PartnerOfferCategoryConnection = {
  __typename?: 'PartnerOfferCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerOfferCategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PartnerOfferCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Metadata specific to category */
export type PartnerOfferCategoryDisplayMetadata = {
  __typename?: 'PartnerOfferCategoryDisplayMetadata';
  /**
   * Dynamically determine how the tiles should be displayed/styled per each category on the detail view in the main section.
   * @deprecated Prefer detail_display_styling
   */
  detailDisplayStyle: CategoryDetailDisplayStyleEnum;
  /** Determine how the tiles should be displayed/styled per each category on the detail view in the main section. */
  detailDisplayStyling: PartnerOfferCategoryDisplayStyling;
  /**
   * Dynamically determine how the tiles should be displayed/styled per each category on the detail view in the featured section.
   * @deprecated Prefer featured_display_styling
   */
  featuredDisplayStyle: CategoryFeaturedDisplayStyleEnum;
  /** Determine how the tiles should be displayed/styled per each category on the detail view in the featured section. */
  featuredDisplayStyling: PartnerOfferCategoryDisplayStyling;
  /**
   * Dynamically determine how the tiles should be displayed/styled per each category in the rewards portal view.
   * @deprecated Prefer main_display_styling
   */
  mainDisplayStyle: CategoryMainDisplayStyleEnum;
  /** Determine how the tiles should be displayed/styled per each category in the rewards portal view. */
  mainDisplayStyling: PartnerOfferCategoryDisplayStyling;
  /** The pagination amount to be used when viewing all category offers. This will default to 200. */
  viewAllPaginationAmount: Scalars['Int']['output'];
};

export type PartnerOfferCategoryDisplayStyling = {
  __typename?: 'PartnerOfferCategoryDisplayStyling';
  /** The axis of scrolling to be used for the category. */
  axis: Scalars['String']['output'];
  /** The hex background color to be used for the container */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The style of the card to be used for the category. */
  cardStyle: Scalars['String']['output'];
  /** The number of columns to be used for the category. Only used if axis is vertical. */
  columns?: Maybe<Scalars['Int']['output']>;
  /** The number of rows to be used for the category. Only used if axis is horizontal. */
  rows?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PartnerOfferCategoryEdge = {
  __typename?: 'PartnerOfferCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PartnerOfferCategory>;
};

export enum PartnerOfferCtaClickBehaviorEnum {
  /** External Browser */
  ExternalBrowser = 'EXTERNAL_BROWSER',
  /** Internal Browser */
  InternalBrowser = 'INTERNAL_BROWSER',
  /** Web View */
  Webview = 'WEBVIEW'
}

export type PartnerOfferPotentialRewardTotal = {
  __typename?: 'PartnerOfferPotentialRewardTotal';
  /** The total amount that can be earned from this offer */
  amount: Scalars['String']['output'];
  /** The original value of this offers reward, pre limited time offers */
  originalAmount: Scalars['String']['output'];
  /** The specific type of reward being granted */
  rewardType: PartnerRewardTypeEnum;
};

export type PartnerOfferProgress = {
  __typename?: 'PartnerOfferProgress';
  /** The time the event was completed at */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Human readable name to be displayed */
  displayName: Scalars['String']['output'];
  /** The type of event */
  eventName: Scalars['String']['output'];
  /** If you see a 00000000-0000-0000-0000-000000000000 UUID, that is a temporary placeholder. */
  id: Scalars['ID']['output'];
  /** The max amount of times this event can be completed */
  maxCompletionTimes: Scalars['Int']['output'];
  /** The amount of times this event has been completed */
  timesCompleted: Scalars['Int']['output'];
};

/** The connection type for PartnerOfferProgress. */
export type PartnerOfferProgressConnection = {
  __typename?: 'PartnerOfferProgressConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerOfferProgressEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PartnerOfferProgress>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PartnerOfferProgressEdge = {
  __typename?: 'PartnerOfferProgressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PartnerOfferProgress>;
};

export type PartnerOfferTag = {
  __typename?: 'PartnerOfferTag';
  id: Scalars['ID']['output'];
  /** The tag name */
  name: Scalars['String']['output'];
  /** The position of the tag to be displayed at. */
  priorityOrder?: Maybe<Scalars['Int']['output']>;
};

/** The connection type for PartnerOfferTag. */
export type PartnerOfferTagConnection = {
  __typename?: 'PartnerOfferTagConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerOfferTagEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PartnerOfferTag>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PartnerOfferTagEdge = {
  __typename?: 'PartnerOfferTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PartnerOfferTag>;
};

export enum PartnerOfferTypeEnum {
  /** A deal */
  Deal = 'DEAL',
  /** A survey */
  Survey = 'SURVEY'
}

export type PartnerOfferUnion = Deal | Survey;

/** The connection type for PartnerOfferUnion. */
export type PartnerOfferUnionConnection = {
  __typename?: 'PartnerOfferUnionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerOfferUnionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PartnerOfferUnion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PartnerOfferUnionEdge = {
  __typename?: 'PartnerOfferUnionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PartnerOfferUnion>;
};

export enum PartnerRewardTypeEnum {
  /** A fixed reward amount */
  Fixed = 'FIXED',
  /** A percentage of reward */
  Percentage = 'PERCENTAGE'
}

export type PauseCashAdvanceSubscriptionActiveAdvanceError = ErrorInterface & {
  __typename?: 'PauseCashAdvanceSubscriptionActiveAdvanceError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type PauseCashAdvanceSubscriptionCanceledError = ErrorInterface & {
  __typename?: 'PauseCashAdvanceSubscriptionCanceledError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type PauseCashAdvanceSubscriptionErrors = Error | PauseCashAdvanceSubscriptionActiveAdvanceError | PauseCashAdvanceSubscriptionCanceledError | PauseCashAdvanceSubscriptionInactiveError | PauseCashAdvanceSubscriptionNoSubscriptionError;

export type PauseCashAdvanceSubscriptionInactiveError = ErrorInterface & {
  __typename?: 'PauseCashAdvanceSubscriptionInactiveError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of PauseCashAdvanceSubscription */
export type PauseCashAdvanceSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type PauseCashAdvanceSubscriptionNoSubscriptionError = ErrorInterface & {
  __typename?: 'PauseCashAdvanceSubscriptionNoSubscriptionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of PauseCashAdvanceSubscription */
export type PauseCashAdvanceSubscriptionPayload = {
  __typename?: 'PauseCashAdvanceSubscriptionPayload';
  cashAdvanceSubscription?: Maybe<CashAdvanceSubscription>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<PauseCashAdvanceSubscriptionErrors>>;
};

export type PauseSubscriptionActiveAdvanceError = ErrorInterface & {
  __typename?: 'PauseSubscriptionActiveAdvanceError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type PauseSubscriptionCanceledError = ErrorInterface & {
  __typename?: 'PauseSubscriptionCanceledError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type PauseSubscriptionErrors = Error | PauseSubscriptionActiveAdvanceError | PauseSubscriptionCanceledError | PauseSubscriptionInactiveError | PauseSubscriptionNoSubscriptionError;

export type PauseSubscriptionInactiveError = ErrorInterface & {
  __typename?: 'PauseSubscriptionInactiveError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of PauseSubscription */
export type PauseSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type PauseSubscriptionNoSubscriptionError = ErrorInterface & {
  __typename?: 'PauseSubscriptionNoSubscriptionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of PauseSubscription */
export type PauseSubscriptionPayload = {
  __typename?: 'PauseSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<PauseSubscriptionErrors>>;
  subscription?: Maybe<Subscription>;
};

export type PayOutstandingFeeError = Error | NoOutStandingFeeError;

/** Autogenerated input type of PayOutstandingFee */
export type PayOutstandingFeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PayOutstandingFee */
export type PayOutstandingFeePayload = {
  __typename?: 'PayOutstandingFeePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<PayOutstandingFeeError>>;
  subscriptionFee?: Maybe<SubscriptionFee>;
};

export enum PaymentAccountChangeAllowedStatus {
  /** Discouraged - Technically allowed, but do not encourage */
  Discouraged = 'DISCOURAGED',
  /** Max account changes reached */
  MaxAccountChangesReached = 'MAX_ACCOUNT_CHANGES_REACHED',
  /** Generic disabled */
  No = 'NO',
  /** OK */
  Ok = 'OK',
  /** Used for cash advance application */
  UsedForCashAdvanceApplication = 'USED_FOR_CASH_ADVANCE_APPLICATION',
  /** Withdrawal in progress */
  WithdrawalInProgress = 'WITHDRAWAL_IN_PROGRESS'
}

export type PaymentAccountLinkedOverLimitError = ErrorInterface & {
  __typename?: 'PaymentAccountLinkedOverLimitError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export enum PaymentAccountTransferMethod {
  /** ACH transfer. 3-5 Business days */
  Ach = 'ACH',
  /** Instant transfer. Within minutes */
  Card = 'CARD'
}

export enum PaymentChannelEnum {
  /** Transactions that are processed in a physical store. */
  InStore = 'IN_STORE',
  /** Transactions that are processed online. */
  Online = 'ONLINE',
  /** Transactions that do not fit the categories of in-store or online. */
  Other = 'OTHER'
}

export type Performance = {
  __typename?: 'Performance';
  cash: Scalars['String']['output'];
  cumRealizedPL: Scalars['String']['output'];
  date: Scalars['String']['output'];
  deposits: Scalars['String']['output'];
  equity: Scalars['String']['output'];
  fees: Scalars['String']['output'];
  realizedDayPL: Scalars['String']['output'];
  unrealizedDayPL: Scalars['String']['output'];
  withdrawals: Scalars['String']['output'];
};

/** Phone Input Object */
export type Phone = {
  /** Country Calling Code */
  code: Scalars['Int']['input'];
  /** Phone Number */
  number: Scalars['String']['input'];
};

/** Additional information related to a phone number. This data comes from Twilio using their lookups. */
export type PhoneDetail = WithTimestamps & {
  __typename?: 'PhoneDetail';
  /** The mobile country code based on carrier */
  carrierMobileCountryCode?: Maybe<Scalars['String']['output']>;
  /** The mobile network code based on carrier */
  carrierMobileNetworkCode?: Maybe<Scalars['String']['output']>;
  /** The name of the carrier */
  carrierName?: Maybe<Scalars['String']['output']>;
  /** The type of carrier */
  carrierType?: Maybe<Scalars['String']['output']>;
  /** The country code of this phone number */
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The phone number */
  phone: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The user associated with this phone number. There is a possibility none are associated anymore. */
  user?: Maybe<User>;
};

/** A token to be used when linking Plaid */
export type PlaidLinkToken = {
  __typename?: 'PlaidLinkToken';
  expiration?: Maybe<Scalars['ISO8601DateTime']['output']>;
  linkToken?: Maybe<Scalars['String']['output']>;
};

export type Portfolio = {
  __typename?: 'Portfolio';
  addonInstruments?: Maybe<Array<Maybe<AddonInstrument>>>;
  corePortfolioId: Scalars['ID']['output'];
  corePortfolioName: Scalars['String']['output'];
};

/** Potential campaign reward totals for a user, scoped by partner, sorted by latest message descending. Grand totals returned at top of list (with null partner id). */
export type PotentialCampaignRewardTotal = {
  __typename?: 'PotentialCampaignRewardTotal';
  /** Total amount of potential rewards for the given partner id */
  amount?: Maybe<Scalars['String']['output']>;
  /** The id of a partner; grand total if null */
  partnerId?: Maybe<Scalars['ID']['output']>;
};

/** The connection type for PotentialCampaignRewardTotal. */
export type PotentialCampaignRewardTotalConnection = {
  __typename?: 'PotentialCampaignRewardTotalConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PotentialCampaignRewardTotalEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PotentialCampaignRewardTotal>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PotentialCampaignRewardTotalEdge = {
  __typename?: 'PotentialCampaignRewardTotalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PotentialCampaignRewardTotal>;
};

/** Provider Input Object */
export type Provider = {
  /** Plaid Account ID */
  accountId?: InputMaybe<Scalars['String']['input']>;
  /** Plaid Insitution ID */
  institutionId?: InputMaybe<Scalars['String']['input']>;
  /** Plaid Public Token */
  publicToken?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of PublishBackgroundEvent */
export type PublishBackgroundEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  event: ClientEventInput;
};

/** Autogenerated return type of PublishBackgroundEvent */
export type PublishBackgroundEventPayload = {
  __typename?: 'PublishBackgroundEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ClientEventUnionErrors>>;
  /** The successful Request ID */
  eventId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of PublishClientEvent */
export type PublishClientEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  event: ClientEventInput;
};

/** Autogenerated return type of PublishClientEvent */
export type PublishClientEventPayload = {
  __typename?: 'PublishClientEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ClientEventUnionErrors>>;
  /** The successful Request ID */
  eventId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of PublishEvent */
export type PublishEventInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  partnerId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of PublishEvent */
export type PublishEventPayload = {
  __typename?: 'PublishEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of PublishWebEvent */
export type PublishWebEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  event: ClientEventInput;
};

/** Autogenerated return type of PublishWebEvent */
export type PublishWebEventPayload = {
  __typename?: 'PublishWebEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ClientEventUnionErrors>>;
  /** The successful Request ID */
  eventId?: Maybe<Scalars['ID']['output']>;
};

export type Query = {
  __typename?: 'Query';
  adForPlacement?: Maybe<AdUnion>;
  addDataContainers: Array<Maybe<QuestionContainer>>;
  addonInstrument: AddonInstrument;
  addonInstrumentBar: Array<BarData>;
  addonInstruments: Array<AddonInstrument>;
  adsForPlacement?: Maybe<AdUnionConnection>;
  appSettings: AppSettings;
  appVersionSupported: Scalars['Boolean']['output'];
  availableBids: PartnerBidConnection;
  availableFeatures?: Maybe<AvailableFeatures>;
  balance?: Maybe<Balance>;
  bankAccount?: Maybe<BankAccount>;
  /** @deprecated Use monitoredBankAccountTransactions instead */
  bankAccountTransactions: Array<BankAccountTransaction>;
  budgets?: Maybe<Array<Budget>>;
  cashAdvanceActiveRequest?: Maybe<CashAdvanceRequest>;
  cashAdvanceActiveRequests: Array<CashAdvanceRequest>;
  cashAdvanceApplication?: Maybe<CashAdvanceApplication>;
  cashAdvanceApplicationCapability: Scalars['Boolean']['output'];
  cashAdvanceApprovedAmount: CashAdvanceApprovedAmount;
  cashAdvanceAsapFeeSchedule: Array<CashAdvanceFeeSchedule>;
  cashAdvanceQuote: CashAdvanceRequest;
  cashAdvanceRequests: Array<CashAdvanceRequest>;
  cashAdvanceSubscription?: Maybe<CashAdvanceSubscription>;
  cashAdvanceTransactions?: Maybe<TransactionConnection>;
  customCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceIntegrity: DeviceIntegrity;
  findPartnerOffer1?: Maybe<PartnerOfferUnion>;
  findPartnerOfferCategoryById?: Maybe<PartnerOfferCategory>;
  investmentAccountPerformance: Array<Performance>;
  investmentAccountPerformanceAggregated: AccountPerformance;
  marketStatus: MarketStatus;
  monitoredBankAccountTransactions: Array<MonitoredBankAccountTransaction>;
  monitoredBankAccounts?: Maybe<Array<MonitoredBankAccount>>;
  nextAvailableDataContainer?: Maybe<QuestionContainer>;
  offerForPlacement1?: Maybe<PartnerOfferUnion>;
  offerSearch?: Maybe<PartnerOfferUnionConnection>;
  offersForPlacement?: Maybe<PartnerOfferUnionConnection>;
  onboardingQuestionContainers: Array<Maybe<QuestionContainer>>;
  partners: Array<Partner>;
  paymentAccountChangeAllowed: PaymentAccountChangeAllowedStatus;
  paymentAccounts?: Maybe<Array<BankAccount>>;
  publicOffersForPlacement?: Maybe<PartnerOfferUnionConnection>;
  publicOffersForUrl?: Maybe<PartnerOfferUnionConnection>;
  questionContainers: Array<Maybe<QuestionContainer>>;
  recentTransactions?: Maybe<TransactionConnection>;
  recurringTransactions?: Maybe<Array<RecurringTransaction>>;
  referral?: Maybe<Referral>;
  rewardsLeaderboard?: Maybe<Leaderboard>;
  sharedUser?: Maybe<SharedUser>;
  statementUrl: Scalars['String']['output'];
  statementsConfirms: Array<Statement>;
  statementsMonthly: Array<Statement>;
  statementsTaxforms: Array<Statement>;
  streakDetails?: Maybe<StreakDetails>;
  streakstakesEvents?: Maybe<Array<StreakstakesEvent>>;
  subscriptionFeesOutstanding?: Maybe<Array<SubscriptionFee>>;
  subscriptionProducts?: Maybe<Array<SubscriptionProduct>>;
  subscriptions?: Maybe<Array<Subscription>>;
  transactionExport: TransactionExport;
  user?: Maybe<User>;
  userDataContainers: Array<Maybe<QuestionContainer>>;
};


export type QueryAdForPlacementArgs = {
  adId?: InputMaybe<Scalars['ID']['input']>;
  placementId: Scalars['ID']['input'];
  supportedAdAttributes?: InputMaybe<AdAttributesInput>;
  supportedAdTypes: Array<AdTypeEnum>;
};


export type QueryAddonInstrumentArgs = {
  symbol: Scalars['ID']['input'];
};


export type QueryAddonInstrumentBarArgs = {
  compression: CompressionEnum;
  period: Scalars['String']['input'];
  symbol: Scalars['ID']['input'];
};


export type QueryAdsForPlacementArgs = {
  adId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  placementId: Scalars['ID']['input'];
  supportedAdAttributes?: InputMaybe<AdAttributesInput>;
  supportedAdTypes: Array<AdTypeEnum>;
};


export type QueryAppVersionSupportedArgs = {
  platform: ClientPlatformEnum;
  version: Scalars['String']['input'];
};


export type QueryAvailableBidsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBankAccountTransactionsArgs = {
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  merchant?: InputMaybe<Scalars['String']['input']>;
  primaryCategory?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<BankAccountTransactionSort>;
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QueryBudgetsArgs = {
  month?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryCashAdvanceQuoteArgs = {
  amount: Scalars['String']['input'];
  tip?: InputMaybe<Scalars['String']['input']>;
  transferType: CashAdvanceRequestTransferType;
};


export type QueryCashAdvanceTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindPartnerOffer1Args = {
  id: Scalars['ID']['input'];
  servedImpressionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFindPartnerOfferCategoryByIdArgs = {
  id: Scalars['ID']['input'];
  placementId?: InputMaybe<Scalars['ID']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInvestmentAccountPerformanceArgs = {
  accountId: Scalars['ID']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvestmentAccountPerformanceAggregatedArgs = {
  accountId: Scalars['ID']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMonitoredBankAccountTransactionsArgs = {
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  merchant?: InputMaybe<Scalars['String']['input']>;
  monitoredBankAccountId?: InputMaybe<Scalars['ID']['input']>;
  primaryCategory?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<BankAccountTransactionSort>;
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QueryNextAvailableDataContainerArgs = {
  placementName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOfferForPlacement1Args = {
  placementId: Scalars['ID']['input'];
};


export type QueryOfferSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryOffersForPlacementArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  placementId: Scalars['ID']['input'];
  tagId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPartnersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryPaymentAccountChangeAllowedArgs = {
  transferMethod: PaymentAccountTransferMethod;
};


export type QueryPaymentAccountsArgs = {
  transferMethod?: InputMaybe<PaymentAccountTransferMethod>;
};


export type QueryPublicOffersForPlacementArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  partnerOfferId?: InputMaybe<Scalars['ID']['input']>;
  placementId: Scalars['ID']['input'];
};


export type QueryPublicOffersForUrlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  placementId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};


export type QueryQuestionContainersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryRecentTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardsLeaderboardArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  period: LeaderboardPeriodEnum;
  type: LeaderboardTypeEnum;
};


export type QueryStatementUrlArgs = {
  accountId: Scalars['ID']['input'];
  fileKey: Scalars['String']['input'];
};


export type QueryStatementsConfirmsArgs = {
  accountId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStatementsMonthlyArgs = {
  accountId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStatementsTaxformsArgs = {
  accountId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTransactionExportArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Question Input Which Can Be Rendered */
export type Question = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<QuestionImage>>;
  required: Scalars['Boolean']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userResponse?: Maybe<UserDataVaultQuestionResponse>;
};

export type QuestionContainer = {
  __typename?: 'QuestionContainer';
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonTooltipText?: Maybe<Scalars['String']['output']>;
  category: Category;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questions?: Maybe<Array<Question>>;
};

export type QuestionImage = {
  __typename?: 'QuestionImage';
  url: Scalars['String']['output'];
};

/** Data Vault Question Response Input Object */
export type QuestionResponse = {
  questionId: Scalars['ID']['input'];
  response: Scalars['String']['input'];
};

export type RateLimitExceeded = ErrorInterface & {
  __typename?: 'RateLimitExceeded';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type RecurringTransaction = {
  __typename?: 'RecurringTransaction';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  firstTransactionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  frequency: RecurringTransactionFrequencyEnum;
  id: Scalars['ID']['output'];
  lastTransactionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  name: Scalars['String']['output'];
  nextTransactionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  transactionCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export enum RecurringTransactionFrequencyEnum {
  /** Occurs every year */
  Annually = 'ANNUALLY',
  /** Occurs every 2 weeks */
  Biweekly = 'BIWEEKLY',
  /** Occurs every month */
  Monthly = 'MONTHLY',
  /** Occurs twice a month */
  Semimonthly = 'SEMIMONTHLY',
  /** Occurs every week */
  Weekly = 'WEEKLY'
}

export type Referral = {
  __typename?: 'Referral';
  code: Scalars['String']['output'];
  history: Array<ReferralHistory>;
  referrerName?: Maybe<Scalars['String']['output']>;
  rewardAmount: Scalars['String']['output'];
  rewardCriteria: ReferralRewardCriteriaEnum;
  rewardCriteriaDescription: Scalars['String']['output'];
};

export type ReferralHistory = {
  __typename?: 'ReferralHistory';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  qualifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  referralId?: Maybe<Scalars['ID']['output']>;
  rewardCriteria: ReferralRewardCriteriaEnum;
};

export type ReferralNotFoundError = ErrorInterface & {
  __typename?: 'ReferralNotFoundError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export enum ReferralRewardCriteriaEnum {
  /** Account Strength */
  AccountStrength = 'ACCOUNT_STRENGTH',
  /** Bank Link */
  BankLink = 'BANK_LINK',
  /** Invest Account */
  InvestAccount = 'INVEST_ACCOUNT',
  /** Register */
  Register = 'REGISTER'
}

export type RefreshTransactionsErrors = Error | RefreshTransactionsUnauthorizedError;

/** Autogenerated input type of RefreshTransactions */
export type RefreshTransactionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RefreshTransactions */
export type RefreshTransactionsPayload = {
  __typename?: 'RefreshTransactionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RefreshTransactionsErrors>>;
  success: Scalars['Boolean']['output'];
};

export type RefreshTransactionsUnauthorizedError = ErrorInterface & {
  __typename?: 'RefreshTransactionsUnauthorizedError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RegistrationComplete */
export type RegistrationCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RegistrationComplete */
export type RegistrationCompletePayload = {
  __typename?: 'RegistrationCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of RemoveAddon */
export type RemoveAddonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  investmentAccountId: Scalars['ID']['input'];
  symbol: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveAddon */
export type RemoveAddonPayload = {
  __typename?: 'RemoveAddonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investmentAccount?: Maybe<InvestmentAccount>;
};

/** Autogenerated input type of RepayCashAdvanceRequest */
export type RepayCashAdvanceRequestInput = {
  cashAdvanceRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RepayCashAdvanceRequest */
export type RepayCashAdvanceRequestPayload = {
  __typename?: 'RepayCashAdvanceRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResendEmailVerification */
export type ResendEmailVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ResendEmailVerification */
export type ResendEmailVerificationPayload = {
  __typename?: 'ResendEmailVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ResendPhoneVerification */
export type ResendPhoneVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ResendPhoneVerification */
export type ResendPhoneVerificationPayload = {
  __typename?: 'ResendPhoneVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ResetPassword */
export type ResetPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};

/** Autogenerated return type of ResetPassword */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ResubmitInvestmentApplication */
export type ResubmitInvestmentApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  investmentAccountId: Scalars['ID']['input'];
  investmentApplication: InvestmentApplicationInput;
};

/** Autogenerated return type of ResubmitInvestmentApplication */
export type ResubmitInvestmentApplicationPayload = {
  __typename?: 'ResubmitInvestmentApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investmentAccount?: Maybe<InvestmentAccount>;
};

export type ResumeCashAdvanceSubscriptionActiveError = ErrorInterface & {
  __typename?: 'ResumeCashAdvanceSubscriptionActiveError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type ResumeCashAdvanceSubscriptionCanceledError = ErrorInterface & {
  __typename?: 'ResumeCashAdvanceSubscriptionCanceledError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type ResumeCashAdvanceSubscriptionErrors = Error | ResumeCashAdvanceSubscriptionActiveError | ResumeCashAdvanceSubscriptionCanceledError | ResumeCashAdvanceSubscriptionNoSubscriptionError;

/** Autogenerated input type of ResumeCashAdvanceSubscription */
export type ResumeCashAdvanceSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ResumeCashAdvanceSubscriptionNoSubscriptionError = ErrorInterface & {
  __typename?: 'ResumeCashAdvanceSubscriptionNoSubscriptionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ResumeCashAdvanceSubscription */
export type ResumeCashAdvanceSubscriptionPayload = {
  __typename?: 'ResumeCashAdvanceSubscriptionPayload';
  cashAdvanceSubscription?: Maybe<CashAdvanceSubscription>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ResumeCashAdvanceSubscriptionErrors>>;
};

export type ResumeSubscriptionActiveError = ErrorInterface & {
  __typename?: 'ResumeSubscriptionActiveError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type ResumeSubscriptionCanceledError = ErrorInterface & {
  __typename?: 'ResumeSubscriptionCanceledError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type ResumeSubscriptionErrors = Error | ResumeSubscriptionActiveError | ResumeSubscriptionCanceledError | ResumeSubscriptionNoSubscriptionError;

/** Autogenerated input type of ResumeSubscription */
export type ResumeSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type ResumeSubscriptionNoSubscriptionError = ErrorInterface & {
  __typename?: 'ResumeSubscriptionNoSubscriptionError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ResumeSubscription */
export type ResumeSubscriptionPayload = {
  __typename?: 'ResumeSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ResumeSubscriptionErrors>>;
  subscription?: Maybe<Subscription>;
};

export type RunCashAdvanceEvaluationErrors = EvaluationAlreadyRunError | NoPaymentAccountError;

/** Autogenerated input type of RunCashAdvanceEvaluation */
export type RunCashAdvanceEvaluationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RunCashAdvanceEvaluation */
export type RunCashAdvanceEvaluationPayload = {
  __typename?: 'RunCashAdvanceEvaluationPayload';
  cashAdvanceEvaluation?: Maybe<CashAdvanceEvaluation>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RunCashAdvanceEvaluationErrors>>;
};

export type SaveError = ErrorInterface & {
  __typename?: 'SaveError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of SendSignInSMS */
export type SendSignInSmsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Phone>;
};

/** Autogenerated return type of SendSignInSMS */
export type SendSignInSmsPayload = {
  __typename?: 'SendSignInSMSPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type SetOverridesErrors = Error | GenericError | SaveError | TransactionNotFoundError;

/** Autogenerated input type of SetOverrides */
export type SetOverridesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ignored?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetOverrides */
export type SetOverridesPayload = {
  __typename?: 'SetOverridesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<SetOverridesErrors>>;
};

export type SetUserAttributionError = Error | InvalidUserAttributionError;

/** Autogenerated input type of SetUserAttribution */
export type SetUserAttributionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userAttribution: UserAttribution;
};

/** Autogenerated return type of SetUserAttribution */
export type SetUserAttributionPayload = {
  __typename?: 'SetUserAttributionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<SetUserAttributionError>>;
};

export type SharedUser = {
  __typename?: 'SharedUser';
  /** Active experiments for a user. */
  activeExperiments?: Maybe<Array<ActiveExperiment>>;
  id: Scalars['ID']['output'];
  /** All the categories for a shared user */
  myCategories?: Maybe<PartnerOfferCategoryConnection>;
  /** All partner offer tags */
  myPartnerTags?: Maybe<PartnerOfferTagConnection>;
};


export type SharedUserMyCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
};


export type SharedUserMyPartnerTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of SignInUser */
export type SignInUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Phone>;
  smsVerificationCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SignInUser */
export type SignInUserPayload = {
  __typename?: 'SignInUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of SignOutUser */
export type SignOutUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of SkipContainer */
export type SkipContainerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  containerId: Scalars['ID']['input'];
};

/** Autogenerated return type of SkipContainer */
export type SkipContainerPayload = {
  __typename?: 'SkipContainerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type Statement = {
  __typename?: 'Statement';
  displayName: Scalars['String']['output'];
  fileKey: Scalars['ID']['output'];
};

export type StreakActionCount = {
  __typename?: 'StreakActionCount';
  actionCount: Scalars['Int']['output'];
  source: TransactionSourceEnum;
};

export type StreakActionSummary = {
  __typename?: 'StreakActionSummary';
  actions: Array<StreakActionCount>;
  date: Scalars['ISO8601Date']['output'];
};

export type StreakDetails = {
  __typename?: 'StreakDetails';
  currentStreakDays?: Maybe<Scalars['Int']['output']>;
  dailyActionSummary?: Maybe<Array<StreakActionSummary>>;
  longestStreakDays?: Maybe<Scalars['Int']['output']>;
};

export enum StreaksSourceEnum {
  /** Colony Dividends */
  ColonyDividends = 'ColonyDividends',
  /** Course Dividends */
  CourseDividends = 'CourseDividends',
  /** Data Reward */
  DataReward = 'DataReward',
  /** Game Dividends */
  GameDividends = 'GameDividends',
  /** Location Dividends */
  LocationDividends = 'LocationDividends',
  /** Reward Dividends */
  RewardDividends = 'RewardDividends',
  /** Streak Bonus */
  StreakBonus = 'StreakBonus',
  /** Survey Dividends */
  SurveyDividends = 'SurveyDividends',
  /** Widget Bonus */
  WidgetBonus = 'WidgetBonus'
}

export type StreakstakesEntry = {
  __typename?: 'StreakstakesEntry';
  entryCount: Scalars['Int']['output'];
  source: StreaksSourceEnum;
};

export type StreakstakesEvent = {
  __typename?: 'StreakstakesEvent';
  endDate: Scalars['ISO8601DateTime']['output'];
  entries?: Maybe<Array<StreakstakesEntry>>;
  /** @deprecated User prizeTiers instead */
  prizeAmount: Scalars['Int']['output'];
  prizeTiers: Array<StreakstakesPrizeTier>;
  /** @deprecated Use prizeTiers instead */
  prizeWinners: Scalars['Int']['output'];
  startDate: Scalars['ISO8601DateTime']['output'];
  winners?: Maybe<Array<StreakstakesWinner>>;
};

export type StreakstakesPrizeTier = {
  __typename?: 'StreakstakesPrizeTier';
  amount: Scalars['Int']['output'];
  numberOfWinners: Scalars['Int']['output'];
};

export type StreakstakesWinner = {
  __typename?: 'StreakstakesWinner';
  amount: Scalars['Int']['output'];
  entryCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type StyledButton = {
  __typename?: 'StyledButton';
  buttonColor?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Autogenerated input type of SubmitCashAdvanceApplication */
export type SubmitCashAdvanceApplicationInput = {
  cashAdvanceApplicationId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SubmitCashAdvanceApplication */
export type SubmitCashAdvanceApplicationPayload = {
  __typename?: 'SubmitCashAdvanceApplicationPayload';
  cashAdvanceApplication?: Maybe<CashAdvanceApplication>;
  cashAdvanceEvaluation?: Maybe<CashAdvanceEvaluation>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of SubmitIntegrityResponse */
export type SubmitIntegrityResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientResponse: Scalars['String']['input'];
};

/** Autogenerated return type of SubmitIntegrityResponse */
export type SubmitIntegrityResponsePayload = {
  __typename?: 'SubmitIntegrityResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deviceIntegrity: DeviceIntegrity;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of SubmitInvestmentApplication */
export type SubmitInvestmentApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  investmentApplication: InvestmentApplicationInput;
};

/** Autogenerated return type of SubmitInvestmentApplication */
export type SubmitInvestmentApplicationPayload = {
  __typename?: 'SubmitInvestmentApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investmentAccount?: Maybe<InvestmentAccount>;
};

export type Subscription = {
  __typename?: 'Subscription';
  activeAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  inactiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  initialFeeChargedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nextFeeChargedAt: Scalars['ISO8601DateTime']['output'];
  product: SubscriptionProduct;
  productKey: SubscriptionProductEnum;
  proratedRefundAmount?: Maybe<Scalars['Float']['output']>;
  status: CashAdvanceSubscriptionStatus;
};

export type SubscriptionFee = {
  __typename?: 'SubscriptionFee';
  amount: Scalars['Float']['output'];
  chargedAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastPaymentAttemptAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum SubscriptionFeeSchedule {
  /** Monthly */
  Monthly = 'monthly',
  /** Weekly */
  Weekly = 'weekly'
}

export type SubscriptionProduct = {
  __typename?: 'SubscriptionProduct';
  description: Scalars['String']['output'];
  features: Array<SubscriptionProductFeature>;
  fee: Scalars['Float']['output'];
  feeSchedule: SubscriptionFeeSchedule;
  footnotes: Array<Scalars['String']['output']>;
  key: SubscriptionProductEnum;
  name: Scalars['String']['output'];
  trialDurationDays: Scalars['Int']['output'];
};

export enum SubscriptionProductEnum {
  /** Cash Advance */
  InstantCash = 'instant_cash',
  /** Personal Finance Trial */
  PersonalFinanceTrial = 'personal_finance_trial',
  /** ATM Premium */
  Premium = 'premium',
  /** Just for testing */
  WeeklyTest = 'weekly_test'
}

export type SubscriptionProductFeature = {
  __typename?: 'SubscriptionProductFeature';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Survey = BasePartnerOffer & WithTimestamps & {
  __typename?: 'Survey';
  /** The card description for an offer */
  cardDescription?: Maybe<Scalars['String']['output']>;
  /** The card headline for an offer */
  cardHeadline?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The call to action of an offer */
  cta?: Maybe<Scalars['String']['output']>;
  /** The click url for a user offer */
  ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum;
  /** The click url for a user offer */
  ctaUrl?: Maybe<Scalars['String']['output']>;
  /** Details about an offer */
  description?: Maybe<Scalars['String']['output']>;
  /** Legal notice related an offer in Markdown syntax. Normally includes Terms and Conditions */
  disclosure?: Maybe<Scalars['String']['output']>;
  /**
   * The click url for a user offer
   * @deprecated Prefer cta_click_behavior instead
   */
  externalCtaUrl: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The response the user made for this offer */
  myResponse?: Maybe<UserPartnerBidResponse>;
  /** The type of offer */
  offerType: PartnerOfferTypeEnum;
  /** The partner for an offer */
  partner: Partner;
  /** The potential reward for this offer that can be earned. */
  potentialRewardTotal?: Maybe<PartnerOfferPotentialRewardTotal>;
  /** The savings amount for this offer */
  savingsAmount?: Maybe<Scalars['String']['output']>;
  /** The Served Impression ID that was served to the user. */
  servedImpressionId: Scalars['ID']['output'];
  /** Whether or not to skip the offer details page */
  skipOfferDetails: Scalars['Boolean']['output'];
  /** The url linking to the terms and conditions for an offer */
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  /** The time it takes to complete the survey (in minutes by default) */
  timeToComplete?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SwitchSubscriptionError = Error | InvalidSubscriptionTransitionError;

/** Autogenerated input type of SwitchSubscription */
export type SwitchSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newProductKey: SubscriptionProductEnum;
  subscriptionId: Scalars['ID']['input'];
};

/** Autogenerated return type of SwitchSubscription */
export type SwitchSubscriptionPayload = {
  __typename?: 'SwitchSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<SwitchSubscriptionError>>;
  subscription?: Maybe<Subscription>;
};

/** TabaPay Card Input Object */
export type TabaPayCard = {
  /** Encrypted card data */
  encryptedCardData: Scalars['String']['input'];
  /** ID of the key used to excrypt the card */
  encryptedCardKeyId: Scalars['String']['input'];
};

/** Base Transaction Type */
export type Transaction = {
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Transaction. */
export type TransactionConnection = {
  __typename?: 'TransactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TransactionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Transaction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TransactionEdge = {
  __typename?: 'TransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Transaction>;
};

export type TransactionExport = {
  __typename?: 'TransactionExport';
  /** CSV content of the transaction export */
  csv: Scalars['String']['output'];
};

export type TransactionNotFoundError = ErrorInterface & {
  __typename?: 'TransactionNotFoundError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export enum TransactionSourceEnum {
  /** Colony Dividends */
  ColonyDividends = 'ColonyDividends',
  /** Course Dividends */
  CourseDividends = 'CourseDividends',
  /** Data Reward */
  DataReward = 'DataReward',
  /** Game Dividends */
  GameDividends = 'GameDividends',
  /** Location Dividends */
  LocationDividends = 'LocationDividends',
  /** Reward Dividends */
  RewardDividends = 'RewardDividends',
  /** Survey Dividends */
  SurveyDividends = 'SurveyDividends'
}

export enum TransactionStatusEnum {
  /** Charged Back */
  ChargeBack = 'ChargeBack',
  /** Earned */
  Earned = 'Earned',
  /** Failed */
  Failed = 'Failed',
  /** On Hold */
  Hold = 'Hold',
  /** Pending */
  Pending = 'Pending',
  /** Pending */
  PendingEarned = 'PendingEarned',
  /** Settled */
  Settled = 'Settled',
  /** Pending */
  TransferPending = 'TransferPending',
  /** Voided */
  Voided = 'Voided'
}

/** Autogenerated input type of UnlinkBankAccount */
export type UnlinkBankAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlinkBankAccount */
export type UnlinkBankAccountPayload = {
  __typename?: 'UnlinkBankAccountPayload';
  bankAccount?: Maybe<BankAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type UpdatePaymentAccountExpirationError = AccountDoesNotMatchError | AccountTypeError | AddressVerificationError | BadRequest | CvvVerificationError | CardDeclinedError | CardHolderNameVerificationError | Conflict | Error | InvalidAddressError | InvalidCardNumberError | InvalidExpirationDateError | PaymentAccountLinkedOverLimitError;

/** Autogenerated input type of UpdatePaymentAccountExpiration */
export type UpdatePaymentAccountExpirationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  tabaPayCard?: InputMaybe<TabaPayCard>;
};

/** Autogenerated return type of UpdatePaymentAccountExpiration */
export type UpdatePaymentAccountExpirationPayload = {
  __typename?: 'UpdatePaymentAccountExpirationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UpdatePaymentAccountExpirationError>>;
  paymentAccount?: Maybe<BankAccount>;
};

/** Autogenerated input type of UpdatePaymentAccount */
export type UpdatePaymentAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  requireReauth?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdatePaymentAccount */
export type UpdatePaymentAccountPayload = {
  __typename?: 'UpdatePaymentAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  paymentAccount?: Maybe<BankAccount>;
};

/** Autogenerated input type of UpdatePhone */
export type UpdatePhoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phone: Phone;
};

/** Autogenerated return type of UpdatePhone */
export type UpdatePhonePayload = {
  __typename?: 'UpdatePhonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['ISO8601Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUser */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Input Type for updating a recurring deposit */
export type UpdateUserRecurringDeposit = {
  amount?: InputMaybe<Scalars['String']['input']>;
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  depositInterval?: InputMaybe<DepositIntervalEnum>;
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateUserRecurringDeposit */
export type UpdateUserRecurringDepositInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  recurringDeposit: UpdateUserRecurringDeposit;
};

/** Autogenerated return type of UpdateUserRecurringDeposit */
export type UpdateUserRecurringDepositPayload = {
  __typename?: 'UpdateUserRecurringDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userRecurringDeposit?: Maybe<UserRecurringDepositConfiguration>;
};

export type UpsertBudgetErrors = BudgetNotFoundError | Error | GenericBudgetError;

/** Autogenerated input type of UpsertBudget */
export type UpsertBudgetInput = {
  amount: Scalars['Float']['input'];
  category: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inactiveAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  month: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of UpsertBudget */
export type UpsertBudgetPayload = {
  __typename?: 'UpsertBudgetPayload';
  budget?: Maybe<Budget>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UpsertBudgetErrors>>;
};

/** Autogenerated input type of UpsertUserFeatureOptIn */
export type UpsertUserFeatureOptInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feature: Scalars['String']['input'];
  optedIn?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpsertUserFeatureOptIn */
export type UpsertUserFeatureOptInPayload = {
  __typename?: 'UpsertUserFeatureOptInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  userFeatureOptIn?: Maybe<UserFeatureOptIn>;
};

export type User = {
  __typename?: 'User';
  accountTaskLists?: Maybe<AccountTaskListConnection>;
  /** Active experiments for a user. */
  activeExperiments?: Maybe<Array<ActiveExperiment>>;
  addresses?: Maybe<Array<Address>>;
  broker?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has completed all the demographic DataVault container questions. */
  completedDemographicQuestions: Scalars['Boolean']['output'];
  confirmationSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  directorOf?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated Naming */
  eligibleForWithdrawal: Array<WithdrawalEligibilityEnum>;
  email?: Maybe<Scalars['String']['output']>;
  emailConfirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  employmentStatus?: Maybe<EmploymentStatusEnum>;
  featureOptIns?: Maybe<Array<UserFeatureOptIn>>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  investmentAccounts?: Maybe<Array<InvestmentAccount>>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** All the categories for a user */
  myCategories?: Maybe<PartnerOfferCategoryConnection>;
  /** All partner offer tags */
  myPartnerTags?: Maybe<PartnerOfferTagConnection>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneConfirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Additional details related to your phone number. */
  phoneDetail?: Maybe<PhoneDetail>;
  politicallyExposedNames?: Maybe<Scalars['String']['output']>;
  /** Potential reward totals */
  potentialCampaignRewardTotal?: Maybe<PotentialCampaignRewardTotalConnection>;
  registrationCompletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  /** Target cash percentage from 0-100 */
  targetCashPercentage: Scalars['Int']['output'];
  token?: Maybe<Scalars['String']['output']>;
  userRecurringDepositConfigurations?: Maybe<Array<UserRecurringDepositConfiguration>>;
  withdrawalEligibilityStatuses?: Maybe<Array<WithdrawalEligibilityEnum>>;
};


export type UserAccountTaskListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserMyCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserMyPartnerTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserPotentialCampaignRewardTotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** User Address input type */
export type UserAddress = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-2 formatted administrative area (division such as state or provence) */
  administrativeArea?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Locality / City */
  locality?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

/** User Attribution input type for tracking registration sources and device information */
export type UserAttribution = {
  /** Mobile application version number (e.g., 1.2.3) */
  appVersion?: InputMaybe<Scalars['String']['input']>;
  /** Branch.io deep linking match identifier */
  branchMatchId?: InputMaybe<Scalars['String']['input']>;
  /** Unique browser identifier generated from device characteristics */
  browserFingerprint?: InputMaybe<Scalars['String']['input']>;
  /** Tracking identifier for affiliate marketing clicks */
  clickId?: InputMaybe<Scalars['String']['input']>;
  /** Device hardware model (e.g., iPhone 14 Pro, Samsung Galaxy S23) */
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  /** User's IPv4 address for geolocation and tracking */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  /** User's operating system name (e.g., iOS, Android, Windows, macOS) */
  os?: InputMaybe<Scalars['String']['input']>;
  /** Operating system version number (e.g., 16.5, 13.0) */
  osVersion?: InputMaybe<Scalars['String']['input']>;
  /** Registration platform (web, ios, android) */
  platform?: InputMaybe<Scalars['String']['input']>;
  /** Screen height in pixels */
  screenHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Screen width in pixels */
  screenWidth?: InputMaybe<Scalars['Int']['input']>;
  /** Unique identifier for the user's current session */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  /** Browser's user agent string containing browser and system information */
  userAgent?: InputMaybe<Scalars['String']['input']>;
  /** Specific marketing campaign identifier (e.g., spring_sale_2024) */
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  /** Differentiates similar content or links within the same ad (e.g., logo_link vs text_link) */
  utmContent?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the marketing campaign */
  utmId?: InputMaybe<Scalars['String']['input']>;
  /** Marketing medium or method used (e.g., cpc, email, social, referral) */
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  /** Marketing source that directed the user (e.g., google, facebook, linkedin) */
  utmSource?: InputMaybe<Scalars['String']['input']>;
  /** Paid search keywords or terms used in the campaign */
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type UserDataVaultQuestionResponse = {
  __typename?: 'UserDataVaultQuestionResponse';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  value: Scalars['String']['output'];
};

export type UserFeatureOptIn = {
  __typename?: 'UserFeatureOptIn';
  feature: Scalars['String']['output'];
  optedIn: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
};

export type UserOnetimeDeposit = Transaction & {
  __typename?: 'UserOnetimeDeposit';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type UserPartnerBidResponse = WithTimestamps & {
  __typename?: 'UserPartnerBidResponse';
  /** The action taken for this data-date */
  actionChoice: ActionChoiceEnum;
  /** When the data-date was responded to */
  actionTakenAt: Scalars['ISO8601DateTime']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type UserRecurringDeposit = Transaction & {
  __typename?: 'UserRecurringDeposit';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A Users recurring deposit configuration */
export type UserRecurringDepositConfiguration = {
  __typename?: 'UserRecurringDepositConfiguration';
  amount?: Maybe<Scalars['Float']['output']>;
  bankAccountId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  depositInterval?: Maybe<DepositIntervalEnum>;
  id?: Maybe<Scalars['ID']['output']>;
  scheduledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type WithTimestamps = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Withdrawal = Transaction & {
  __typename?: 'Withdrawal';
  amount: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<Scalars['String']['output']>;
  iconImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: TransactionStatusEnum;
  subtag?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum WithdrawalEligibilityEnum {
  /** User is eligible for withdrawal */
  Eligible = 'ELIGIBLE',
  /** User has not confirmed their attached email */
  UnconfirmedEmail = 'UNCONFIRMED_EMAIL',
  /**
   * User has an in-flight withdrawal
   * @deprecated Advisor system now supports multiple in-flight withdrawals
   */
  WithdrawalInProgress = 'WITHDRAWAL_IN_PROGRESS'
}

/** Withdrawal request input type */
export type WithdrawalRequest = {
  amount: Scalars['String']['input'];
};

export type UserFragmentFragment = { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, token?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null };

export type PotentialRewardsFragmentFragment = { __typename?: 'User', potentialCampaignRewardTotal?: { __typename?: 'PotentialCampaignRewardTotalConnection', edges?: Array<{ __typename?: 'PotentialCampaignRewardTotalEdge', cursor: string, node?: { __typename?: 'PotentialCampaignRewardTotal', amount?: string | null, partnerId?: string | null } | null } | null> | null, nodes?: Array<{ __typename?: 'PotentialCampaignRewardTotal', amount?: string | null, partnerId?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type ActiveExperimentsFragmentFragment = { __typename?: 'User', activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null };

export type CreateUserPayloadFragmentFragment = { __typename?: 'CreateUserPayload', errors?: Array<{ __typename?: 'AccountDoesNotMatchError' } | { __typename?: 'AccountTypeError' } | { __typename?: 'AddressVerificationError' } | { __typename?: 'BadRequest' } | { __typename?: 'BudgetNotFoundError' } | { __typename?: 'CVVVerificationError' } | { __typename?: 'CardDeclinedError' } | { __typename?: 'CardHolderNameVerificationError' } | { __typename?: 'CommonError' } | { __typename?: 'Conflict' } | { __typename?: 'CreateClosureRequestAlreadyClosingError' } | { __typename?: 'CreateClosureRequestCashAdvanceRequestNotRepaidError' } | { __typename?: 'CreateClosureRequestUnableToRetrieveACHAccountNumberError' } | { __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'EvaluationAlreadyRunError' } | { __typename?: 'ExistingSubscriptionError' } | { __typename?: 'GenericBudgetError' } | { __typename?: 'GenericCalibrationError' } | { __typename?: 'GenericError' } | { __typename?: 'InvalidAddressError' } | { __typename?: 'InvalidCardNumberError' } | { __typename?: 'InvalidExpirationDateError' } | { __typename?: 'InvalidSubscriptionTransitionError' } | { __typename?: 'InvalidUserAttributionError' } | { __typename?: 'NoLinkedCardError' } | { __typename?: 'NoOutStandingFeeError' } | { __typename?: 'NoPaymentAccountError' } | { __typename?: 'NotSupportedSubscriptionProductError' } | { __typename?: 'OAuthCreateUserExistingOAuthError' } | { __typename?: 'OAuthCreateUserExistingUserError' } | { __typename?: 'OAuthCreateUserInvalidTokenError' } | { __typename?: 'OAuthCreateUserTokenExpiredError' } | { __typename?: 'OAuthSignInNotRegisteredError' } | { __typename?: 'OAuthSignInUserInvalidTokenError' } | { __typename?: 'OAuthSignInUserTokenExpiredError' } | { __typename?: 'PauseCashAdvanceSubscriptionActiveAdvanceError' } | { __typename?: 'PauseCashAdvanceSubscriptionCanceledError' } | { __typename?: 'PauseCashAdvanceSubscriptionInactiveError' } | { __typename?: 'PauseCashAdvanceSubscriptionNoSubscriptionError' } | { __typename?: 'PauseSubscriptionActiveAdvanceError' } | { __typename?: 'PauseSubscriptionCanceledError' } | { __typename?: 'PauseSubscriptionInactiveError' } | { __typename?: 'PauseSubscriptionNoSubscriptionError' } | { __typename?: 'PaymentAccountLinkedOverLimitError' } | { __typename?: 'RateLimitExceeded' } | { __typename?: 'ReferralNotFoundError' } | { __typename?: 'RefreshTransactionsUnauthorizedError' } | { __typename?: 'ResumeCashAdvanceSubscriptionActiveError' } | { __typename?: 'ResumeCashAdvanceSubscriptionCanceledError' } | { __typename?: 'ResumeCashAdvanceSubscriptionNoSubscriptionError' } | { __typename?: 'ResumeSubscriptionActiveError' } | { __typename?: 'ResumeSubscriptionCanceledError' } | { __typename?: 'ResumeSubscriptionNoSubscriptionError' } | { __typename?: 'SaveError' } | { __typename?: 'TransactionNotFoundError' }> | null, user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, token?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null } };

export type SignInUserPayloadFragmentFragment = { __typename?: 'SignInUserPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null, user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, token?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null } | null };

export type ConfirmEmailPayloadFragmentFragment = { __typename?: 'ConfirmEmailPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null };

export type ConfirmPhonePayloadFragmentFragment = { __typename?: 'ConfirmPhonePayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null };

export type ResetPasswordPayloadFragmentFragment = { __typename?: 'ResetPasswordPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null };

export type ErrorFragmentFragment = { __typename?: 'Error', message: string, path: Array<string> };

type OAuthAccountCreationError_Error_Fragment = { __typename?: 'Error', message: string, path: Array<string> };

type OAuthAccountCreationError_OAuthCreateUserExistingOAuthError_Fragment = { __typename?: 'OAuthCreateUserExistingOAuthError', message: string, path: Array<string> };

type OAuthAccountCreationError_OAuthCreateUserExistingUserError_Fragment = { __typename?: 'OAuthCreateUserExistingUserError', message: string, path: Array<string> };

type OAuthAccountCreationError_OAuthCreateUserInvalidTokenError_Fragment = { __typename?: 'OAuthCreateUserInvalidTokenError', message: string, path: Array<string> };

type OAuthAccountCreationError_OAuthCreateUserTokenExpiredError_Fragment = { __typename?: 'OAuthCreateUserTokenExpiredError', message: string, path: Array<string> };

export type OAuthAccountCreationErrorFragment = OAuthAccountCreationError_Error_Fragment | OAuthAccountCreationError_OAuthCreateUserExistingOAuthError_Fragment | OAuthAccountCreationError_OAuthCreateUserExistingUserError_Fragment | OAuthAccountCreationError_OAuthCreateUserInvalidTokenError_Fragment | OAuthAccountCreationError_OAuthCreateUserTokenExpiredError_Fragment;

type OAuthAccountSignInError_Error_Fragment = { __typename?: 'Error', message: string, path: Array<string> };

type OAuthAccountSignInError_OAuthSignInNotRegisteredError_Fragment = { __typename?: 'OAuthSignInNotRegisteredError', message: string, path: Array<string> };

type OAuthAccountSignInError_OAuthSignInUserInvalidTokenError_Fragment = { __typename?: 'OAuthSignInUserInvalidTokenError', message: string, path: Array<string> };

type OAuthAccountSignInError_OAuthSignInUserTokenExpiredError_Fragment = { __typename?: 'OAuthSignInUserTokenExpiredError', message: string, path: Array<string> };

export type OAuthAccountSignInErrorFragment = OAuthAccountSignInError_Error_Fragment | OAuthAccountSignInError_OAuthSignInNotRegisteredError_Fragment | OAuthAccountSignInError_OAuthSignInUserInvalidTokenError_Fragment | OAuthAccountSignInError_OAuthSignInUserTokenExpiredError_Fragment;

export type CategoryFragmentFragment = { __typename?: 'Category', name: string };

export type QuestionContainerFragmentFragment = { __typename?: 'QuestionContainer', id: string, buttonLabel?: string | null, name: string, category: { __typename?: 'Category', name: string }, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', falseOptionLabel?: string | null, trueOptionLabel?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', placeholderText?: string | null, currencyCode: string, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'StyledButton', buttonColor?: string | null, label: string, shortDescription?: string | null, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null };

export type ButtonFragmentFragment = { __typename?: 'Button', label: string, value: string };

type QuestionFragment_InputAdministrativeArea_Fragment = { __typename?: 'InputAdministrativeArea', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null };

type QuestionFragment_InputBoolean_Fragment = { __typename?: 'InputBoolean', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null };

type QuestionFragment_InputButtonSelection_Fragment = { __typename?: 'InputButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null };

type QuestionFragment_InputCurrency_Fragment = { __typename?: 'InputCurrency', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null };

type QuestionFragment_InputDate_Fragment = { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null };

type QuestionFragment_InputGroup_Fragment = { __typename?: 'InputGroup', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null };

type QuestionFragment_InputListSelection_Fragment = { __typename?: 'InputListSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null };

type QuestionFragment_InputNumber_Fragment = { __typename?: 'InputNumber', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null };

type QuestionFragment_InputPostalCode_Fragment = { __typename?: 'InputPostalCode', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null };

type QuestionFragment_InputStyledButtonSelection_Fragment = { __typename?: 'InputStyledButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null };

type QuestionFragment_InputText_Fragment = { __typename?: 'InputText', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null };

export type QuestionFragmentFragment = QuestionFragment_InputAdministrativeArea_Fragment | QuestionFragment_InputBoolean_Fragment | QuestionFragment_InputButtonSelection_Fragment | QuestionFragment_InputCurrency_Fragment | QuestionFragment_InputDate_Fragment | QuestionFragment_InputGroup_Fragment | QuestionFragment_InputListSelection_Fragment | QuestionFragment_InputNumber_Fragment | QuestionFragment_InputPostalCode_Fragment | QuestionFragment_InputStyledButtonSelection_Fragment | QuestionFragment_InputText_Fragment;

export type InputGroupFragmentFragment = { __typename?: 'InputGroup', questions?: Array<{ __typename?: 'InputAdministrativeArea', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null };

export type InputButtonSelectionFragmentFragment = { __typename?: 'InputButtonSelection', buttons: Array<{ __typename?: 'Button', label: string, value: string }> };

export type InputSelectionListFragmentFragment = { __typename?: 'InputListSelection', options: Array<{ __typename?: 'Option', label: string, value: string }> };

export type InputStyledButtonSelectionFragmentFragment = { __typename?: 'InputStyledButtonSelection', buttons: Array<{ __typename?: 'StyledButton', buttonColor?: string | null, label: string, shortDescription?: string | null, value: string }> };

export type StyledButtonFragmentFragment = { __typename?: 'StyledButton', buttonColor?: string | null, label: string, shortDescription?: string | null, value: string };

export type OptionFragmentFragment = { __typename?: 'Option', label: string, value: string };

export type UserDataVaultQuestionResponseFragmentFragment = { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null };

export type PartnerBidFragmentFragment = { __typename?: 'PartnerBid', activeFrom?: any | null, activeTo?: any | null, id: string, name?: string | null, dataVaultContainers?: Array<{ __typename?: 'QuestionContainer', id: string, buttonLabel?: string | null, name: string, category: { __typename?: 'Category', name: string }, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', falseOptionLabel?: string | null, trueOptionLabel?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', placeholderText?: string | null, currencyCode: string, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'StyledButton', buttonColor?: string | null, label: string, shortDescription?: string | null, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null }> | null, partner: { __typename?: 'Partner', id: string, dataUsageDescription?: string | null, description?: string | null, iconUrl?: string | null, bannerUrl?: string | null, name: string, shortDescription?: string | null }, reward?: { __typename?: 'PartnerBidReward', amount?: string | null, type: PartnerBidRewardEnum } | null };

export type PartnerFragmentFragment = { __typename?: 'Partner', id: string, dataUsageDescription?: string | null, description?: string | null, iconUrl?: string | null, bannerUrl?: string | null, name: string, shortDescription?: string | null };

export type PartnerBidRewardFragmentFragment = { __typename?: 'PartnerBidReward', amount?: string | null, type: PartnerBidRewardEnum };

export type PartnerBidResponsePayloadFragmentFragment = { __typename?: 'PartnerBidResponsePayload', bidResponseId?: string | null, offerId?: string | null, categoryId?: string | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null };

export type BalanceFragmentFragment = { __typename?: 'Balance', available?: string | null, total?: string | null, availableToWithdraw?: string | null, cashTotal?: string | null, cumulativeEarned?: string | null, pending?: string | null };

export type QuestionImageFragmentFragment = { __typename?: 'QuestionImage', url: string };

export type BankAccountFragmentFragment = { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, deletedAt?: string | null, displayAccountNumber?: string | null, gatewayWithdrawalFee?: string | null, id: string, logo?: string | null, name?: string | null, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null };

export type CreateChatTokenPayloadFragmentFragment = { __typename?: 'CreateChatTokenPayload', chatUser?: { __typename?: 'ChatUser', identity?: string | null, token?: string | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null };

export type ChatUserFragmentFragment = { __typename?: 'ChatUser', identity?: string | null, token?: string | null };

export type TransactionEdgeFragmentFragment = { __typename?: 'TransactionEdge', cursor: string, node?: { __typename?: 'AtmSubscriptionFee', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'AtmSubscriptionFeePayment', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvance', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceRepayment', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceTip', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceTransferFee', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'DataDividend', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InactivityFeeDisplay', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InvestmentDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InvestmentWithdrawal', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'UserOnetimeDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'UserRecurringDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'Withdrawal', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | null };

type TransactionFragment_AtmSubscriptionFee_Fragment = { __typename?: 'AtmSubscriptionFee', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null };

type TransactionFragment_AtmSubscriptionFeePayment_Fragment = { __typename?: 'AtmSubscriptionFeePayment', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null };

type TransactionFragment_CashAdvance_Fragment = { __typename?: 'CashAdvance', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null };

type TransactionFragment_CashAdvanceRepayment_Fragment = { __typename?: 'CashAdvanceRepayment', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null };

type TransactionFragment_CashAdvanceTip_Fragment = { __typename?: 'CashAdvanceTip', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null };

type TransactionFragment_CashAdvanceTransferFee_Fragment = { __typename?: 'CashAdvanceTransferFee', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null };

type TransactionFragment_DataDividend_Fragment = { __typename?: 'DataDividend', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null };

type TransactionFragment_InactivityFeeDisplay_Fragment = { __typename?: 'InactivityFeeDisplay', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null };

type TransactionFragment_InvestmentDeposit_Fragment = { __typename?: 'InvestmentDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null };

type TransactionFragment_InvestmentWithdrawal_Fragment = { __typename?: 'InvestmentWithdrawal', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null };

type TransactionFragment_UserOnetimeDeposit_Fragment = { __typename?: 'UserOnetimeDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null };

type TransactionFragment_UserRecurringDeposit_Fragment = { __typename?: 'UserRecurringDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null };

type TransactionFragment_Withdrawal_Fragment = { __typename?: 'Withdrawal', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null };

export type TransactionFragmentFragment = TransactionFragment_AtmSubscriptionFee_Fragment | TransactionFragment_AtmSubscriptionFeePayment_Fragment | TransactionFragment_CashAdvance_Fragment | TransactionFragment_CashAdvanceRepayment_Fragment | TransactionFragment_CashAdvanceTip_Fragment | TransactionFragment_CashAdvanceTransferFee_Fragment | TransactionFragment_DataDividend_Fragment | TransactionFragment_InactivityFeeDisplay_Fragment | TransactionFragment_InvestmentDeposit_Fragment | TransactionFragment_InvestmentWithdrawal_Fragment | TransactionFragment_UserOnetimeDeposit_Fragment | TransactionFragment_UserRecurringDeposit_Fragment | TransactionFragment_Withdrawal_Fragment;

export type PageInfoFragmentFragment = { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null };

export type TransactionConnectionFragmentFragment = { __typename?: 'TransactionConnection', edges?: Array<{ __typename?: 'TransactionEdge', cursor: string, node?: { __typename?: 'AtmSubscriptionFee', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'AtmSubscriptionFeePayment', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvance', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceRepayment', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceTip', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceTransferFee', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'DataDividend', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InactivityFeeDisplay', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InvestmentDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InvestmentWithdrawal', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'UserOnetimeDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'UserRecurringDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'Withdrawal', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | null } | null> | null, nodes?: Array<{ __typename?: 'AtmSubscriptionFee', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'AtmSubscriptionFeePayment', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvance', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceRepayment', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceTip', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceTransferFee', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'DataDividend', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InactivityFeeDisplay', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InvestmentDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InvestmentWithdrawal', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'UserOnetimeDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'UserRecurringDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'Withdrawal', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } };

export type PotentialCampaignRewardTotalConnectionFragmentFragment = { __typename?: 'PotentialCampaignRewardTotalConnection', edges?: Array<{ __typename?: 'PotentialCampaignRewardTotalEdge', cursor: string, node?: { __typename?: 'PotentialCampaignRewardTotal', amount?: string | null, partnerId?: string | null } | null } | null> | null, nodes?: Array<{ __typename?: 'PotentialCampaignRewardTotal', amount?: string | null, partnerId?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } };

export type PotentialCampaignRewardTotalFragmentFragment = { __typename?: 'PotentialCampaignRewardTotal', amount?: string | null, partnerId?: string | null };

export type PotentialCampaignRewardTotalEdgeFragmentFragment = { __typename?: 'PotentialCampaignRewardTotalEdge', cursor: string, node?: { __typename?: 'PotentialCampaignRewardTotal', amount?: string | null, partnerId?: string | null } | null };

export type AppSettingsFragmentFragment = { __typename?: 'AppSettings', depositMinLimit: number, depositMaxLimit: number, withdrawalMaxLimit: number, withdrawalMinLimit: number, withdrawalMinBalanceCopy: string, availableBalanceInfoCopy: string, lifetimeEarningsInfoCopy: string, pendingBalanceInfoCopy: string, sessionInactivityPeriod: number, unifiedLogin: boolean, rpSearchPlaceholderCopy: string, rpHomeTagCopy: string, rpCategoryPaginationAmount: number, tutorialHighlightedRpCategoryId: string, tutorialHighlightedRpTagId: string, accountStrengthCardHeaderCopy: string, accountStrengthIncentiveCopy: string };

export type SkipContainerPayloadFragmentFragment = { __typename?: 'SkipContainerPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null };

export type AddressFragmentFragment = { __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null };

export type ReferralFragmentFragment = { __typename?: 'Referral', code: string, referrerName?: string | null, rewardAmount: string, rewardCriteria: ReferralRewardCriteriaEnum, rewardCriteriaDescription: string, history: Array<{ __typename?: 'ReferralHistory', amount: string, createdAt: any, firstName?: string | null, lastName?: string | null, qualifiedAt?: any | null, rewardCriteria: ReferralRewardCriteriaEnum }> };

export type ReferralHistoryFragmentFragment = { __typename?: 'ReferralHistory', amount: string, createdAt: any, firstName?: string | null, lastName?: string | null, qualifiedAt?: any | null, rewardCriteria: ReferralRewardCriteriaEnum };

export type PlaidLinkTokenFragmentFragment = { __typename?: 'PlaidLinkToken', expiration?: any | null, linkToken?: string | null };

export type ActiveExperimentFragmentFragment = { __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null };

export type ClientEventFragmentFragment = { __typename?: 'ClientEvent', data?: any | null, name: string, partnerId?: string | null, partnerOfferId?: string | null, requestId: string, servedImpressionId?: string | null };

export type AccountTaskFragmentFragment = { __typename?: 'AccountTask', currentCompletions: number, deepLink: string, description: string, icon: string, instruction?: string | null, targetCompletions: number };

export type DealFragmentFragment = { __typename?: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } };

type PartnerOfferUnionFragment_Deal_Fragment = { __typename?: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } };

type PartnerOfferUnionFragment_Survey_Fragment = { __typename?: 'Survey' };

export type PartnerOfferUnionFragmentFragment = PartnerOfferUnionFragment_Deal_Fragment | PartnerOfferUnionFragment_Survey_Fragment;

type OfferForBidFragment_Deal_Fragment = { __typename?: 'Deal', id: string, servedImpressionId: string, offerType: PartnerOfferTypeEnum, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null };

type OfferForBidFragment_Survey_Fragment = { __typename?: 'Survey', id: string, servedImpressionId: string, offerType: PartnerOfferTypeEnum, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null };

export type OfferForBidFragmentFragment = OfferForBidFragment_Deal_Fragment | OfferForBidFragment_Survey_Fragment;

export type PartnerOfferCategoryDisplayStylingFragmentFragment = { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null };

export type PartnerOfferCategoryFragmentFragment = { __typename?: 'PartnerOfferCategory', id: string, name: string, bannerUrl?: string | null, priorityOrder?: number | null, displayMetadata: { __typename?: 'PartnerOfferCategoryDisplayMetadata', viewAllPaginationAmount: number, detailDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null }, mainDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null } } };

export type MonitoredBankAccountFragmentFragment = { __typename?: 'MonitoredBankAccount', balance?: number | null, balanceLastUpdatedAt?: any | null, createdAt: any, deletedAt?: string | null, displayAccountNumber?: string | null, id: string, logo?: string | null, name?: string | null, requireReauth?: boolean | null, subtype?: MonitoredBankAccountSubtypeEnum | null, type?: MonitoredBankAccountTypeEnum | null };

export type MonitoredBankAccountFragmentNoTypeFragment = { __typename?: 'MonitoredBankAccount', balance?: number | null, balanceLastUpdatedAt?: any | null, createdAt: any, deletedAt?: string | null, displayAccountNumber?: string | null, id: string, logo?: string | null, name?: string | null, requireReauth?: boolean | null };

export type MonitoredBankAccountTransactionFragmentFragment = { __typename?: 'MonitoredBankAccountTransaction', amount: number, date: any, deleted: boolean, detailedCategory?: string | null, id: string, ignored: boolean, merchantLogoUrl?: string | null, merchantName?: string | null, monitoredBankAccountId: string, name: string, nameOverride?: string | null, needsCategorization: boolean, paymentChannel?: PaymentChannelEnum | null, pending: boolean, primaryCategory?: string | null, primaryCategoryOverride?: string | null, recurringTransactionId?: string | null, updatedAt: any, website?: string | null, location?: { __typename?: 'Location', address?: string | null, city?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, postalCode?: string | null, region?: string | null, storeNumber?: string | null } | null };

export type LocationFragmentFragment = { __typename?: 'Location', address?: string | null, city?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, postalCode?: string | null, region?: string | null, storeNumber?: string | null };

export type SignInMutationVariables = Exact<{
  signInUserInput: SignInUserInput;
}>;


export type SignInMutation = { __typename?: 'Mutation', signInUser?: { __typename?: 'SignInUserPayload', user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, token?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type SignOutUserMutationVariables = Exact<{
  signOutUserInput: SignOutUserInput;
}>;


export type SignOutUserMutation = { __typename?: 'Mutation', signOutUser?: boolean | null };

export type ConfirmEmailMutationVariables = Exact<{
  confirmEmailInput: ConfirmEmailInput;
}>;


export type ConfirmEmailMutation = { __typename?: 'Mutation', confirmEmail: { __typename?: 'ConfirmEmailPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type ForgotPasswordMutationVariables = Exact<{
  forgotPasswordInput: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type ResetPasswordMutationVariables = Exact<{
  resetPasswordInput: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ResetPasswordPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, token?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type UpdateAddressMutationVariables = Exact<{
  addressInput: AddressInput;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', address?: { __typename?: 'AddressPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type SendSignInSmsMutationVariables = Exact<{
  input: SendSignInSmsInput;
}>;


export type SendSignInSmsMutation = { __typename?: 'Mutation', sendSignInSms?: { __typename?: 'SendSignInSMSPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type AnswerQuestionMutationVariables = Exact<{
  answerQuestionInput: AnswerQuestionInput;
}>;


export type AnswerQuestionMutation = { __typename?: 'Mutation', answerQuestion?: { __typename?: 'AnswerQuestionPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null, nextAvailableDataContainer?: { __typename?: 'QuestionContainer', id: string, buttonLabel?: string | null, name: string, category: { __typename?: 'Category', name: string }, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', falseOptionLabel?: string | null, trueOptionLabel?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', placeholderText?: string | null, currencyCode: string, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'StyledButton', buttonColor?: string | null, label: string, shortDescription?: string | null, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null } | null, partnerBid?: { __typename?: 'PartnerBid', activeFrom?: any | null, activeTo?: any | null, id: string, name?: string | null, dataVaultContainers?: Array<{ __typename?: 'QuestionContainer', id: string, buttonLabel?: string | null, name: string, category: { __typename?: 'Category', name: string }, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', falseOptionLabel?: string | null, trueOptionLabel?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', placeholderText?: string | null, currencyCode: string, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'StyledButton', buttonColor?: string | null, label: string, shortDescription?: string | null, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null }> | null, partner: { __typename?: 'Partner', id: string, dataUsageDescription?: string | null, description?: string | null, iconUrl?: string | null, bannerUrl?: string | null, name: string, shortDescription?: string | null }, reward?: { __typename?: 'PartnerBidReward', amount?: string | null, type: PartnerBidRewardEnum } | null } | null } | null };

export type SkipContainerMutationVariables = Exact<{
  skipContainerInput: SkipContainerInput;
}>;


export type SkipContainerMutation = { __typename?: 'Mutation', skipContainer?: { __typename?: 'SkipContainerPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type BidResponseMutationVariables = Exact<{
  responseInput: PartnerBidResponseInput;
}>;


export type BidResponseMutation = { __typename?: 'Mutation', bidResponse?: { __typename?: 'PartnerBidResponsePayload', bidResponseId?: string | null, offerId?: string | null, categoryId?: string | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type CreateChatTokenMutationVariables = Exact<{
  createChatTokenInput: CreateChatTokenInput;
}>;


export type CreateChatTokenMutation = { __typename?: 'Mutation', createChatToken: { __typename?: 'CreateChatTokenPayload', chatUser?: { __typename?: 'ChatUser', identity?: string | null, token?: string | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type CreateUserMutationVariables = Exact<{
  createUserInput: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'CreateUserPayload', user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, token?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null }, errors?: Array<{ __typename?: 'AccountDoesNotMatchError' } | { __typename?: 'AccountTypeError' } | { __typename?: 'AddressVerificationError' } | { __typename?: 'BadRequest' } | { __typename?: 'BudgetNotFoundError' } | { __typename?: 'CVVVerificationError' } | { __typename?: 'CardDeclinedError' } | { __typename?: 'CardHolderNameVerificationError' } | { __typename?: 'CommonError' } | { __typename?: 'Conflict' } | { __typename?: 'CreateClosureRequestAlreadyClosingError' } | { __typename?: 'CreateClosureRequestCashAdvanceRequestNotRepaidError' } | { __typename?: 'CreateClosureRequestUnableToRetrieveACHAccountNumberError' } | { __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'EvaluationAlreadyRunError' } | { __typename?: 'ExistingSubscriptionError' } | { __typename?: 'GenericBudgetError' } | { __typename?: 'GenericCalibrationError' } | { __typename?: 'GenericError' } | { __typename?: 'InvalidAddressError' } | { __typename?: 'InvalidCardNumberError' } | { __typename?: 'InvalidExpirationDateError' } | { __typename?: 'InvalidSubscriptionTransitionError' } | { __typename?: 'InvalidUserAttributionError' } | { __typename?: 'NoLinkedCardError' } | { __typename?: 'NoOutStandingFeeError' } | { __typename?: 'NoPaymentAccountError' } | { __typename?: 'NotSupportedSubscriptionProductError' } | { __typename?: 'OAuthCreateUserExistingOAuthError' } | { __typename?: 'OAuthCreateUserExistingUserError' } | { __typename?: 'OAuthCreateUserInvalidTokenError' } | { __typename?: 'OAuthCreateUserTokenExpiredError' } | { __typename?: 'OAuthSignInNotRegisteredError' } | { __typename?: 'OAuthSignInUserInvalidTokenError' } | { __typename?: 'OAuthSignInUserTokenExpiredError' } | { __typename?: 'PauseCashAdvanceSubscriptionActiveAdvanceError' } | { __typename?: 'PauseCashAdvanceSubscriptionCanceledError' } | { __typename?: 'PauseCashAdvanceSubscriptionInactiveError' } | { __typename?: 'PauseCashAdvanceSubscriptionNoSubscriptionError' } | { __typename?: 'PauseSubscriptionActiveAdvanceError' } | { __typename?: 'PauseSubscriptionCanceledError' } | { __typename?: 'PauseSubscriptionInactiveError' } | { __typename?: 'PauseSubscriptionNoSubscriptionError' } | { __typename?: 'PaymentAccountLinkedOverLimitError' } | { __typename?: 'RateLimitExceeded' } | { __typename?: 'ReferralNotFoundError' } | { __typename?: 'RefreshTransactionsUnauthorizedError' } | { __typename?: 'ResumeCashAdvanceSubscriptionActiveError' } | { __typename?: 'ResumeCashAdvanceSubscriptionCanceledError' } | { __typename?: 'ResumeCashAdvanceSubscriptionNoSubscriptionError' } | { __typename?: 'ResumeSubscriptionActiveError' } | { __typename?: 'ResumeSubscriptionCanceledError' } | { __typename?: 'ResumeSubscriptionNoSubscriptionError' } | { __typename?: 'SaveError' } | { __typename?: 'TransactionNotFoundError' }> | null } };

export type OAuthCreateUserMutationVariables = Exact<{
  input: OAuthCreateUserInput;
}>;


export type OAuthCreateUserMutation = { __typename?: 'Mutation', oAuthCreateUser: { __typename?: 'OAuthCreateUserPayload', user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, token?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'OAuthCreateUserExistingOAuthError', message: string, path: Array<string> } | { __typename?: 'OAuthCreateUserExistingUserError', message: string, path: Array<string> } | { __typename?: 'OAuthCreateUserInvalidTokenError', message: string, path: Array<string> } | { __typename?: 'OAuthCreateUserTokenExpiredError', message: string, path: Array<string> }> | null } };

export type OAuthSignInUserMutationVariables = Exact<{
  input: OAuthSignInUserInput;
}>;


export type OAuthSignInUserMutation = { __typename?: 'Mutation', oAuthSignInUser: { __typename?: 'OAuthSignInUserPayload', user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, token?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'OAuthSignInNotRegisteredError', message: string, path: Array<string> } | { __typename?: 'OAuthSignInUserInvalidTokenError', message: string, path: Array<string> } | { __typename?: 'OAuthSignInUserTokenExpiredError', message: string, path: Array<string> }> | null } };

export type ConfirmPhoneMutationVariables = Exact<{
  confirmPhoneInput: ConfirmPhoneInput;
}>;


export type ConfirmPhoneMutation = { __typename?: 'Mutation', confirmPhone: { __typename?: 'ConfirmPhonePayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type UpdatePhoneMutationVariables = Exact<{
  updatePhoneInput: UpdatePhoneInput;
}>;


export type UpdatePhoneMutation = { __typename?: 'Mutation', updatePhone: { __typename?: 'UpdatePhonePayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type ResendPhoneVerificationMutationVariables = Exact<{
  resendPhoneVerificationInput: ResendPhoneVerificationInput;
}>;


export type ResendPhoneVerificationMutation = { __typename?: 'Mutation', resendPhoneVerification?: { __typename?: 'ResendPhoneVerificationPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type ResendEmailVerificationMutationVariables = Exact<{
  input: ResendEmailVerificationInput;
}>;


export type ResendEmailVerificationMutation = { __typename?: 'Mutation', resendEmailVerification?: { __typename?: 'ResendEmailVerificationPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type LinkBankAccountMutationVariables = Exact<{
  input: LinkBankAccountInput;
}>;


export type LinkBankAccountMutation = { __typename?: 'Mutation', linkBankAccount: { __typename?: 'LinkBankAccountPayload', bankAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, deletedAt?: string | null, displayAccountNumber?: string | null, gatewayWithdrawalFee?: string | null, id: string, logo?: string | null, name?: string | null, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type UnlinkBankAccountMutationVariables = Exact<{
  input: UnlinkBankAccountInput;
}>;


export type UnlinkBankAccountMutation = { __typename?: 'Mutation', unlinkBankAccount: { __typename?: 'UnlinkBankAccountPayload', bankAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, deletedAt?: string | null, displayAccountNumber?: string | null, gatewayWithdrawalFee?: string | null, id: string, logo?: string | null, name?: string | null, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type CreateLinkTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateLinkTokenMutation = { __typename?: 'Mutation', createLinkToken?: { __typename?: 'CreateLinkTokenPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null, linkToken?: { __typename?: 'PlaidLinkToken', expiration?: any | null, linkToken?: string | null } | null } | null };

export type WithdrawalMutationVariables = Exact<{
  input: CreateWithdrawalInput;
}>;


export type WithdrawalMutation = { __typename?: 'Mutation', createWithdrawal?: { __typename?: 'CreateWithdrawalPayload', transaction?: { __typename?: 'Withdrawal', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | null, errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type RegistrationCompleteMutationVariables = Exact<{
  input: RegistrationCompleteInput;
}>;


export type RegistrationCompleteMutation = { __typename?: 'Mutation', registrationComplete: { __typename?: 'RegistrationCompletePayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type BatchPublishClientEventsMutationVariables = Exact<{
  input: BatchPublishClientEventsInput;
}>;


export type BatchPublishClientEventsMutation = { __typename?: 'Mutation', batchPublishClientEvents?: { __typename?: 'BatchPublishClientEventsPayload', eventIds?: Array<string> | null, errors?: Array<{ __typename?: 'ClientEventError', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null, event: { __typename?: 'ClientEvent', data?: any | null, name: string, partnerId?: string | null, partnerOfferId?: string | null, requestId: string, servedImpressionId?: string | null } } | { __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type PublishEventMutationVariables = Exact<{
  input: PublishClientEventInput;
}>;


export type PublishEventMutation = { __typename?: 'Mutation', publishClientEvent?: { __typename?: 'PublishClientEventPayload', eventId?: string | null, errors?: Array<{ __typename?: 'ClientEventError', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null, event: { __typename?: 'ClientEvent', data?: any | null, name: string, partnerId?: string | null, partnerOfferId?: string | null, requestId: string, servedImpressionId?: string | null } } | { __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type PublishWebEventMutationVariables = Exact<{
  input: PublishWebEventInput;
}>;


export type PublishWebEventMutation = { __typename?: 'Mutation', publishWebEvent?: { __typename?: 'PublishWebEventPayload', eventId?: string | null, errors?: Array<{ __typename?: 'ClientEventError', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null, event: { __typename?: 'ClientEvent', data?: any | null, name: string, partnerId?: string | null, partnerOfferId?: string | null, requestId: string, servedImpressionId?: string | null } } | { __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type PublishBackgroundEventMutationVariables = Exact<{
  input: PublishBackgroundEventInput;
}>;


export type PublishBackgroundEventMutation = { __typename?: 'Mutation', publishBackgroundEvent?: { __typename?: 'PublishBackgroundEventPayload', eventId?: string | null, errors?: Array<{ __typename?: 'ClientEventError', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null, event: { __typename?: 'ClientEvent', data?: any | null, name: string, partnerId?: string | null, partnerOfferId?: string | null, requestId: string, servedImpressionId?: string | null } } | { __typename?: 'Error', message: string, path: Array<string> }> | null } | null };

export type CreateUserFeatureOptInMutationVariables = Exact<{
  input: CreateUserFeatureOptInInput;
}>;


export type CreateUserFeatureOptInMutation = { __typename?: 'Mutation', createUserFeatureOptIn: { __typename?: 'CreateUserFeatureOptInPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> }> | null } };

export type SetUserAttributionMutationVariables = Exact<{
  input: SetUserAttributionInput;
}>;


export type SetUserAttributionMutation = { __typename?: 'Mutation', setUserAttribution: { __typename?: 'SetUserAttributionPayload', errors?: Array<{ __typename?: 'Error', message: string, path: Array<string> } | { __typename?: 'InvalidUserAttributionError', message: string, path: Array<string> }> | null } };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, token?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null } | null };

export type LimitedUserQueryVariables = Exact<{ [key: string]: never; }>;


export type LimitedUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, dob?: any | null, gender?: string | null, registrationCompletedAt?: any | null, emailConfirmedAt?: any | null, phoneConfirmedAt?: any | null, addresses?: Array<{ __typename?: 'Address', address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null }> | null } | null };

export type OnboardedUserQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardedUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, token?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null } | null };

export type ActiveExperimentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveExperimentsQuery = { __typename?: 'Query', user?: { __typename?: 'User', activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null } | null };

export type PotentialRewardsQueryVariables = Exact<{ [key: string]: never; }>;


export type PotentialRewardsQuery = { __typename?: 'Query', user?: { __typename?: 'User', potentialCampaignRewardTotal?: { __typename?: 'PotentialCampaignRewardTotalConnection', edges?: Array<{ __typename?: 'PotentialCampaignRewardTotalEdge', cursor: string, node?: { __typename?: 'PotentialCampaignRewardTotal', amount?: string | null, partnerId?: string | null } | null } | null> | null, nodes?: Array<{ __typename?: 'PotentialCampaignRewardTotal', amount?: string | null, partnerId?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null } | null };

export type WithdrawalEligibilityQueryVariables = Exact<{ [key: string]: never; }>;


export type WithdrawalEligibilityQuery = { __typename?: 'Query', user?: { __typename?: 'User', eligibleForWithdrawal: Array<WithdrawalEligibilityEnum> } | null };

export type AddDataContainersQueryVariables = Exact<{ [key: string]: never; }>;


export type AddDataContainersQuery = { __typename?: 'Query', addDataContainers: Array<{ __typename?: 'QuestionContainer', id: string, buttonLabel?: string | null, name: string, category: { __typename?: 'Category', name: string }, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', falseOptionLabel?: string | null, trueOptionLabel?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', placeholderText?: string | null, currencyCode: string, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'StyledButton', buttonColor?: string | null, label: string, shortDescription?: string | null, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null } | null> };

export type AvailableBidsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableBidsQuery = { __typename?: 'Query', availableBids: { __typename?: 'PartnerBidConnection', nodes?: Array<{ __typename?: 'PartnerBid', activeFrom?: any | null, activeTo?: any | null, id: string, name?: string | null, dataVaultContainers?: Array<{ __typename?: 'QuestionContainer', id: string, buttonLabel?: string | null, name: string, category: { __typename?: 'Category', name: string }, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', falseOptionLabel?: string | null, trueOptionLabel?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', placeholderText?: string | null, currencyCode: string, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'StyledButton', buttonColor?: string | null, label: string, shortDescription?: string | null, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null }> | null, partner: { __typename?: 'Partner', id: string, dataUsageDescription?: string | null, description?: string | null, iconUrl?: string | null, bannerUrl?: string | null, name: string, shortDescription?: string | null }, reward?: { __typename?: 'PartnerBidReward', amount?: string | null, type: PartnerBidRewardEnum } | null } | null> | null } };

export type UserDataContainersQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDataContainersQuery = { __typename?: 'Query', userDataContainers: Array<{ __typename?: 'QuestionContainer', id: string, buttonLabel?: string | null, name: string, category: { __typename?: 'Category', name: string }, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', falseOptionLabel?: string | null, trueOptionLabel?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', placeholderText?: string | null, currencyCode: string, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'StyledButton', buttonColor?: string | null, label: string, shortDescription?: string | null, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null } | null> };

export type UserDataContainersForAddDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDataContainersForAddDataQuery = { __typename?: 'Query', userDataContainers: Array<{ __typename?: 'QuestionContainer', name: string } | null> };

export type OnboardingQuestionContainersQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingQuestionContainersQuery = { __typename?: 'Query', onboardingQuestionContainers: Array<{ __typename?: 'QuestionContainer', id: string, buttonLabel?: string | null, name: string, category: { __typename?: 'Category', name: string }, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', falseOptionLabel?: string | null, trueOptionLabel?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', placeholderText?: string | null, currencyCode: string, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'StyledButton', buttonColor?: string | null, label: string, shortDescription?: string | null, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null } | null> };

export type UserStateQueryVariables = Exact<{ [key: string]: never; }>;


export type UserStateQuery = { __typename?: 'Query', user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, dob?: any | null, gender?: string | null, phone?: string | null, token?: string | null, confirmationSentAt?: any | null, phoneConfirmedAt?: any | null, emailConfirmedAt?: any | null, registrationCompletedAt?: any | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, administrativeArea?: string | null, locality?: string | null, postalCode?: string | null, primary?: boolean | null, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null }> | null, activeExperiments?: Array<{ __typename?: 'ActiveExperiment', testName: string, variant?: string | null, details?: any | null }> | null } | null, onboardingQuestionContainers: Array<{ __typename?: 'QuestionContainer', id: string, buttonLabel?: string | null, name: string, category: { __typename?: 'Category', name: string }, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', falseOptionLabel?: string | null, trueOptionLabel?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', placeholderText?: string | null, currencyCode: string, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'StyledButton', buttonColor?: string | null, label: string, shortDescription?: string | null, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null } | null>, bankAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, deletedAt?: string | null, displayAccountNumber?: string | null, gatewayWithdrawalFee?: string | null, id: string, logo?: string | null, name?: string | null, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null, appSettings: { __typename?: 'AppSettings', depositMinLimit: number, depositMaxLimit: number, withdrawalMaxLimit: number, withdrawalMinLimit: number, withdrawalMinBalanceCopy: string, availableBalanceInfoCopy: string, lifetimeEarningsInfoCopy: string, pendingBalanceInfoCopy: string, sessionInactivityPeriod: number, unifiedLogin: boolean, rpSearchPlaceholderCopy: string, rpHomeTagCopy: string, rpCategoryPaginationAmount: number, tutorialHighlightedRpCategoryId: string, tutorialHighlightedRpTagId: string, accountStrengthCardHeaderCopy: string, accountStrengthIncentiveCopy: string } };

export type BankAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type BankAccountQuery = { __typename?: 'Query', bankAccount?: { __typename?: 'BankAccount', allowDeposit?: boolean | null, allowWithdrawal?: boolean | null, deletedAt?: string | null, displayAccountNumber?: string | null, gatewayWithdrawalFee?: string | null, id: string, logo?: string | null, name?: string | null, requireReauth?: boolean | null, status?: BankAccountStatusEnum | null, transferMethod?: string | null } | null };

export type BalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type BalanceQuery = { __typename?: 'Query', balance?: { __typename?: 'Balance', available?: string | null, total?: string | null, availableToWithdraw?: string | null, cashTotal?: string | null, cumulativeEarned?: string | null, pending?: string | null } | null };

export type RecentTransactionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentTransactionsQuery = { __typename?: 'Query', recentTransactions?: { __typename?: 'TransactionConnection', edges?: Array<{ __typename?: 'TransactionEdge', cursor: string, node?: { __typename?: 'AtmSubscriptionFee', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'AtmSubscriptionFeePayment', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvance', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceRepayment', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceTip', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceTransferFee', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'DataDividend', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InactivityFeeDisplay', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InvestmentDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InvestmentWithdrawal', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'UserOnetimeDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'UserRecurringDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'Withdrawal', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | null } | null> | null, nodes?: Array<{ __typename?: 'AtmSubscriptionFee', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'AtmSubscriptionFeePayment', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvance', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceRepayment', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceTip', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'CashAdvanceTransferFee', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'DataDividend', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InactivityFeeDisplay', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InvestmentDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'InvestmentWithdrawal', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'UserOnetimeDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'UserRecurringDeposit', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | { __typename?: 'Withdrawal', id: string, amount: string, createdAt: any, criteria?: string | null, explainer?: string | null, source: string, status: TransactionStatusEnum, title: string, iconImageUrl: string, tag?: string | null, subtag?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type AppSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AppSettingsQuery = { __typename?: 'Query', appSettings: { __typename?: 'AppSettings', depositMinLimit: number, depositMaxLimit: number, withdrawalMaxLimit: number, withdrawalMinLimit: number, withdrawalMinBalanceCopy: string, availableBalanceInfoCopy: string, lifetimeEarningsInfoCopy: string, pendingBalanceInfoCopy: string, sessionInactivityPeriod: number, unifiedLogin: boolean, rpSearchPlaceholderCopy: string, rpHomeTagCopy: string, rpCategoryPaginationAmount: number, tutorialHighlightedRpCategoryId: string, tutorialHighlightedRpTagId: string, accountStrengthCardHeaderCopy: string, accountStrengthIncentiveCopy: string } };

export type QuestionContainersQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type QuestionContainersQuery = { __typename?: 'Query', questionContainers: Array<{ __typename?: 'QuestionContainer', id: string, buttonLabel?: string | null, name: string, category: { __typename?: 'Category', name: string }, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', falseOptionLabel?: string | null, trueOptionLabel?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'Button', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', placeholderText?: string | null, currencyCode: string, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, questions?: Array<{ __typename?: 'InputAdministrativeArea', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputBoolean', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputCurrency', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputDate', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputGroup', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputListSelection', id: string, required: boolean, text: string, options: Array<{ __typename?: 'Option', label: string, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputNumber', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputPostalCode', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputStyledButtonSelection', multiple: boolean, id: string, required: boolean, text: string, buttons: Array<{ __typename?: 'StyledButton', buttonColor?: string | null, label: string, shortDescription?: string | null, value: string }>, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null } | { __typename?: 'InputText', placeholderText?: string | null, id: string, required: boolean, text: string, images?: Array<{ __typename?: 'QuestionImage', url: string }> | null, userResponse?: { __typename?: 'UserDataVaultQuestionResponse', value: string, updatedAt?: any | null } | null }> | null } | null> };

export type PartnersQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PartnersQuery = { __typename?: 'Query', partners: Array<{ __typename?: 'Partner', id: string, dataUsageDescription?: string | null, description?: string | null, iconUrl?: string | null, bannerUrl?: string | null, name: string, shortDescription?: string | null }> };

export type AppVersionSupportedQueryVariables = Exact<{
  platform: ClientPlatformEnum;
  version: Scalars['String']['input'];
}>;


export type AppVersionSupportedQuery = { __typename?: 'Query', appVersionSupported: boolean };

export type ReferralQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferralQuery = { __typename?: 'Query', referral?: { __typename?: 'Referral', code: string, referrerName?: string | null, rewardAmount: string, rewardCriteria: ReferralRewardCriteriaEnum, rewardCriteriaDescription: string, history: Array<{ __typename?: 'ReferralHistory', amount: string, createdAt: any, firstName?: string | null, lastName?: string | null, qualifiedAt?: any | null, rewardCriteria: ReferralRewardCriteriaEnum }> } | null };

export type SharedUserIdQueryVariables = Exact<{ [key: string]: never; }>;


export type SharedUserIdQuery = { __typename?: 'Query', sharedUser?: { __typename?: 'SharedUser', id: string } | null };

export type AccountTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountTasksQuery = { __typename?: 'Query', appSettings: { __typename?: 'AppSettings', accountStrengthCardHeaderCopy: string, accountStrengthIncentiveCopy: string }, user?: { __typename?: 'User', accountTaskLists?: { __typename?: 'AccountTaskListConnection', nodes?: Array<{ __typename?: 'AccountTaskList', completedAt?: any | null, accountTasks?: Array<{ __typename?: 'AccountTask', currentCompletions: number, deepLink: string, description: string, icon: string, instruction?: string | null, targetCompletions: number }> | null } | null> | null } | null } | null };

export type PublicOffersForUrlQueryVariables = Exact<{
  url: Scalars['String']['input'];
  placementId: Scalars['ID']['input'];
}>;


export type PublicOffersForUrlQuery = { __typename?: 'Query', publicOffersForUrl?: { __typename?: 'PartnerOfferUnionConnection', nodes?: Array<{ __typename?: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } } | { __typename?: 'Survey' } | null> | null } | null };

export type PartnerOfferCategoryByIdOffersQueryVariables = Exact<{
  categoryId: Scalars['ID']['input'];
  placementId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PartnerOfferCategoryByIdOffersQuery = { __typename?: 'Query', findPartnerOfferCategoryById?: { __typename?: 'PartnerOfferCategory', id: string, name: string, bannerUrl?: string | null, priorityOrder?: number | null, myFullPartnerOffers1: { __typename?: 'PartnerOfferUnionConnection', nodes?: Array<{ __typename?: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } } | { __typename?: 'Survey' } | null> | null }, displayMetadata: { __typename?: 'PartnerOfferCategoryDisplayMetadata', viewAllPaginationAmount: number, detailDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null }, mainDisplayStyling: { __typename?: 'PartnerOfferCategoryDisplayStyling', axis: string, backgroundColor?: string | null, cardStyle: string, columns?: number | null, rows?: number | null } } } | null };

export type PartnerOfferPlacementByIdOffersQueryVariables = Exact<{
  placementId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PartnerOfferPlacementByIdOffersQuery = { __typename?: 'Query', offersForPlacement?: { __typename?: 'PartnerOfferUnionConnection', nodes?: Array<{ __typename?: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } } | { __typename?: 'Survey' } | null> | null } | null };

export type PublicOffersForPlacementQueryVariables = Exact<{
  placementId: Scalars['ID']['input'];
}>;


export type PublicOffersForPlacementQuery = { __typename?: 'Query', publicOffersForPlacement?: { __typename?: 'PartnerOfferUnionConnection', nodes?: Array<{ __typename?: 'Deal', id: string, completedAt?: any | null, createdAt: any, cta?: string | null, ctaClickBehavior: PartnerOfferCtaClickBehaviorEnum, ctaUrl?: string | null, description?: string | null, disclosure?: string | null, expectedRewardTimeline?: string | null, offerType: PartnerOfferTypeEnum, updatedAt: any, termsAndConditionsUrl?: string | null, skipOfferDetails: boolean, servedImpressionId: string, savingsAmount?: string | null, cardHeadline?: string | null, cardDescription?: string | null, potentialRewardTotal?: { __typename?: 'PartnerOfferPotentialRewardTotal', amount: string, originalAmount: string, rewardType: PartnerRewardTypeEnum } | null, partner: { __typename?: 'Partner', bannerUrl?: string | null, createdAt: any, shortDescription?: string | null, name: string, minimalOfferDetailOverride: boolean, id: string, iconUrl?: string | null, description?: string | null, dataUsageDescription?: string | null } } | { __typename?: 'Survey' } | null> | null } | null };

export type PublicOffersForPlacementPartnerLinksQueryVariables = Exact<{
  placementId: Scalars['ID']['input'];
}>;


export type PublicOffersForPlacementPartnerLinksQuery = { __typename?: 'Query', publicOffersForPlacement?: { __typename?: 'PartnerOfferUnionConnection', nodes?: Array<{ __typename?: 'Deal', ctaUrl?: string | null, partner: { __typename?: 'Partner', name: string } } | { __typename?: 'Survey' } | null> | null } | null };

export type MonitoredBankAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type MonitoredBankAccountsQuery = { __typename?: 'Query', monitoredBankAccounts?: Array<{ __typename?: 'MonitoredBankAccount', balance?: number | null, balanceLastUpdatedAt?: any | null, createdAt: any, deletedAt?: string | null, displayAccountNumber?: string | null, id: string, logo?: string | null, name?: string | null, requireReauth?: boolean | null, subtype?: MonitoredBankAccountSubtypeEnum | null, type?: MonitoredBankAccountTypeEnum | null }> | null };

export type MonitoredBankAccountTransactionsQueryVariables = Exact<{
  monitoredBankAccountId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  merchant?: InputMaybe<Scalars['String']['input']>;
  primaryCategory?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<BankAccountTransactionSort>;
}>;


export type MonitoredBankAccountTransactionsQuery = { __typename?: 'Query', monitoredBankAccountTransactions: Array<{ __typename?: 'MonitoredBankAccountTransaction', amount: number, date: any, deleted: boolean, detailedCategory?: string | null, id: string, ignored: boolean, merchantLogoUrl?: string | null, merchantName?: string | null, monitoredBankAccountId: string, name: string, nameOverride?: string | null, needsCategorization: boolean, paymentChannel?: PaymentChannelEnum | null, pending: boolean, primaryCategory?: string | null, primaryCategoryOverride?: string | null, recurringTransactionId?: string | null, updatedAt: any, website?: string | null, location?: { __typename?: 'Location', address?: string | null, city?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, postalCode?: string | null, region?: string | null, storeNumber?: string | null } | null }> };

export const PotentialCampaignRewardTotalFragmentFragmentDoc = gql`
    fragment PotentialCampaignRewardTotalFragment on PotentialCampaignRewardTotal {
  amount
  partnerId
}
    `;
export const PotentialCampaignRewardTotalEdgeFragmentFragmentDoc = gql`
    fragment PotentialCampaignRewardTotalEdgeFragment on PotentialCampaignRewardTotalEdge {
  cursor
  node {
    ...PotentialCampaignRewardTotalFragment
  }
}
    ${PotentialCampaignRewardTotalFragmentFragmentDoc}`;
export const PageInfoFragmentFragmentDoc = gql`
    fragment PageInfoFragment on PageInfo {
  endCursor
  hasNextPage
  hasPreviousPage
  startCursor
}
    `;
export const PotentialCampaignRewardTotalConnectionFragmentFragmentDoc = gql`
    fragment PotentialCampaignRewardTotalConnectionFragment on PotentialCampaignRewardTotalConnection {
  edges {
    ...PotentialCampaignRewardTotalEdgeFragment
  }
  nodes {
    ...PotentialCampaignRewardTotalFragment
  }
  pageInfo {
    ...PageInfoFragment
  }
}
    ${PotentialCampaignRewardTotalEdgeFragmentFragmentDoc}
${PotentialCampaignRewardTotalFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;
export const PotentialRewardsFragmentFragmentDoc = gql`
    fragment PotentialRewardsFragment on User {
  potentialCampaignRewardTotal {
    ...PotentialCampaignRewardTotalConnectionFragment
  }
}
    ${PotentialCampaignRewardTotalConnectionFragmentFragmentDoc}`;
export const ActiveExperimentFragmentFragmentDoc = gql`
    fragment ActiveExperimentFragment on ActiveExperiment {
  testName
  variant
  details
}
    `;
export const ActiveExperimentsFragmentFragmentDoc = gql`
    fragment ActiveExperimentsFragment on User {
  activeExperiments {
    ...ActiveExperimentFragment
  }
}
    ${ActiveExperimentFragmentFragmentDoc}`;
export const ErrorFragmentFragmentDoc = gql`
    fragment ErrorFragment on Error {
  message
  path
}
    `;
export const AddressFragmentFragmentDoc = gql`
    fragment AddressFragment on Address {
  id
  address1
  address2
  administrativeArea
  locality
  postalCode
  primary
  createdAt
  deletedAt
  updatedAt
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  id
  firstName
  lastName
  email
  dob
  gender
  phone
  token
  confirmationSentAt
  phoneConfirmedAt
  emailConfirmedAt
  registrationCompletedAt
  token
  addresses {
    ...AddressFragment
  }
  activeExperiments {
    ...ActiveExperimentFragment
  }
}
    ${AddressFragmentFragmentDoc}
${ActiveExperimentFragmentFragmentDoc}`;
export const CreateUserPayloadFragmentFragmentDoc = gql`
    fragment CreateUserPayloadFragment on CreateUserPayload {
  errors {
    ...ErrorFragment
  }
  user {
    ...UserFragment
  }
}
    ${ErrorFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;
export const SignInUserPayloadFragmentFragmentDoc = gql`
    fragment SignInUserPayloadFragment on SignInUserPayload {
  errors {
    ...ErrorFragment
  }
  user {
    ...UserFragment
  }
}
    ${ErrorFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;
export const ConfirmEmailPayloadFragmentFragmentDoc = gql`
    fragment ConfirmEmailPayloadFragment on ConfirmEmailPayload {
  errors {
    ...ErrorFragment
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const ConfirmPhonePayloadFragmentFragmentDoc = gql`
    fragment ConfirmPhonePayloadFragment on ConfirmPhonePayload {
  errors {
    ...ErrorFragment
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const ResetPasswordPayloadFragmentFragmentDoc = gql`
    fragment ResetPasswordPayloadFragment on ResetPasswordPayload {
  errors {
    ...ErrorFragment
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const OAuthAccountCreationErrorFragmentDoc = gql`
    fragment OAuthAccountCreationError on OAuthCreateUserError {
  ... on Error {
    ...ErrorFragment
  }
  ... on OAuthCreateUserExistingOAuthError {
    message
    path
  }
  ... on OAuthCreateUserExistingUserError {
    message
    path
  }
  ... on OAuthCreateUserInvalidTokenError {
    message
    path
  }
  ... on OAuthCreateUserTokenExpiredError {
    message
    path
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const OAuthAccountSignInErrorFragmentDoc = gql`
    fragment OAuthAccountSignInError on OAuthSignInUserError {
  ... on Error {
    ...ErrorFragment
  }
  ... on OAuthSignInNotRegisteredError {
    message
    path
  }
  ... on OAuthSignInUserInvalidTokenError {
    message
    path
  }
  ... on OAuthSignInUserTokenExpiredError {
    message
    path
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const QuestionImageFragmentFragmentDoc = gql`
    fragment QuestionImageFragment on QuestionImage {
  url
}
    `;
export const UserDataVaultQuestionResponseFragmentFragmentDoc = gql`
    fragment UserDataVaultQuestionResponseFragment on UserDataVaultQuestionResponse {
  value
  updatedAt
}
    `;
export const QuestionFragmentFragmentDoc = gql`
    fragment QuestionFragment on Question {
  id
  images {
    ...QuestionImageFragment
  }
  required
  text
  userResponse {
    ...UserDataVaultQuestionResponseFragment
  }
}
    ${QuestionImageFragmentFragmentDoc}
${UserDataVaultQuestionResponseFragmentFragmentDoc}`;
export const InputGroupFragmentFragmentDoc = gql`
    fragment InputGroupFragment on InputGroup {
  questions {
    ...QuestionFragment
  }
}
    ${QuestionFragmentFragmentDoc}`;
export const ButtonFragmentFragmentDoc = gql`
    fragment ButtonFragment on Button {
  label
  value
}
    `;
export const InputButtonSelectionFragmentFragmentDoc = gql`
    fragment InputButtonSelectionFragment on InputButtonSelection {
  buttons {
    ...ButtonFragment
  }
}
    ${ButtonFragmentFragmentDoc}`;
export const OptionFragmentFragmentDoc = gql`
    fragment OptionFragment on Option {
  label
  value
}
    `;
export const InputSelectionListFragmentFragmentDoc = gql`
    fragment InputSelectionListFragment on InputListSelection {
  options {
    ...OptionFragment
  }
}
    ${OptionFragmentFragmentDoc}`;
export const StyledButtonFragmentFragmentDoc = gql`
    fragment StyledButtonFragment on StyledButton {
  buttonColor
  label
  shortDescription
  value
}
    `;
export const InputStyledButtonSelectionFragmentFragmentDoc = gql`
    fragment InputStyledButtonSelectionFragment on InputStyledButtonSelection {
  buttons {
    ...StyledButtonFragment
  }
}
    ${StyledButtonFragmentFragmentDoc}`;
export const CategoryFragmentFragmentDoc = gql`
    fragment CategoryFragment on Category {
  name
}
    `;
export const QuestionContainerFragmentFragmentDoc = gql`
    fragment QuestionContainerFragment on QuestionContainer {
  id
  category {
    ...CategoryFragment
  }
  buttonLabel
  name
  questions {
    ...QuestionFragment
    ... on InputGroup {
      questions {
        ...QuestionFragment
        ... on InputText {
          placeholderText
        }
        ... on InputPostalCode {
          placeholderText
        }
        ... on InputAdministrativeArea {
          placeholderText
        }
      }
    }
    ... on InputStyledButtonSelection {
      buttons {
        ...StyledButtonFragment
      }
      multiple
    }
    ... on InputListSelection {
      options {
        ...OptionFragment
      }
    }
    ... on InputButtonSelection {
      buttons {
        ...ButtonFragment
      }
      multiple
    }
    ... on InputCurrency {
      placeholderText
      currencyCode
    }
    ... on InputNumber {
      placeholderText
    }
    ... on InputText {
      placeholderText
    }
    ... on InputPostalCode {
      placeholderText
    }
    ... on InputAdministrativeArea {
      placeholderText
    }
    ... on InputBoolean {
      falseOptionLabel
      trueOptionLabel
    }
  }
}
    ${CategoryFragmentFragmentDoc}
${QuestionFragmentFragmentDoc}
${StyledButtonFragmentFragmentDoc}
${OptionFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}`;
export const PartnerFragmentFragmentDoc = gql`
    fragment PartnerFragment on Partner {
  id
  dataUsageDescription
  description
  iconUrl
  bannerUrl
  name
  shortDescription
}
    `;
export const PartnerBidRewardFragmentFragmentDoc = gql`
    fragment PartnerBidRewardFragment on PartnerBidReward {
  amount
  type
}
    `;
export const PartnerBidFragmentFragmentDoc = gql`
    fragment PartnerBidFragment on PartnerBid {
  activeFrom
  activeTo
  dataVaultContainers {
    ...QuestionContainerFragment
  }
  id
  name
  partner {
    ...PartnerFragment
  }
  reward {
    ...PartnerBidRewardFragment
  }
}
    ${QuestionContainerFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartnerBidRewardFragmentFragmentDoc}`;
export const PartnerBidResponsePayloadFragmentFragmentDoc = gql`
    fragment PartnerBidResponsePayloadFragment on PartnerBidResponsePayload {
  bidResponseId
  offerId
  categoryId
  errors {
    ...ErrorFragment
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const BalanceFragmentFragmentDoc = gql`
    fragment BalanceFragment on Balance {
  available
  total
  availableToWithdraw
  cashTotal
  cumulativeEarned
  pending
}
    `;
export const BankAccountFragmentFragmentDoc = gql`
    fragment BankAccountFragment on BankAccount {
  allowDeposit
  allowWithdrawal
  deletedAt
  displayAccountNumber
  gatewayWithdrawalFee
  id
  logo
  name
  requireReauth
  status
  transferMethod
}
    `;
export const ChatUserFragmentFragmentDoc = gql`
    fragment ChatUserFragment on ChatUser {
  identity
  token
}
    `;
export const CreateChatTokenPayloadFragmentFragmentDoc = gql`
    fragment CreateChatTokenPayloadFragment on CreateChatTokenPayload {
  chatUser {
    ...ChatUserFragment
  }
  errors {
    ...ErrorFragment
  }
}
    ${ChatUserFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export const TransactionFragmentFragmentDoc = gql`
    fragment TransactionFragment on Transaction {
  id
  amount
  createdAt
  criteria
  explainer
  source
  status
  title
  iconImageUrl
  tag
  subtag
}
    `;
export const TransactionEdgeFragmentFragmentDoc = gql`
    fragment TransactionEdgeFragment on TransactionEdge {
  cursor
  node {
    ...TransactionFragment
  }
}
    ${TransactionFragmentFragmentDoc}`;
export const TransactionConnectionFragmentFragmentDoc = gql`
    fragment TransactionConnectionFragment on TransactionConnection {
  edges {
    ...TransactionEdgeFragment
  }
  nodes {
    ...TransactionFragment
  }
  pageInfo {
    ...PageInfoFragment
  }
}
    ${TransactionEdgeFragmentFragmentDoc}
${TransactionFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;
export const AppSettingsFragmentFragmentDoc = gql`
    fragment AppSettingsFragment on AppSettings {
  depositMinLimit
  depositMaxLimit
  withdrawalMaxLimit
  withdrawalMinLimit
  withdrawalMinBalanceCopy
  availableBalanceInfoCopy
  lifetimeEarningsInfoCopy
  pendingBalanceInfoCopy
  sessionInactivityPeriod
  unifiedLogin
  rpSearchPlaceholderCopy
  rpHomeTagCopy
  rpCategoryPaginationAmount
  tutorialHighlightedRpCategoryId
  tutorialHighlightedRpTagId
  accountStrengthCardHeaderCopy
  accountStrengthIncentiveCopy
}
    `;
export const SkipContainerPayloadFragmentFragmentDoc = gql`
    fragment SkipContainerPayloadFragment on SkipContainerPayload {
  errors {
    ...ErrorFragment
  }
}
    ${ErrorFragmentFragmentDoc}`;
export const ReferralHistoryFragmentFragmentDoc = gql`
    fragment ReferralHistoryFragment on ReferralHistory {
  amount
  createdAt
  firstName
  lastName
  qualifiedAt
  rewardCriteria
}
    `;
export const ReferralFragmentFragmentDoc = gql`
    fragment ReferralFragment on Referral {
  code
  history {
    ...ReferralHistoryFragment
  }
  referrerName
  rewardAmount
  rewardCriteria
  rewardCriteriaDescription
}
    ${ReferralHistoryFragmentFragmentDoc}`;
export const PlaidLinkTokenFragmentFragmentDoc = gql`
    fragment PlaidLinkTokenFragment on PlaidLinkToken {
  expiration
  linkToken
}
    `;
export const ClientEventFragmentFragmentDoc = gql`
    fragment ClientEventFragment on ClientEvent {
  data
  name
  partnerId
  partnerOfferId
  requestId
  servedImpressionId
}
    `;
export const AccountTaskFragmentFragmentDoc = gql`
    fragment AccountTaskFragment on AccountTask {
  currentCompletions
  deepLink
  description
  icon
  instruction
  targetCompletions
}
    `;
export const DealFragmentFragmentDoc = gql`
    fragment DealFragment on Deal {
  id
  completedAt
  createdAt
  cta
  ctaClickBehavior
  ctaUrl
  description
  disclosure
  expectedRewardTimeline
  offerType
  updatedAt
  termsAndConditionsUrl
  skipOfferDetails
  servedImpressionId
  savingsAmount
  potentialRewardTotal {
    amount
    originalAmount
    rewardType
  }
  partner {
    bannerUrl
    createdAt
    shortDescription
    name
    minimalOfferDetailOverride
    id
    iconUrl
    description
    dataUsageDescription
  }
  cardHeadline
  cardDescription
}
    `;
export const PartnerOfferUnionFragmentFragmentDoc = gql`
    fragment PartnerOfferUnionFragment on PartnerOfferUnion {
  ... on Deal {
    ...DealFragment
  }
}
    ${DealFragmentFragmentDoc}`;
export const OfferForBidFragmentFragmentDoc = gql`
    fragment OfferForBidFragment on BasePartnerOffer {
  id
  servedImpressionId
  offerType
  potentialRewardTotal {
    amount
    originalAmount
    rewardType
  }
}
    `;
export const PartnerOfferCategoryDisplayStylingFragmentFragmentDoc = gql`
    fragment PartnerOfferCategoryDisplayStylingFragment on PartnerOfferCategoryDisplayStyling {
  axis
  backgroundColor
  cardStyle
  columns
  rows
}
    `;
export const PartnerOfferCategoryFragmentFragmentDoc = gql`
    fragment PartnerOfferCategoryFragment on PartnerOfferCategory {
  id
  name
  bannerUrl
  displayMetadata {
    detailDisplayStyling {
      ...PartnerOfferCategoryDisplayStylingFragment
    }
    mainDisplayStyling {
      ...PartnerOfferCategoryDisplayStylingFragment
    }
    viewAllPaginationAmount
  }
  priorityOrder
}
    ${PartnerOfferCategoryDisplayStylingFragmentFragmentDoc}`;
export const MonitoredBankAccountFragmentFragmentDoc = gql`
    fragment MonitoredBankAccountFragment on MonitoredBankAccount {
  balance
  balanceLastUpdatedAt
  createdAt
  deletedAt
  displayAccountNumber
  id
  logo
  name
  requireReauth
  subtype
  type
}
    `;
export const MonitoredBankAccountFragmentNoTypeFragmentDoc = gql`
    fragment MonitoredBankAccountFragmentNoType on MonitoredBankAccount {
  balance
  balanceLastUpdatedAt
  createdAt
  deletedAt
  displayAccountNumber
  id
  logo
  name
  requireReauth
}
    `;
export const LocationFragmentFragmentDoc = gql`
    fragment LocationFragment on Location {
  address
  city
  country
  latitude
  longitude
  postalCode
  region
  storeNumber
}
    `;
export const MonitoredBankAccountTransactionFragmentFragmentDoc = gql`
    fragment MonitoredBankAccountTransactionFragment on MonitoredBankAccountTransaction {
  amount
  date
  deleted
  detailedCategory
  id
  ignored
  location {
    ...LocationFragment
  }
  merchantLogoUrl
  merchantName
  monitoredBankAccountId
  name
  nameOverride
  needsCategorization
  paymentChannel
  pending
  primaryCategory
  primaryCategoryOverride
  recurringTransactionId
  updatedAt
  website
}
    ${LocationFragmentFragmentDoc}`;
export const SignInDocument = gql`
    mutation SignIn($signInUserInput: SignInUserInput!) {
  signInUser(input: $signInUserInput) {
    user {
      ...UserFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${UserFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      signInUserInput: // value for 'signInUserInput'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SignOutUserDocument = gql`
    mutation SignOutUser($signOutUserInput: SignOutUserInput!) {
  signOutUser(input: $signOutUserInput)
}
    `;
export type SignOutUserMutationFn = Apollo.MutationFunction<SignOutUserMutation, SignOutUserMutationVariables>;

/**
 * __useSignOutUserMutation__
 *
 * To run a mutation, you first call `useSignOutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutUserMutation, { data, loading, error }] = useSignOutUserMutation({
 *   variables: {
 *      signOutUserInput: // value for 'signOutUserInput'
 *   },
 * });
 */
export function useSignOutUserMutation(baseOptions?: Apollo.MutationHookOptions<SignOutUserMutation, SignOutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOutUserMutation, SignOutUserMutationVariables>(SignOutUserDocument, options);
      }
export type SignOutUserMutationHookResult = ReturnType<typeof useSignOutUserMutation>;
export type SignOutUserMutationResult = Apollo.MutationResult<SignOutUserMutation>;
export type SignOutUserMutationOptions = Apollo.BaseMutationOptions<SignOutUserMutation, SignOutUserMutationVariables>;
export const ConfirmEmailDocument = gql`
    mutation ConfirmEmail($confirmEmailInput: ConfirmEmailInput!) {
  confirmEmail(input: $confirmEmailInput) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type ConfirmEmailMutationFn = Apollo.MutationFunction<ConfirmEmailMutation, ConfirmEmailMutationVariables>;

/**
 * __useConfirmEmailMutation__
 *
 * To run a mutation, you first call `useConfirmEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEmailMutation, { data, loading, error }] = useConfirmEmailMutation({
 *   variables: {
 *      confirmEmailInput: // value for 'confirmEmailInput'
 *   },
 * });
 */
export function useConfirmEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument, options);
      }
export type ConfirmEmailMutationHookResult = ReturnType<typeof useConfirmEmailMutation>;
export type ConfirmEmailMutationResult = Apollo.MutationResult<ConfirmEmailMutation>;
export type ConfirmEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($forgotPasswordInput: ForgotPasswordInput!) {
  forgotPassword(input: $forgotPasswordInput)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      forgotPasswordInput: // value for 'forgotPasswordInput'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($resetPasswordInput: ResetPasswordInput!) {
  resetPassword(input: $resetPasswordInput) {
    ...ResetPasswordPayloadFragment
  }
}
    ${ResetPasswordPayloadFragmentFragmentDoc}`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      resetPasswordInput: // value for 'resetPasswordInput'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($updateUserInput: UpdateUserInput!) {
  updateUser(input: $updateUserInput) {
    user {
      ...UserFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${UserFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      updateUserInput: // value for 'updateUserInput'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateAddressDocument = gql`
    mutation UpdateAddress($addressInput: AddressInput!) {
  address(input: $addressInput) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdateAddressMutationFn = Apollo.MutationFunction<UpdateAddressMutation, UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      addressInput: // value for 'addressInput'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressMutation, UpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const SendSignInSmsDocument = gql`
    mutation SendSignInSms($input: SendSignInSMSInput!) {
  sendSignInSms(input: $input) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type SendSignInSmsMutationFn = Apollo.MutationFunction<SendSignInSmsMutation, SendSignInSmsMutationVariables>;

/**
 * __useSendSignInSmsMutation__
 *
 * To run a mutation, you first call `useSendSignInSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSignInSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSignInSmsMutation, { data, loading, error }] = useSendSignInSmsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSignInSmsMutation(baseOptions?: Apollo.MutationHookOptions<SendSignInSmsMutation, SendSignInSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSignInSmsMutation, SendSignInSmsMutationVariables>(SendSignInSmsDocument, options);
      }
export type SendSignInSmsMutationHookResult = ReturnType<typeof useSendSignInSmsMutation>;
export type SendSignInSmsMutationResult = Apollo.MutationResult<SendSignInSmsMutation>;
export type SendSignInSmsMutationOptions = Apollo.BaseMutationOptions<SendSignInSmsMutation, SendSignInSmsMutationVariables>;
export const AnswerQuestionDocument = gql`
    mutation AnswerQuestion($answerQuestionInput: AnswerQuestionInput!) {
  answerQuestion(input: $answerQuestionInput) {
    errors {
      ...ErrorFragment
    }
    nextAvailableDataContainer {
      ...QuestionContainerFragment
    }
    partnerBid {
      ...PartnerBidFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}
${QuestionContainerFragmentFragmentDoc}
${PartnerBidFragmentFragmentDoc}`;
export type AnswerQuestionMutationFn = Apollo.MutationFunction<AnswerQuestionMutation, AnswerQuestionMutationVariables>;

/**
 * __useAnswerQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerQuestionMutation, { data, loading, error }] = useAnswerQuestionMutation({
 *   variables: {
 *      answerQuestionInput: // value for 'answerQuestionInput'
 *   },
 * });
 */
export function useAnswerQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AnswerQuestionMutation, AnswerQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerQuestionMutation, AnswerQuestionMutationVariables>(AnswerQuestionDocument, options);
      }
export type AnswerQuestionMutationHookResult = ReturnType<typeof useAnswerQuestionMutation>;
export type AnswerQuestionMutationResult = Apollo.MutationResult<AnswerQuestionMutation>;
export type AnswerQuestionMutationOptions = Apollo.BaseMutationOptions<AnswerQuestionMutation, AnswerQuestionMutationVariables>;
export const SkipContainerDocument = gql`
    mutation SkipContainer($skipContainerInput: SkipContainerInput!) {
  skipContainer(input: $skipContainerInput) {
    ...SkipContainerPayloadFragment
    errors {
      ...ErrorFragment
    }
  }
}
    ${SkipContainerPayloadFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type SkipContainerMutationFn = Apollo.MutationFunction<SkipContainerMutation, SkipContainerMutationVariables>;

/**
 * __useSkipContainerMutation__
 *
 * To run a mutation, you first call `useSkipContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipContainerMutation, { data, loading, error }] = useSkipContainerMutation({
 *   variables: {
 *      skipContainerInput: // value for 'skipContainerInput'
 *   },
 * });
 */
export function useSkipContainerMutation(baseOptions?: Apollo.MutationHookOptions<SkipContainerMutation, SkipContainerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipContainerMutation, SkipContainerMutationVariables>(SkipContainerDocument, options);
      }
export type SkipContainerMutationHookResult = ReturnType<typeof useSkipContainerMutation>;
export type SkipContainerMutationResult = Apollo.MutationResult<SkipContainerMutation>;
export type SkipContainerMutationOptions = Apollo.BaseMutationOptions<SkipContainerMutation, SkipContainerMutationVariables>;
export const BidResponseDocument = gql`
    mutation BidResponse($responseInput: PartnerBidResponseInput!) {
  bidResponse(input: $responseInput) {
    ...PartnerBidResponsePayloadFragment
  }
}
    ${PartnerBidResponsePayloadFragmentFragmentDoc}`;
export type BidResponseMutationFn = Apollo.MutationFunction<BidResponseMutation, BidResponseMutationVariables>;

/**
 * __useBidResponseMutation__
 *
 * To run a mutation, you first call `useBidResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBidResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bidResponseMutation, { data, loading, error }] = useBidResponseMutation({
 *   variables: {
 *      responseInput: // value for 'responseInput'
 *   },
 * });
 */
export function useBidResponseMutation(baseOptions?: Apollo.MutationHookOptions<BidResponseMutation, BidResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BidResponseMutation, BidResponseMutationVariables>(BidResponseDocument, options);
      }
export type BidResponseMutationHookResult = ReturnType<typeof useBidResponseMutation>;
export type BidResponseMutationResult = Apollo.MutationResult<BidResponseMutation>;
export type BidResponseMutationOptions = Apollo.BaseMutationOptions<BidResponseMutation, BidResponseMutationVariables>;
export const CreateChatTokenDocument = gql`
    mutation CreateChatToken($createChatTokenInput: CreateChatTokenInput!) {
  createChatToken(input: $createChatTokenInput) {
    ...CreateChatTokenPayloadFragment
  }
}
    ${CreateChatTokenPayloadFragmentFragmentDoc}`;
export type CreateChatTokenMutationFn = Apollo.MutationFunction<CreateChatTokenMutation, CreateChatTokenMutationVariables>;

/**
 * __useCreateChatTokenMutation__
 *
 * To run a mutation, you first call `useCreateChatTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatTokenMutation, { data, loading, error }] = useCreateChatTokenMutation({
 *   variables: {
 *      createChatTokenInput: // value for 'createChatTokenInput'
 *   },
 * });
 */
export function useCreateChatTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatTokenMutation, CreateChatTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatTokenMutation, CreateChatTokenMutationVariables>(CreateChatTokenDocument, options);
      }
export type CreateChatTokenMutationHookResult = ReturnType<typeof useCreateChatTokenMutation>;
export type CreateChatTokenMutationResult = Apollo.MutationResult<CreateChatTokenMutation>;
export type CreateChatTokenMutationOptions = Apollo.BaseMutationOptions<CreateChatTokenMutation, CreateChatTokenMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($createUserInput: CreateUserInput!) {
  createUser(input: $createUserInput) {
    user {
      ...UserFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${UserFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      createUserInput: // value for 'createUserInput'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const OAuthCreateUserDocument = gql`
    mutation OAuthCreateUser($input: OAuthCreateUserInput!) {
  oAuthCreateUser(input: $input) {
    user {
      ...UserFragment
    }
    errors {
      ...OAuthAccountCreationError
    }
  }
}
    ${UserFragmentFragmentDoc}
${OAuthAccountCreationErrorFragmentDoc}`;
export type OAuthCreateUserMutationFn = Apollo.MutationFunction<OAuthCreateUserMutation, OAuthCreateUserMutationVariables>;

/**
 * __useOAuthCreateUserMutation__
 *
 * To run a mutation, you first call `useOAuthCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOAuthCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oAuthCreateUserMutation, { data, loading, error }] = useOAuthCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOAuthCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<OAuthCreateUserMutation, OAuthCreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OAuthCreateUserMutation, OAuthCreateUserMutationVariables>(OAuthCreateUserDocument, options);
      }
export type OAuthCreateUserMutationHookResult = ReturnType<typeof useOAuthCreateUserMutation>;
export type OAuthCreateUserMutationResult = Apollo.MutationResult<OAuthCreateUserMutation>;
export type OAuthCreateUserMutationOptions = Apollo.BaseMutationOptions<OAuthCreateUserMutation, OAuthCreateUserMutationVariables>;
export const OAuthSignInUserDocument = gql`
    mutation OAuthSignInUser($input: OAuthSignInUserInput!) {
  oAuthSignInUser(input: $input) {
    user {
      ...UserFragment
    }
    errors {
      ...OAuthAccountSignInError
    }
  }
}
    ${UserFragmentFragmentDoc}
${OAuthAccountSignInErrorFragmentDoc}`;
export type OAuthSignInUserMutationFn = Apollo.MutationFunction<OAuthSignInUserMutation, OAuthSignInUserMutationVariables>;

/**
 * __useOAuthSignInUserMutation__
 *
 * To run a mutation, you first call `useOAuthSignInUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOAuthSignInUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oAuthSignInUserMutation, { data, loading, error }] = useOAuthSignInUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOAuthSignInUserMutation(baseOptions?: Apollo.MutationHookOptions<OAuthSignInUserMutation, OAuthSignInUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OAuthSignInUserMutation, OAuthSignInUserMutationVariables>(OAuthSignInUserDocument, options);
      }
export type OAuthSignInUserMutationHookResult = ReturnType<typeof useOAuthSignInUserMutation>;
export type OAuthSignInUserMutationResult = Apollo.MutationResult<OAuthSignInUserMutation>;
export type OAuthSignInUserMutationOptions = Apollo.BaseMutationOptions<OAuthSignInUserMutation, OAuthSignInUserMutationVariables>;
export const ConfirmPhoneDocument = gql`
    mutation ConfirmPhone($confirmPhoneInput: ConfirmPhoneInput!) {
  confirmPhone(input: $confirmPhoneInput) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type ConfirmPhoneMutationFn = Apollo.MutationFunction<ConfirmPhoneMutation, ConfirmPhoneMutationVariables>;

/**
 * __useConfirmPhoneMutation__
 *
 * To run a mutation, you first call `useConfirmPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPhoneMutation, { data, loading, error }] = useConfirmPhoneMutation({
 *   variables: {
 *      confirmPhoneInput: // value for 'confirmPhoneInput'
 *   },
 * });
 */
export function useConfirmPhoneMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmPhoneMutation, ConfirmPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmPhoneMutation, ConfirmPhoneMutationVariables>(ConfirmPhoneDocument, options);
      }
export type ConfirmPhoneMutationHookResult = ReturnType<typeof useConfirmPhoneMutation>;
export type ConfirmPhoneMutationResult = Apollo.MutationResult<ConfirmPhoneMutation>;
export type ConfirmPhoneMutationOptions = Apollo.BaseMutationOptions<ConfirmPhoneMutation, ConfirmPhoneMutationVariables>;
export const UpdatePhoneDocument = gql`
    mutation UpdatePhone($updatePhoneInput: UpdatePhoneInput!) {
  updatePhone(input: $updatePhoneInput) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdatePhoneMutationFn = Apollo.MutationFunction<UpdatePhoneMutation, UpdatePhoneMutationVariables>;

/**
 * __useUpdatePhoneMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneMutation, { data, loading, error }] = useUpdatePhoneMutation({
 *   variables: {
 *      updatePhoneInput: // value for 'updatePhoneInput'
 *   },
 * });
 */
export function useUpdatePhoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhoneMutation, UpdatePhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhoneMutation, UpdatePhoneMutationVariables>(UpdatePhoneDocument, options);
      }
export type UpdatePhoneMutationHookResult = ReturnType<typeof useUpdatePhoneMutation>;
export type UpdatePhoneMutationResult = Apollo.MutationResult<UpdatePhoneMutation>;
export type UpdatePhoneMutationOptions = Apollo.BaseMutationOptions<UpdatePhoneMutation, UpdatePhoneMutationVariables>;
export const ResendPhoneVerificationDocument = gql`
    mutation ResendPhoneVerification($resendPhoneVerificationInput: ResendPhoneVerificationInput!) {
  resendPhoneVerification(input: $resendPhoneVerificationInput) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type ResendPhoneVerificationMutationFn = Apollo.MutationFunction<ResendPhoneVerificationMutation, ResendPhoneVerificationMutationVariables>;

/**
 * __useResendPhoneVerificationMutation__
 *
 * To run a mutation, you first call `useResendPhoneVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPhoneVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPhoneVerificationMutation, { data, loading, error }] = useResendPhoneVerificationMutation({
 *   variables: {
 *      resendPhoneVerificationInput: // value for 'resendPhoneVerificationInput'
 *   },
 * });
 */
export function useResendPhoneVerificationMutation(baseOptions?: Apollo.MutationHookOptions<ResendPhoneVerificationMutation, ResendPhoneVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendPhoneVerificationMutation, ResendPhoneVerificationMutationVariables>(ResendPhoneVerificationDocument, options);
      }
export type ResendPhoneVerificationMutationHookResult = ReturnType<typeof useResendPhoneVerificationMutation>;
export type ResendPhoneVerificationMutationResult = Apollo.MutationResult<ResendPhoneVerificationMutation>;
export type ResendPhoneVerificationMutationOptions = Apollo.BaseMutationOptions<ResendPhoneVerificationMutation, ResendPhoneVerificationMutationVariables>;
export const ResendEmailVerificationDocument = gql`
    mutation ResendEmailVerification($input: ResendEmailVerificationInput!) {
  resendEmailVerification(input: $input) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type ResendEmailVerificationMutationFn = Apollo.MutationFunction<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;

/**
 * __useResendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useResendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailVerificationMutation, { data, loading, error }] = useResendEmailVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>(ResendEmailVerificationDocument, options);
      }
export type ResendEmailVerificationMutationHookResult = ReturnType<typeof useResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationResult = Apollo.MutationResult<ResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationOptions = Apollo.BaseMutationOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;
export const LinkBankAccountDocument = gql`
    mutation LinkBankAccount($input: LinkBankAccountInput!) {
  linkBankAccount(input: $input) {
    bankAccount {
      ...BankAccountFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${BankAccountFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type LinkBankAccountMutationFn = Apollo.MutationFunction<LinkBankAccountMutation, LinkBankAccountMutationVariables>;

/**
 * __useLinkBankAccountMutation__
 *
 * To run a mutation, you first call `useLinkBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkBankAccountMutation, { data, loading, error }] = useLinkBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkBankAccountMutation, LinkBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkBankAccountMutation, LinkBankAccountMutationVariables>(LinkBankAccountDocument, options);
      }
export type LinkBankAccountMutationHookResult = ReturnType<typeof useLinkBankAccountMutation>;
export type LinkBankAccountMutationResult = Apollo.MutationResult<LinkBankAccountMutation>;
export type LinkBankAccountMutationOptions = Apollo.BaseMutationOptions<LinkBankAccountMutation, LinkBankAccountMutationVariables>;
export const UnlinkBankAccountDocument = gql`
    mutation UnlinkBankAccount($input: UnlinkBankAccountInput!) {
  unlinkBankAccount(input: $input) {
    bankAccount {
      ...BankAccountFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${BankAccountFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type UnlinkBankAccountMutationFn = Apollo.MutationFunction<UnlinkBankAccountMutation, UnlinkBankAccountMutationVariables>;

/**
 * __useUnlinkBankAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkBankAccountMutation, { data, loading, error }] = useUnlinkBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkBankAccountMutation, UnlinkBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkBankAccountMutation, UnlinkBankAccountMutationVariables>(UnlinkBankAccountDocument, options);
      }
export type UnlinkBankAccountMutationHookResult = ReturnType<typeof useUnlinkBankAccountMutation>;
export type UnlinkBankAccountMutationResult = Apollo.MutationResult<UnlinkBankAccountMutation>;
export type UnlinkBankAccountMutationOptions = Apollo.BaseMutationOptions<UnlinkBankAccountMutation, UnlinkBankAccountMutationVariables>;
export const CreateLinkTokenDocument = gql`
    mutation CreateLinkToken {
  createLinkToken {
    errors {
      ...ErrorFragment
    }
    linkToken {
      ...PlaidLinkTokenFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}
${PlaidLinkTokenFragmentFragmentDoc}`;
export type CreateLinkTokenMutationFn = Apollo.MutationFunction<CreateLinkTokenMutation, CreateLinkTokenMutationVariables>;

/**
 * __useCreateLinkTokenMutation__
 *
 * To run a mutation, you first call `useCreateLinkTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkTokenMutation, { data, loading, error }] = useCreateLinkTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateLinkTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateLinkTokenMutation, CreateLinkTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLinkTokenMutation, CreateLinkTokenMutationVariables>(CreateLinkTokenDocument, options);
      }
export type CreateLinkTokenMutationHookResult = ReturnType<typeof useCreateLinkTokenMutation>;
export type CreateLinkTokenMutationResult = Apollo.MutationResult<CreateLinkTokenMutation>;
export type CreateLinkTokenMutationOptions = Apollo.BaseMutationOptions<CreateLinkTokenMutation, CreateLinkTokenMutationVariables>;
export const WithdrawalDocument = gql`
    mutation Withdrawal($input: CreateWithdrawalInput!) {
  createWithdrawal(input: $input) {
    transaction {
      ...TransactionFragment
    }
    errors {
      ...ErrorFragment
    }
  }
}
    ${TransactionFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type WithdrawalMutationFn = Apollo.MutationFunction<WithdrawalMutation, WithdrawalMutationVariables>;

/**
 * __useWithdrawalMutation__
 *
 * To run a mutation, you first call `useWithdrawalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawalMutation, { data, loading, error }] = useWithdrawalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWithdrawalMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawalMutation, WithdrawalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawalMutation, WithdrawalMutationVariables>(WithdrawalDocument, options);
      }
export type WithdrawalMutationHookResult = ReturnType<typeof useWithdrawalMutation>;
export type WithdrawalMutationResult = Apollo.MutationResult<WithdrawalMutation>;
export type WithdrawalMutationOptions = Apollo.BaseMutationOptions<WithdrawalMutation, WithdrawalMutationVariables>;
export const RegistrationCompleteDocument = gql`
    mutation RegistrationComplete($input: RegistrationCompleteInput!) {
  registrationComplete(input: $input) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type RegistrationCompleteMutationFn = Apollo.MutationFunction<RegistrationCompleteMutation, RegistrationCompleteMutationVariables>;

/**
 * __useRegistrationCompleteMutation__
 *
 * To run a mutation, you first call `useRegistrationCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegistrationCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registrationCompleteMutation, { data, loading, error }] = useRegistrationCompleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegistrationCompleteMutation(baseOptions?: Apollo.MutationHookOptions<RegistrationCompleteMutation, RegistrationCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegistrationCompleteMutation, RegistrationCompleteMutationVariables>(RegistrationCompleteDocument, options);
      }
export type RegistrationCompleteMutationHookResult = ReturnType<typeof useRegistrationCompleteMutation>;
export type RegistrationCompleteMutationResult = Apollo.MutationResult<RegistrationCompleteMutation>;
export type RegistrationCompleteMutationOptions = Apollo.BaseMutationOptions<RegistrationCompleteMutation, RegistrationCompleteMutationVariables>;
export const BatchPublishClientEventsDocument = gql`
    mutation BatchPublishClientEvents($input: BatchPublishClientEventsInput!) {
  batchPublishClientEvents(input: $input) {
    errors {
      ... on Error {
        ...ErrorFragment
      }
      ... on ClientEventError {
        errors {
          ...ErrorFragment
        }
        event {
          ...ClientEventFragment
        }
      }
    }
    eventIds
  }
}
    ${ErrorFragmentFragmentDoc}
${ClientEventFragmentFragmentDoc}`;
export type BatchPublishClientEventsMutationFn = Apollo.MutationFunction<BatchPublishClientEventsMutation, BatchPublishClientEventsMutationVariables>;

/**
 * __useBatchPublishClientEventsMutation__
 *
 * To run a mutation, you first call `useBatchPublishClientEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchPublishClientEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchPublishClientEventsMutation, { data, loading, error }] = useBatchPublishClientEventsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchPublishClientEventsMutation(baseOptions?: Apollo.MutationHookOptions<BatchPublishClientEventsMutation, BatchPublishClientEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchPublishClientEventsMutation, BatchPublishClientEventsMutationVariables>(BatchPublishClientEventsDocument, options);
      }
export type BatchPublishClientEventsMutationHookResult = ReturnType<typeof useBatchPublishClientEventsMutation>;
export type BatchPublishClientEventsMutationResult = Apollo.MutationResult<BatchPublishClientEventsMutation>;
export type BatchPublishClientEventsMutationOptions = Apollo.BaseMutationOptions<BatchPublishClientEventsMutation, BatchPublishClientEventsMutationVariables>;
export const PublishEventDocument = gql`
    mutation PublishEvent($input: PublishClientEventInput!) {
  publishClientEvent(input: $input) {
    errors {
      ... on Error {
        ...ErrorFragment
      }
      ... on ClientEventError {
        errors {
          ...ErrorFragment
        }
        event {
          ...ClientEventFragment
        }
      }
    }
    eventId
  }
}
    ${ErrorFragmentFragmentDoc}
${ClientEventFragmentFragmentDoc}`;
export type PublishEventMutationFn = Apollo.MutationFunction<PublishEventMutation, PublishEventMutationVariables>;

/**
 * __usePublishEventMutation__
 *
 * To run a mutation, you first call `usePublishEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishEventMutation, { data, loading, error }] = usePublishEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishEventMutation(baseOptions?: Apollo.MutationHookOptions<PublishEventMutation, PublishEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishEventMutation, PublishEventMutationVariables>(PublishEventDocument, options);
      }
export type PublishEventMutationHookResult = ReturnType<typeof usePublishEventMutation>;
export type PublishEventMutationResult = Apollo.MutationResult<PublishEventMutation>;
export type PublishEventMutationOptions = Apollo.BaseMutationOptions<PublishEventMutation, PublishEventMutationVariables>;
export const PublishWebEventDocument = gql`
    mutation PublishWebEvent($input: PublishWebEventInput!) {
  publishWebEvent(input: $input) {
    errors {
      ... on Error {
        ...ErrorFragment
      }
      ... on ClientEventError {
        errors {
          ...ErrorFragment
        }
        event {
          ...ClientEventFragment
        }
      }
    }
    eventId
  }
}
    ${ErrorFragmentFragmentDoc}
${ClientEventFragmentFragmentDoc}`;
export type PublishWebEventMutationFn = Apollo.MutationFunction<PublishWebEventMutation, PublishWebEventMutationVariables>;

/**
 * __usePublishWebEventMutation__
 *
 * To run a mutation, you first call `usePublishWebEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishWebEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishWebEventMutation, { data, loading, error }] = usePublishWebEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishWebEventMutation(baseOptions?: Apollo.MutationHookOptions<PublishWebEventMutation, PublishWebEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishWebEventMutation, PublishWebEventMutationVariables>(PublishWebEventDocument, options);
      }
export type PublishWebEventMutationHookResult = ReturnType<typeof usePublishWebEventMutation>;
export type PublishWebEventMutationResult = Apollo.MutationResult<PublishWebEventMutation>;
export type PublishWebEventMutationOptions = Apollo.BaseMutationOptions<PublishWebEventMutation, PublishWebEventMutationVariables>;
export const PublishBackgroundEventDocument = gql`
    mutation PublishBackgroundEvent($input: PublishBackgroundEventInput!) {
  publishBackgroundEvent(input: $input) {
    errors {
      ... on Error {
        ...ErrorFragment
      }
      ... on ClientEventError {
        errors {
          ...ErrorFragment
        }
        event {
          ...ClientEventFragment
        }
      }
    }
    eventId
  }
}
    ${ErrorFragmentFragmentDoc}
${ClientEventFragmentFragmentDoc}`;
export type PublishBackgroundEventMutationFn = Apollo.MutationFunction<PublishBackgroundEventMutation, PublishBackgroundEventMutationVariables>;

/**
 * __usePublishBackgroundEventMutation__
 *
 * To run a mutation, you first call `usePublishBackgroundEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishBackgroundEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishBackgroundEventMutation, { data, loading, error }] = usePublishBackgroundEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishBackgroundEventMutation(baseOptions?: Apollo.MutationHookOptions<PublishBackgroundEventMutation, PublishBackgroundEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishBackgroundEventMutation, PublishBackgroundEventMutationVariables>(PublishBackgroundEventDocument, options);
      }
export type PublishBackgroundEventMutationHookResult = ReturnType<typeof usePublishBackgroundEventMutation>;
export type PublishBackgroundEventMutationResult = Apollo.MutationResult<PublishBackgroundEventMutation>;
export type PublishBackgroundEventMutationOptions = Apollo.BaseMutationOptions<PublishBackgroundEventMutation, PublishBackgroundEventMutationVariables>;
export const CreateUserFeatureOptInDocument = gql`
    mutation CreateUserFeatureOptIn($input: CreateUserFeatureOptInInput!) {
  createUserFeatureOptIn(input: $input) {
    errors {
      ...ErrorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type CreateUserFeatureOptInMutationFn = Apollo.MutationFunction<CreateUserFeatureOptInMutation, CreateUserFeatureOptInMutationVariables>;

/**
 * __useCreateUserFeatureOptInMutation__
 *
 * To run a mutation, you first call `useCreateUserFeatureOptInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserFeatureOptInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserFeatureOptInMutation, { data, loading, error }] = useCreateUserFeatureOptInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserFeatureOptInMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserFeatureOptInMutation, CreateUserFeatureOptInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserFeatureOptInMutation, CreateUserFeatureOptInMutationVariables>(CreateUserFeatureOptInDocument, options);
      }
export type CreateUserFeatureOptInMutationHookResult = ReturnType<typeof useCreateUserFeatureOptInMutation>;
export type CreateUserFeatureOptInMutationResult = Apollo.MutationResult<CreateUserFeatureOptInMutation>;
export type CreateUserFeatureOptInMutationOptions = Apollo.BaseMutationOptions<CreateUserFeatureOptInMutation, CreateUserFeatureOptInMutationVariables>;
export const SetUserAttributionDocument = gql`
    mutation SetUserAttribution($input: SetUserAttributionInput!) {
  setUserAttribution(input: $input) {
    errors {
      ... on Error {
        ...ErrorFragment
      }
      ... on InvalidUserAttributionError {
        message
        path
      }
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type SetUserAttributionMutationFn = Apollo.MutationFunction<SetUserAttributionMutation, SetUserAttributionMutationVariables>;

/**
 * __useSetUserAttributionMutation__
 *
 * To run a mutation, you first call `useSetUserAttributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserAttributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserAttributionMutation, { data, loading, error }] = useSetUserAttributionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserAttributionMutation(baseOptions?: Apollo.MutationHookOptions<SetUserAttributionMutation, SetUserAttributionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserAttributionMutation, SetUserAttributionMutationVariables>(SetUserAttributionDocument, options);
      }
export type SetUserAttributionMutationHookResult = ReturnType<typeof useSetUserAttributionMutation>;
export type SetUserAttributionMutationResult = Apollo.MutationResult<SetUserAttributionMutation>;
export type SetUserAttributionMutationOptions = Apollo.BaseMutationOptions<SetUserAttributionMutation, SetUserAttributionMutationVariables>;
export const UserDocument = gql`
    query User {
  user {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const LimitedUserDocument = gql`
    query LimitedUser {
  user {
    id
    firstName
    lastName
    email
    phone
    dob
    gender
    registrationCompletedAt
    emailConfirmedAt
    phoneConfirmedAt
    addresses {
      address1
      address2
      administrativeArea
      locality
      postalCode
    }
  }
}
    `;

/**
 * __useLimitedUserQuery__
 *
 * To run a query within a React component, call `useLimitedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLimitedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLimitedUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useLimitedUserQuery(baseOptions?: Apollo.QueryHookOptions<LimitedUserQuery, LimitedUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LimitedUserQuery, LimitedUserQueryVariables>(LimitedUserDocument, options);
      }
export function useLimitedUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LimitedUserQuery, LimitedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LimitedUserQuery, LimitedUserQueryVariables>(LimitedUserDocument, options);
        }
export function useLimitedUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LimitedUserQuery, LimitedUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LimitedUserQuery, LimitedUserQueryVariables>(LimitedUserDocument, options);
        }
export type LimitedUserQueryHookResult = ReturnType<typeof useLimitedUserQuery>;
export type LimitedUserLazyQueryHookResult = ReturnType<typeof useLimitedUserLazyQuery>;
export type LimitedUserSuspenseQueryHookResult = ReturnType<typeof useLimitedUserSuspenseQuery>;
export type LimitedUserQueryResult = Apollo.QueryResult<LimitedUserQuery, LimitedUserQueryVariables>;
export const OnboardedUserDocument = gql`
    query OnboardedUser {
  user {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useOnboardedUserQuery__
 *
 * To run a query within a React component, call `useOnboardedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardedUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardedUserQuery(baseOptions?: Apollo.QueryHookOptions<OnboardedUserQuery, OnboardedUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardedUserQuery, OnboardedUserQueryVariables>(OnboardedUserDocument, options);
      }
export function useOnboardedUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardedUserQuery, OnboardedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardedUserQuery, OnboardedUserQueryVariables>(OnboardedUserDocument, options);
        }
export function useOnboardedUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnboardedUserQuery, OnboardedUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardedUserQuery, OnboardedUserQueryVariables>(OnboardedUserDocument, options);
        }
export type OnboardedUserQueryHookResult = ReturnType<typeof useOnboardedUserQuery>;
export type OnboardedUserLazyQueryHookResult = ReturnType<typeof useOnboardedUserLazyQuery>;
export type OnboardedUserSuspenseQueryHookResult = ReturnType<typeof useOnboardedUserSuspenseQuery>;
export type OnboardedUserQueryResult = Apollo.QueryResult<OnboardedUserQuery, OnboardedUserQueryVariables>;
export const ActiveExperimentsDocument = gql`
    query ActiveExperiments {
  user {
    ...ActiveExperimentsFragment
  }
}
    ${ActiveExperimentsFragmentFragmentDoc}`;

/**
 * __useActiveExperimentsQuery__
 *
 * To run a query within a React component, call `useActiveExperimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveExperimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveExperimentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveExperimentsQuery(baseOptions?: Apollo.QueryHookOptions<ActiveExperimentsQuery, ActiveExperimentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveExperimentsQuery, ActiveExperimentsQueryVariables>(ActiveExperimentsDocument, options);
      }
export function useActiveExperimentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveExperimentsQuery, ActiveExperimentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveExperimentsQuery, ActiveExperimentsQueryVariables>(ActiveExperimentsDocument, options);
        }
export function useActiveExperimentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActiveExperimentsQuery, ActiveExperimentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveExperimentsQuery, ActiveExperimentsQueryVariables>(ActiveExperimentsDocument, options);
        }
export type ActiveExperimentsQueryHookResult = ReturnType<typeof useActiveExperimentsQuery>;
export type ActiveExperimentsLazyQueryHookResult = ReturnType<typeof useActiveExperimentsLazyQuery>;
export type ActiveExperimentsSuspenseQueryHookResult = ReturnType<typeof useActiveExperimentsSuspenseQuery>;
export type ActiveExperimentsQueryResult = Apollo.QueryResult<ActiveExperimentsQuery, ActiveExperimentsQueryVariables>;
export const PotentialRewardsDocument = gql`
    query PotentialRewards {
  user {
    ...PotentialRewardsFragment
  }
}
    ${PotentialRewardsFragmentFragmentDoc}`;

/**
 * __usePotentialRewardsQuery__
 *
 * To run a query within a React component, call `usePotentialRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePotentialRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePotentialRewardsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePotentialRewardsQuery(baseOptions?: Apollo.QueryHookOptions<PotentialRewardsQuery, PotentialRewardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PotentialRewardsQuery, PotentialRewardsQueryVariables>(PotentialRewardsDocument, options);
      }
export function usePotentialRewardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PotentialRewardsQuery, PotentialRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PotentialRewardsQuery, PotentialRewardsQueryVariables>(PotentialRewardsDocument, options);
        }
export function usePotentialRewardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PotentialRewardsQuery, PotentialRewardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PotentialRewardsQuery, PotentialRewardsQueryVariables>(PotentialRewardsDocument, options);
        }
export type PotentialRewardsQueryHookResult = ReturnType<typeof usePotentialRewardsQuery>;
export type PotentialRewardsLazyQueryHookResult = ReturnType<typeof usePotentialRewardsLazyQuery>;
export type PotentialRewardsSuspenseQueryHookResult = ReturnType<typeof usePotentialRewardsSuspenseQuery>;
export type PotentialRewardsQueryResult = Apollo.QueryResult<PotentialRewardsQuery, PotentialRewardsQueryVariables>;
export const WithdrawalEligibilityDocument = gql`
    query WithdrawalEligibility {
  user {
    eligibleForWithdrawal
  }
}
    `;

/**
 * __useWithdrawalEligibilityQuery__
 *
 * To run a query within a React component, call `useWithdrawalEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useWithdrawalEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithdrawalEligibilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useWithdrawalEligibilityQuery(baseOptions?: Apollo.QueryHookOptions<WithdrawalEligibilityQuery, WithdrawalEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WithdrawalEligibilityQuery, WithdrawalEligibilityQueryVariables>(WithdrawalEligibilityDocument, options);
      }
export function useWithdrawalEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WithdrawalEligibilityQuery, WithdrawalEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WithdrawalEligibilityQuery, WithdrawalEligibilityQueryVariables>(WithdrawalEligibilityDocument, options);
        }
export function useWithdrawalEligibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WithdrawalEligibilityQuery, WithdrawalEligibilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WithdrawalEligibilityQuery, WithdrawalEligibilityQueryVariables>(WithdrawalEligibilityDocument, options);
        }
export type WithdrawalEligibilityQueryHookResult = ReturnType<typeof useWithdrawalEligibilityQuery>;
export type WithdrawalEligibilityLazyQueryHookResult = ReturnType<typeof useWithdrawalEligibilityLazyQuery>;
export type WithdrawalEligibilitySuspenseQueryHookResult = ReturnType<typeof useWithdrawalEligibilitySuspenseQuery>;
export type WithdrawalEligibilityQueryResult = Apollo.QueryResult<WithdrawalEligibilityQuery, WithdrawalEligibilityQueryVariables>;
export const AddDataContainersDocument = gql`
    query AddDataContainers {
  addDataContainers {
    ...QuestionContainerFragment
  }
}
    ${QuestionContainerFragmentFragmentDoc}`;

/**
 * __useAddDataContainersQuery__
 *
 * To run a query within a React component, call `useAddDataContainersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddDataContainersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddDataContainersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddDataContainersQuery(baseOptions?: Apollo.QueryHookOptions<AddDataContainersQuery, AddDataContainersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddDataContainersQuery, AddDataContainersQueryVariables>(AddDataContainersDocument, options);
      }
export function useAddDataContainersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddDataContainersQuery, AddDataContainersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddDataContainersQuery, AddDataContainersQueryVariables>(AddDataContainersDocument, options);
        }
export function useAddDataContainersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddDataContainersQuery, AddDataContainersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddDataContainersQuery, AddDataContainersQueryVariables>(AddDataContainersDocument, options);
        }
export type AddDataContainersQueryHookResult = ReturnType<typeof useAddDataContainersQuery>;
export type AddDataContainersLazyQueryHookResult = ReturnType<typeof useAddDataContainersLazyQuery>;
export type AddDataContainersSuspenseQueryHookResult = ReturnType<typeof useAddDataContainersSuspenseQuery>;
export type AddDataContainersQueryResult = Apollo.QueryResult<AddDataContainersQuery, AddDataContainersQueryVariables>;
export const AvailableBidsDocument = gql`
    query AvailableBids {
  availableBids {
    nodes {
      ...PartnerBidFragment
    }
  }
}
    ${PartnerBidFragmentFragmentDoc}`;

/**
 * __useAvailableBidsQuery__
 *
 * To run a query within a React component, call `useAvailableBidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableBidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableBidsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableBidsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableBidsQuery, AvailableBidsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableBidsQuery, AvailableBidsQueryVariables>(AvailableBidsDocument, options);
      }
export function useAvailableBidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableBidsQuery, AvailableBidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableBidsQuery, AvailableBidsQueryVariables>(AvailableBidsDocument, options);
        }
export function useAvailableBidsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableBidsQuery, AvailableBidsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableBidsQuery, AvailableBidsQueryVariables>(AvailableBidsDocument, options);
        }
export type AvailableBidsQueryHookResult = ReturnType<typeof useAvailableBidsQuery>;
export type AvailableBidsLazyQueryHookResult = ReturnType<typeof useAvailableBidsLazyQuery>;
export type AvailableBidsSuspenseQueryHookResult = ReturnType<typeof useAvailableBidsSuspenseQuery>;
export type AvailableBidsQueryResult = Apollo.QueryResult<AvailableBidsQuery, AvailableBidsQueryVariables>;
export const UserDataContainersDocument = gql`
    query UserDataContainers {
  userDataContainers {
    ...QuestionContainerFragment
  }
}
    ${QuestionContainerFragmentFragmentDoc}`;

/**
 * __useUserDataContainersQuery__
 *
 * To run a query within a React component, call `useUserDataContainersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDataContainersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDataContainersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDataContainersQuery(baseOptions?: Apollo.QueryHookOptions<UserDataContainersQuery, UserDataContainersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDataContainersQuery, UserDataContainersQueryVariables>(UserDataContainersDocument, options);
      }
export function useUserDataContainersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDataContainersQuery, UserDataContainersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDataContainersQuery, UserDataContainersQueryVariables>(UserDataContainersDocument, options);
        }
export function useUserDataContainersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDataContainersQuery, UserDataContainersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDataContainersQuery, UserDataContainersQueryVariables>(UserDataContainersDocument, options);
        }
export type UserDataContainersQueryHookResult = ReturnType<typeof useUserDataContainersQuery>;
export type UserDataContainersLazyQueryHookResult = ReturnType<typeof useUserDataContainersLazyQuery>;
export type UserDataContainersSuspenseQueryHookResult = ReturnType<typeof useUserDataContainersSuspenseQuery>;
export type UserDataContainersQueryResult = Apollo.QueryResult<UserDataContainersQuery, UserDataContainersQueryVariables>;
export const UserDataContainersForAddDataDocument = gql`
    query UserDataContainersForAddData {
  userDataContainers {
    name
  }
}
    `;

/**
 * __useUserDataContainersForAddDataQuery__
 *
 * To run a query within a React component, call `useUserDataContainersForAddDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDataContainersForAddDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDataContainersForAddDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDataContainersForAddDataQuery(baseOptions?: Apollo.QueryHookOptions<UserDataContainersForAddDataQuery, UserDataContainersForAddDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDataContainersForAddDataQuery, UserDataContainersForAddDataQueryVariables>(UserDataContainersForAddDataDocument, options);
      }
export function useUserDataContainersForAddDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDataContainersForAddDataQuery, UserDataContainersForAddDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDataContainersForAddDataQuery, UserDataContainersForAddDataQueryVariables>(UserDataContainersForAddDataDocument, options);
        }
export function useUserDataContainersForAddDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDataContainersForAddDataQuery, UserDataContainersForAddDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDataContainersForAddDataQuery, UserDataContainersForAddDataQueryVariables>(UserDataContainersForAddDataDocument, options);
        }
export type UserDataContainersForAddDataQueryHookResult = ReturnType<typeof useUserDataContainersForAddDataQuery>;
export type UserDataContainersForAddDataLazyQueryHookResult = ReturnType<typeof useUserDataContainersForAddDataLazyQuery>;
export type UserDataContainersForAddDataSuspenseQueryHookResult = ReturnType<typeof useUserDataContainersForAddDataSuspenseQuery>;
export type UserDataContainersForAddDataQueryResult = Apollo.QueryResult<UserDataContainersForAddDataQuery, UserDataContainersForAddDataQueryVariables>;
export const OnboardingQuestionContainersDocument = gql`
    query OnboardingQuestionContainers {
  onboardingQuestionContainers {
    ...QuestionContainerFragment
  }
}
    ${QuestionContainerFragmentFragmentDoc}`;

/**
 * __useOnboardingQuestionContainersQuery__
 *
 * To run a query within a React component, call `useOnboardingQuestionContainersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingQuestionContainersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingQuestionContainersQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingQuestionContainersQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingQuestionContainersQuery, OnboardingQuestionContainersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingQuestionContainersQuery, OnboardingQuestionContainersQueryVariables>(OnboardingQuestionContainersDocument, options);
      }
export function useOnboardingQuestionContainersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingQuestionContainersQuery, OnboardingQuestionContainersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingQuestionContainersQuery, OnboardingQuestionContainersQueryVariables>(OnboardingQuestionContainersDocument, options);
        }
export function useOnboardingQuestionContainersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnboardingQuestionContainersQuery, OnboardingQuestionContainersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingQuestionContainersQuery, OnboardingQuestionContainersQueryVariables>(OnboardingQuestionContainersDocument, options);
        }
export type OnboardingQuestionContainersQueryHookResult = ReturnType<typeof useOnboardingQuestionContainersQuery>;
export type OnboardingQuestionContainersLazyQueryHookResult = ReturnType<typeof useOnboardingQuestionContainersLazyQuery>;
export type OnboardingQuestionContainersSuspenseQueryHookResult = ReturnType<typeof useOnboardingQuestionContainersSuspenseQuery>;
export type OnboardingQuestionContainersQueryResult = Apollo.QueryResult<OnboardingQuestionContainersQuery, OnboardingQuestionContainersQueryVariables>;
export const UserStateDocument = gql`
    query UserState {
  user {
    ...UserFragment
  }
  onboardingQuestionContainers {
    ...QuestionContainerFragment
  }
  bankAccount {
    ...BankAccountFragment
  }
  appSettings {
    ...AppSettingsFragment
  }
}
    ${UserFragmentFragmentDoc}
${QuestionContainerFragmentFragmentDoc}
${BankAccountFragmentFragmentDoc}
${AppSettingsFragmentFragmentDoc}`;

/**
 * __useUserStateQuery__
 *
 * To run a query within a React component, call `useUserStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserStateQuery(baseOptions?: Apollo.QueryHookOptions<UserStateQuery, UserStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserStateQuery, UserStateQueryVariables>(UserStateDocument, options);
      }
export function useUserStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserStateQuery, UserStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserStateQuery, UserStateQueryVariables>(UserStateDocument, options);
        }
export function useUserStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserStateQuery, UserStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserStateQuery, UserStateQueryVariables>(UserStateDocument, options);
        }
export type UserStateQueryHookResult = ReturnType<typeof useUserStateQuery>;
export type UserStateLazyQueryHookResult = ReturnType<typeof useUserStateLazyQuery>;
export type UserStateSuspenseQueryHookResult = ReturnType<typeof useUserStateSuspenseQuery>;
export type UserStateQueryResult = Apollo.QueryResult<UserStateQuery, UserStateQueryVariables>;
export const BankAccountDocument = gql`
    query BankAccount {
  bankAccount {
    ...BankAccountFragment
  }
}
    ${BankAccountFragmentFragmentDoc}`;

/**
 * __useBankAccountQuery__
 *
 * To run a query within a React component, call `useBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankAccountQuery(baseOptions?: Apollo.QueryHookOptions<BankAccountQuery, BankAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankAccountQuery, BankAccountQueryVariables>(BankAccountDocument, options);
      }
export function useBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankAccountQuery, BankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankAccountQuery, BankAccountQueryVariables>(BankAccountDocument, options);
        }
export function useBankAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankAccountQuery, BankAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BankAccountQuery, BankAccountQueryVariables>(BankAccountDocument, options);
        }
export type BankAccountQueryHookResult = ReturnType<typeof useBankAccountQuery>;
export type BankAccountLazyQueryHookResult = ReturnType<typeof useBankAccountLazyQuery>;
export type BankAccountSuspenseQueryHookResult = ReturnType<typeof useBankAccountSuspenseQuery>;
export type BankAccountQueryResult = Apollo.QueryResult<BankAccountQuery, BankAccountQueryVariables>;
export const BalanceDocument = gql`
    query Balance {
  balance {
    ...BalanceFragment
  }
}
    ${BalanceFragmentFragmentDoc}`;

/**
 * __useBalanceQuery__
 *
 * To run a query within a React component, call `useBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useBalanceQuery(baseOptions?: Apollo.QueryHookOptions<BalanceQuery, BalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BalanceQuery, BalanceQueryVariables>(BalanceDocument, options);
      }
export function useBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BalanceQuery, BalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BalanceQuery, BalanceQueryVariables>(BalanceDocument, options);
        }
export function useBalanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BalanceQuery, BalanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BalanceQuery, BalanceQueryVariables>(BalanceDocument, options);
        }
export type BalanceQueryHookResult = ReturnType<typeof useBalanceQuery>;
export type BalanceLazyQueryHookResult = ReturnType<typeof useBalanceLazyQuery>;
export type BalanceSuspenseQueryHookResult = ReturnType<typeof useBalanceSuspenseQuery>;
export type BalanceQueryResult = Apollo.QueryResult<BalanceQuery, BalanceQueryVariables>;
export const RecentTransactionsDocument = gql`
    query RecentTransactions($after: String, $before: String, $first: Int, $last: Int) {
  recentTransactions(after: $after, before: $before, first: $first, last: $last) {
    ...TransactionConnectionFragment
  }
}
    ${TransactionConnectionFragmentFragmentDoc}`;

/**
 * __useRecentTransactionsQuery__
 *
 * To run a query within a React component, call `useRecentTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentTransactionsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useRecentTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<RecentTransactionsQuery, RecentTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentTransactionsQuery, RecentTransactionsQueryVariables>(RecentTransactionsDocument, options);
      }
export function useRecentTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentTransactionsQuery, RecentTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentTransactionsQuery, RecentTransactionsQueryVariables>(RecentTransactionsDocument, options);
        }
export function useRecentTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentTransactionsQuery, RecentTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentTransactionsQuery, RecentTransactionsQueryVariables>(RecentTransactionsDocument, options);
        }
export type RecentTransactionsQueryHookResult = ReturnType<typeof useRecentTransactionsQuery>;
export type RecentTransactionsLazyQueryHookResult = ReturnType<typeof useRecentTransactionsLazyQuery>;
export type RecentTransactionsSuspenseQueryHookResult = ReturnType<typeof useRecentTransactionsSuspenseQuery>;
export type RecentTransactionsQueryResult = Apollo.QueryResult<RecentTransactionsQuery, RecentTransactionsQueryVariables>;
export const AppSettingsDocument = gql`
    query AppSettings {
  appSettings {
    ...AppSettingsFragment
  }
}
    ${AppSettingsFragmentFragmentDoc}`;

/**
 * __useAppSettingsQuery__
 *
 * To run a query within a React component, call `useAppSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppSettingsQuery(baseOptions?: Apollo.QueryHookOptions<AppSettingsQuery, AppSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppSettingsQuery, AppSettingsQueryVariables>(AppSettingsDocument, options);
      }
export function useAppSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppSettingsQuery, AppSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppSettingsQuery, AppSettingsQueryVariables>(AppSettingsDocument, options);
        }
export function useAppSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AppSettingsQuery, AppSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppSettingsQuery, AppSettingsQueryVariables>(AppSettingsDocument, options);
        }
export type AppSettingsQueryHookResult = ReturnType<typeof useAppSettingsQuery>;
export type AppSettingsLazyQueryHookResult = ReturnType<typeof useAppSettingsLazyQuery>;
export type AppSettingsSuspenseQueryHookResult = ReturnType<typeof useAppSettingsSuspenseQuery>;
export type AppSettingsQueryResult = Apollo.QueryResult<AppSettingsQuery, AppSettingsQueryVariables>;
export const QuestionContainersDocument = gql`
    query QuestionContainers($ids: [ID!]!) {
  questionContainers(ids: $ids) {
    ...QuestionContainerFragment
  }
}
    ${QuestionContainerFragmentFragmentDoc}`;

/**
 * __useQuestionContainersQuery__
 *
 * To run a query within a React component, call `useQuestionContainersQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionContainersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionContainersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useQuestionContainersQuery(baseOptions: Apollo.QueryHookOptions<QuestionContainersQuery, QuestionContainersQueryVariables> & ({ variables: QuestionContainersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionContainersQuery, QuestionContainersQueryVariables>(QuestionContainersDocument, options);
      }
export function useQuestionContainersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionContainersQuery, QuestionContainersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionContainersQuery, QuestionContainersQueryVariables>(QuestionContainersDocument, options);
        }
export function useQuestionContainersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionContainersQuery, QuestionContainersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionContainersQuery, QuestionContainersQueryVariables>(QuestionContainersDocument, options);
        }
export type QuestionContainersQueryHookResult = ReturnType<typeof useQuestionContainersQuery>;
export type QuestionContainersLazyQueryHookResult = ReturnType<typeof useQuestionContainersLazyQuery>;
export type QuestionContainersSuspenseQueryHookResult = ReturnType<typeof useQuestionContainersSuspenseQuery>;
export type QuestionContainersQueryResult = Apollo.QueryResult<QuestionContainersQuery, QuestionContainersQueryVariables>;
export const PartnersDocument = gql`
    query Partners($ids: [ID!]!) {
  partners(ids: $ids) {
    ...PartnerFragment
  }
}
    ${PartnerFragmentFragmentDoc}`;

/**
 * __usePartnersQuery__
 *
 * To run a query within a React component, call `usePartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePartnersQuery(baseOptions: Apollo.QueryHookOptions<PartnersQuery, PartnersQueryVariables> & ({ variables: PartnersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnersQuery, PartnersQueryVariables>(PartnersDocument, options);
      }
export function usePartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnersQuery, PartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnersQuery, PartnersQueryVariables>(PartnersDocument, options);
        }
export function usePartnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnersQuery, PartnersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnersQuery, PartnersQueryVariables>(PartnersDocument, options);
        }
export type PartnersQueryHookResult = ReturnType<typeof usePartnersQuery>;
export type PartnersLazyQueryHookResult = ReturnType<typeof usePartnersLazyQuery>;
export type PartnersSuspenseQueryHookResult = ReturnType<typeof usePartnersSuspenseQuery>;
export type PartnersQueryResult = Apollo.QueryResult<PartnersQuery, PartnersQueryVariables>;
export const AppVersionSupportedDocument = gql`
    query AppVersionSupported($platform: ClientPlatformEnum!, $version: String!) {
  appVersionSupported(platform: $platform, version: $version)
}
    `;

/**
 * __useAppVersionSupportedQuery__
 *
 * To run a query within a React component, call `useAppVersionSupportedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppVersionSupportedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppVersionSupportedQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useAppVersionSupportedQuery(baseOptions: Apollo.QueryHookOptions<AppVersionSupportedQuery, AppVersionSupportedQueryVariables> & ({ variables: AppVersionSupportedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppVersionSupportedQuery, AppVersionSupportedQueryVariables>(AppVersionSupportedDocument, options);
      }
export function useAppVersionSupportedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppVersionSupportedQuery, AppVersionSupportedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppVersionSupportedQuery, AppVersionSupportedQueryVariables>(AppVersionSupportedDocument, options);
        }
export function useAppVersionSupportedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AppVersionSupportedQuery, AppVersionSupportedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppVersionSupportedQuery, AppVersionSupportedQueryVariables>(AppVersionSupportedDocument, options);
        }
export type AppVersionSupportedQueryHookResult = ReturnType<typeof useAppVersionSupportedQuery>;
export type AppVersionSupportedLazyQueryHookResult = ReturnType<typeof useAppVersionSupportedLazyQuery>;
export type AppVersionSupportedSuspenseQueryHookResult = ReturnType<typeof useAppVersionSupportedSuspenseQuery>;
export type AppVersionSupportedQueryResult = Apollo.QueryResult<AppVersionSupportedQuery, AppVersionSupportedQueryVariables>;
export const ReferralDocument = gql`
    query Referral {
  referral {
    ...ReferralFragment
  }
}
    ${ReferralFragmentFragmentDoc}`;

/**
 * __useReferralQuery__
 *
 * To run a query within a React component, call `useReferralQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferralQuery(baseOptions?: Apollo.QueryHookOptions<ReferralQuery, ReferralQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferralQuery, ReferralQueryVariables>(ReferralDocument, options);
      }
export function useReferralLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferralQuery, ReferralQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferralQuery, ReferralQueryVariables>(ReferralDocument, options);
        }
export function useReferralSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReferralQuery, ReferralQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReferralQuery, ReferralQueryVariables>(ReferralDocument, options);
        }
export type ReferralQueryHookResult = ReturnType<typeof useReferralQuery>;
export type ReferralLazyQueryHookResult = ReturnType<typeof useReferralLazyQuery>;
export type ReferralSuspenseQueryHookResult = ReturnType<typeof useReferralSuspenseQuery>;
export type ReferralQueryResult = Apollo.QueryResult<ReferralQuery, ReferralQueryVariables>;
export const SharedUserIdDocument = gql`
    query SharedUserId {
  sharedUser {
    id
  }
}
    `;

/**
 * __useSharedUserIdQuery__
 *
 * To run a query within a React component, call `useSharedUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useSharedUserIdQuery(baseOptions?: Apollo.QueryHookOptions<SharedUserIdQuery, SharedUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedUserIdQuery, SharedUserIdQueryVariables>(SharedUserIdDocument, options);
      }
export function useSharedUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedUserIdQuery, SharedUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedUserIdQuery, SharedUserIdQueryVariables>(SharedUserIdDocument, options);
        }
export function useSharedUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedUserIdQuery, SharedUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedUserIdQuery, SharedUserIdQueryVariables>(SharedUserIdDocument, options);
        }
export type SharedUserIdQueryHookResult = ReturnType<typeof useSharedUserIdQuery>;
export type SharedUserIdLazyQueryHookResult = ReturnType<typeof useSharedUserIdLazyQuery>;
export type SharedUserIdSuspenseQueryHookResult = ReturnType<typeof useSharedUserIdSuspenseQuery>;
export type SharedUserIdQueryResult = Apollo.QueryResult<SharedUserIdQuery, SharedUserIdQueryVariables>;
export const AccountTasksDocument = gql`
    query AccountTasks {
  appSettings {
    accountStrengthCardHeaderCopy
    accountStrengthIncentiveCopy
  }
  user {
    accountTaskLists {
      nodes {
        accountTasks {
          ...AccountTaskFragment
        }
        completedAt
      }
    }
  }
}
    ${AccountTaskFragmentFragmentDoc}`;

/**
 * __useAccountTasksQuery__
 *
 * To run a query within a React component, call `useAccountTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountTasksQuery(baseOptions?: Apollo.QueryHookOptions<AccountTasksQuery, AccountTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountTasksQuery, AccountTasksQueryVariables>(AccountTasksDocument, options);
      }
export function useAccountTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountTasksQuery, AccountTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountTasksQuery, AccountTasksQueryVariables>(AccountTasksDocument, options);
        }
export function useAccountTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountTasksQuery, AccountTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountTasksQuery, AccountTasksQueryVariables>(AccountTasksDocument, options);
        }
export type AccountTasksQueryHookResult = ReturnType<typeof useAccountTasksQuery>;
export type AccountTasksLazyQueryHookResult = ReturnType<typeof useAccountTasksLazyQuery>;
export type AccountTasksSuspenseQueryHookResult = ReturnType<typeof useAccountTasksSuspenseQuery>;
export type AccountTasksQueryResult = Apollo.QueryResult<AccountTasksQuery, AccountTasksQueryVariables>;
export const PublicOffersForUrlDocument = gql`
    query PublicOffersForUrl($url: String!, $placementId: ID!) {
  publicOffersForUrl(url: $url, placementId: $placementId) {
    nodes {
      ... on Deal {
        ...DealFragment
      }
    }
  }
}
    ${DealFragmentFragmentDoc}`;

/**
 * __usePublicOffersForUrlQuery__
 *
 * To run a query within a React component, call `usePublicOffersForUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicOffersForUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicOffersForUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      placementId: // value for 'placementId'
 *   },
 * });
 */
export function usePublicOffersForUrlQuery(baseOptions: Apollo.QueryHookOptions<PublicOffersForUrlQuery, PublicOffersForUrlQueryVariables> & ({ variables: PublicOffersForUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicOffersForUrlQuery, PublicOffersForUrlQueryVariables>(PublicOffersForUrlDocument, options);
      }
export function usePublicOffersForUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicOffersForUrlQuery, PublicOffersForUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicOffersForUrlQuery, PublicOffersForUrlQueryVariables>(PublicOffersForUrlDocument, options);
        }
export function usePublicOffersForUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicOffersForUrlQuery, PublicOffersForUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicOffersForUrlQuery, PublicOffersForUrlQueryVariables>(PublicOffersForUrlDocument, options);
        }
export type PublicOffersForUrlQueryHookResult = ReturnType<typeof usePublicOffersForUrlQuery>;
export type PublicOffersForUrlLazyQueryHookResult = ReturnType<typeof usePublicOffersForUrlLazyQuery>;
export type PublicOffersForUrlSuspenseQueryHookResult = ReturnType<typeof usePublicOffersForUrlSuspenseQuery>;
export type PublicOffersForUrlQueryResult = Apollo.QueryResult<PublicOffersForUrlQuery, PublicOffersForUrlQueryVariables>;
export const PartnerOfferCategoryByIdOffersDocument = gql`
    query PartnerOfferCategoryByIdOffers($categoryId: ID!, $placementId: ID!, $after: String, $before: String, $first: Int, $last: Int) {
  findPartnerOfferCategoryById(id: $categoryId, placementId: $placementId) {
    ...PartnerOfferCategoryFragment
    myFullPartnerOffers1(after: $after, before: $before, first: $first, last: $last) {
      nodes {
        ... on Deal {
          ...DealFragment
        }
      }
    }
  }
}
    ${PartnerOfferCategoryFragmentFragmentDoc}
${DealFragmentFragmentDoc}`;

/**
 * __usePartnerOfferCategoryByIdOffersQuery__
 *
 * To run a query within a React component, call `usePartnerOfferCategoryByIdOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerOfferCategoryByIdOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerOfferCategoryByIdOffersQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      placementId: // value for 'placementId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function usePartnerOfferCategoryByIdOffersQuery(baseOptions: Apollo.QueryHookOptions<PartnerOfferCategoryByIdOffersQuery, PartnerOfferCategoryByIdOffersQueryVariables> & ({ variables: PartnerOfferCategoryByIdOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerOfferCategoryByIdOffersQuery, PartnerOfferCategoryByIdOffersQueryVariables>(PartnerOfferCategoryByIdOffersDocument, options);
      }
export function usePartnerOfferCategoryByIdOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerOfferCategoryByIdOffersQuery, PartnerOfferCategoryByIdOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerOfferCategoryByIdOffersQuery, PartnerOfferCategoryByIdOffersQueryVariables>(PartnerOfferCategoryByIdOffersDocument, options);
        }
export function usePartnerOfferCategoryByIdOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerOfferCategoryByIdOffersQuery, PartnerOfferCategoryByIdOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerOfferCategoryByIdOffersQuery, PartnerOfferCategoryByIdOffersQueryVariables>(PartnerOfferCategoryByIdOffersDocument, options);
        }
export type PartnerOfferCategoryByIdOffersQueryHookResult = ReturnType<typeof usePartnerOfferCategoryByIdOffersQuery>;
export type PartnerOfferCategoryByIdOffersLazyQueryHookResult = ReturnType<typeof usePartnerOfferCategoryByIdOffersLazyQuery>;
export type PartnerOfferCategoryByIdOffersSuspenseQueryHookResult = ReturnType<typeof usePartnerOfferCategoryByIdOffersSuspenseQuery>;
export type PartnerOfferCategoryByIdOffersQueryResult = Apollo.QueryResult<PartnerOfferCategoryByIdOffersQuery, PartnerOfferCategoryByIdOffersQueryVariables>;
export const PartnerOfferPlacementByIdOffersDocument = gql`
    query PartnerOfferPlacementByIdOffers($placementId: ID!, $after: String, $before: String, $first: Int, $last: Int) {
  offersForPlacement(
    placementId: $placementId
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    nodes {
      ... on Deal {
        ...DealFragment
      }
    }
  }
}
    ${DealFragmentFragmentDoc}`;

/**
 * __usePartnerOfferPlacementByIdOffersQuery__
 *
 * To run a query within a React component, call `usePartnerOfferPlacementByIdOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerOfferPlacementByIdOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerOfferPlacementByIdOffersQuery({
 *   variables: {
 *      placementId: // value for 'placementId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function usePartnerOfferPlacementByIdOffersQuery(baseOptions: Apollo.QueryHookOptions<PartnerOfferPlacementByIdOffersQuery, PartnerOfferPlacementByIdOffersQueryVariables> & ({ variables: PartnerOfferPlacementByIdOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerOfferPlacementByIdOffersQuery, PartnerOfferPlacementByIdOffersQueryVariables>(PartnerOfferPlacementByIdOffersDocument, options);
      }
export function usePartnerOfferPlacementByIdOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerOfferPlacementByIdOffersQuery, PartnerOfferPlacementByIdOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerOfferPlacementByIdOffersQuery, PartnerOfferPlacementByIdOffersQueryVariables>(PartnerOfferPlacementByIdOffersDocument, options);
        }
export function usePartnerOfferPlacementByIdOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerOfferPlacementByIdOffersQuery, PartnerOfferPlacementByIdOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerOfferPlacementByIdOffersQuery, PartnerOfferPlacementByIdOffersQueryVariables>(PartnerOfferPlacementByIdOffersDocument, options);
        }
export type PartnerOfferPlacementByIdOffersQueryHookResult = ReturnType<typeof usePartnerOfferPlacementByIdOffersQuery>;
export type PartnerOfferPlacementByIdOffersLazyQueryHookResult = ReturnType<typeof usePartnerOfferPlacementByIdOffersLazyQuery>;
export type PartnerOfferPlacementByIdOffersSuspenseQueryHookResult = ReturnType<typeof usePartnerOfferPlacementByIdOffersSuspenseQuery>;
export type PartnerOfferPlacementByIdOffersQueryResult = Apollo.QueryResult<PartnerOfferPlacementByIdOffersQuery, PartnerOfferPlacementByIdOffersQueryVariables>;
export const PublicOffersForPlacementDocument = gql`
    query PublicOffersForPlacement($placementId: ID!) {
  publicOffersForPlacement(placementId: $placementId) {
    nodes {
      ... on Deal {
        ...DealFragment
      }
    }
  }
}
    ${DealFragmentFragmentDoc}`;

/**
 * __usePublicOffersForPlacementQuery__
 *
 * To run a query within a React component, call `usePublicOffersForPlacementQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicOffersForPlacementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicOffersForPlacementQuery({
 *   variables: {
 *      placementId: // value for 'placementId'
 *   },
 * });
 */
export function usePublicOffersForPlacementQuery(baseOptions: Apollo.QueryHookOptions<PublicOffersForPlacementQuery, PublicOffersForPlacementQueryVariables> & ({ variables: PublicOffersForPlacementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicOffersForPlacementQuery, PublicOffersForPlacementQueryVariables>(PublicOffersForPlacementDocument, options);
      }
export function usePublicOffersForPlacementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicOffersForPlacementQuery, PublicOffersForPlacementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicOffersForPlacementQuery, PublicOffersForPlacementQueryVariables>(PublicOffersForPlacementDocument, options);
        }
export function usePublicOffersForPlacementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicOffersForPlacementQuery, PublicOffersForPlacementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicOffersForPlacementQuery, PublicOffersForPlacementQueryVariables>(PublicOffersForPlacementDocument, options);
        }
export type PublicOffersForPlacementQueryHookResult = ReturnType<typeof usePublicOffersForPlacementQuery>;
export type PublicOffersForPlacementLazyQueryHookResult = ReturnType<typeof usePublicOffersForPlacementLazyQuery>;
export type PublicOffersForPlacementSuspenseQueryHookResult = ReturnType<typeof usePublicOffersForPlacementSuspenseQuery>;
export type PublicOffersForPlacementQueryResult = Apollo.QueryResult<PublicOffersForPlacementQuery, PublicOffersForPlacementQueryVariables>;
export const PublicOffersForPlacementPartnerLinksDocument = gql`
    query PublicOffersForPlacementPartnerLinks($placementId: ID!) {
  publicOffersForPlacement(placementId: $placementId) {
    nodes {
      ... on Deal {
        ctaUrl
        partner {
          name
        }
      }
    }
  }
}
    `;

/**
 * __usePublicOffersForPlacementPartnerLinksQuery__
 *
 * To run a query within a React component, call `usePublicOffersForPlacementPartnerLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicOffersForPlacementPartnerLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicOffersForPlacementPartnerLinksQuery({
 *   variables: {
 *      placementId: // value for 'placementId'
 *   },
 * });
 */
export function usePublicOffersForPlacementPartnerLinksQuery(baseOptions: Apollo.QueryHookOptions<PublicOffersForPlacementPartnerLinksQuery, PublicOffersForPlacementPartnerLinksQueryVariables> & ({ variables: PublicOffersForPlacementPartnerLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicOffersForPlacementPartnerLinksQuery, PublicOffersForPlacementPartnerLinksQueryVariables>(PublicOffersForPlacementPartnerLinksDocument, options);
      }
export function usePublicOffersForPlacementPartnerLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicOffersForPlacementPartnerLinksQuery, PublicOffersForPlacementPartnerLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicOffersForPlacementPartnerLinksQuery, PublicOffersForPlacementPartnerLinksQueryVariables>(PublicOffersForPlacementPartnerLinksDocument, options);
        }
export function usePublicOffersForPlacementPartnerLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicOffersForPlacementPartnerLinksQuery, PublicOffersForPlacementPartnerLinksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicOffersForPlacementPartnerLinksQuery, PublicOffersForPlacementPartnerLinksQueryVariables>(PublicOffersForPlacementPartnerLinksDocument, options);
        }
export type PublicOffersForPlacementPartnerLinksQueryHookResult = ReturnType<typeof usePublicOffersForPlacementPartnerLinksQuery>;
export type PublicOffersForPlacementPartnerLinksLazyQueryHookResult = ReturnType<typeof usePublicOffersForPlacementPartnerLinksLazyQuery>;
export type PublicOffersForPlacementPartnerLinksSuspenseQueryHookResult = ReturnType<typeof usePublicOffersForPlacementPartnerLinksSuspenseQuery>;
export type PublicOffersForPlacementPartnerLinksQueryResult = Apollo.QueryResult<PublicOffersForPlacementPartnerLinksQuery, PublicOffersForPlacementPartnerLinksQueryVariables>;
export const MonitoredBankAccountsDocument = gql`
    query MonitoredBankAccounts {
  monitoredBankAccounts {
    ...MonitoredBankAccountFragment
  }
}
    ${MonitoredBankAccountFragmentFragmentDoc}`;

/**
 * __useMonitoredBankAccountsQuery__
 *
 * To run a query within a React component, call `useMonitoredBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonitoredBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonitoredBankAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMonitoredBankAccountsQuery(baseOptions?: Apollo.QueryHookOptions<MonitoredBankAccountsQuery, MonitoredBankAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MonitoredBankAccountsQuery, MonitoredBankAccountsQueryVariables>(MonitoredBankAccountsDocument, options);
      }
export function useMonitoredBankAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MonitoredBankAccountsQuery, MonitoredBankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MonitoredBankAccountsQuery, MonitoredBankAccountsQueryVariables>(MonitoredBankAccountsDocument, options);
        }
export function useMonitoredBankAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MonitoredBankAccountsQuery, MonitoredBankAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MonitoredBankAccountsQuery, MonitoredBankAccountsQueryVariables>(MonitoredBankAccountsDocument, options);
        }
export type MonitoredBankAccountsQueryHookResult = ReturnType<typeof useMonitoredBankAccountsQuery>;
export type MonitoredBankAccountsLazyQueryHookResult = ReturnType<typeof useMonitoredBankAccountsLazyQuery>;
export type MonitoredBankAccountsSuspenseQueryHookResult = ReturnType<typeof useMonitoredBankAccountsSuspenseQuery>;
export type MonitoredBankAccountsQueryResult = Apollo.QueryResult<MonitoredBankAccountsQuery, MonitoredBankAccountsQueryVariables>;
export const MonitoredBankAccountTransactionsDocument = gql`
    query MonitoredBankAccountTransactions($monitoredBankAccountId: ID, $start: ISO8601DateTime, $end: ISO8601DateTime, $updatedAtStart: ISO8601DateTime, $merchant: String, $primaryCategory: String, $sort: BankAccountTransactionSort) {
  monitoredBankAccountTransactions(
    monitoredBankAccountId: $monitoredBankAccountId
    start: $start
    end: $end
    updatedAtStart: $updatedAtStart
    merchant: $merchant
    primaryCategory: $primaryCategory
    sort: $sort
  ) {
    ...MonitoredBankAccountTransactionFragment
  }
}
    ${MonitoredBankAccountTransactionFragmentFragmentDoc}`;

/**
 * __useMonitoredBankAccountTransactionsQuery__
 *
 * To run a query within a React component, call `useMonitoredBankAccountTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonitoredBankAccountTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonitoredBankAccountTransactionsQuery({
 *   variables: {
 *      monitoredBankAccountId: // value for 'monitoredBankAccountId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      updatedAtStart: // value for 'updatedAtStart'
 *      merchant: // value for 'merchant'
 *      primaryCategory: // value for 'primaryCategory'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMonitoredBankAccountTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<MonitoredBankAccountTransactionsQuery, MonitoredBankAccountTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MonitoredBankAccountTransactionsQuery, MonitoredBankAccountTransactionsQueryVariables>(MonitoredBankAccountTransactionsDocument, options);
      }
export function useMonitoredBankAccountTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MonitoredBankAccountTransactionsQuery, MonitoredBankAccountTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MonitoredBankAccountTransactionsQuery, MonitoredBankAccountTransactionsQueryVariables>(MonitoredBankAccountTransactionsDocument, options);
        }
export function useMonitoredBankAccountTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MonitoredBankAccountTransactionsQuery, MonitoredBankAccountTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MonitoredBankAccountTransactionsQuery, MonitoredBankAccountTransactionsQueryVariables>(MonitoredBankAccountTransactionsDocument, options);
        }
export type MonitoredBankAccountTransactionsQueryHookResult = ReturnType<typeof useMonitoredBankAccountTransactionsQuery>;
export type MonitoredBankAccountTransactionsLazyQueryHookResult = ReturnType<typeof useMonitoredBankAccountTransactionsLazyQuery>;
export type MonitoredBankAccountTransactionsSuspenseQueryHookResult = ReturnType<typeof useMonitoredBankAccountTransactionsSuspenseQuery>;
export type MonitoredBankAccountTransactionsQueryResult = Apollo.QueryResult<MonitoredBankAccountTransactionsQuery, MonitoredBankAccountTransactionsQueryVariables>;